/**-----------------------------------------------------------------------------------------
* Copyright © 2025 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import * as i0 from '@angular/core';
import { Injectable, Directive, Input, EventEmitter, inject, isDevMode, HostBinding, ViewChild, forwardRef, Component, Output, Optional, ViewContainerRef, ViewEncapsulation, QueryList, SkipSelf, Host, ContentChildren, ContentChild, HostListener, LOCALE_ID, Inject, NgModule } from '@angular/core';
import { ColumnBase, ColumnComponent, ColumnGroupComponent, SpanColumnComponent, TreeListSpacerComponent, DataBoundTreeComponent, ExpandableTreeComponent, TreeListComponent, CustomMessagesComponent as CustomMessagesComponent$2, FlatBindingDirective, HierarchyBindingDirective, ExpandableDirective, ColumnResizingService } from '@progress/kendo-angular-treelist';
import { cloneDate, addWeeks, firstDayInWeek, addDays, lastDayOfMonth, getDate, firstDayOfMonth, addMonths, lastMonthOfYear, MS_PER_HOUR, MS_PER_DAY, isEqual } from '@progress/kendo-date-math';
import { Subject, Subscription, fromEvent, forkJoin, EMPTY, isObservable, of } from 'rxjs';
import { validatePackage } from '@progress/kendo-licensing';
import { Keys, isDocumentAvailable, closestInScope, matchesClasses, isPresent as isPresent$1, EventsOutsideAngularDirective, DraggableDirective, PreventableEvent, anyChanged, closest, isFocusable, focusableSelector, isVisible, shouldShowValidationUI, hasObservers, WatermarkOverlayComponent, ResizeBatchService } from '@progress/kendo-angular-common';
import { map, distinctUntilChanged, take, switchMap, expand, reduce, filter } from 'rxjs/operators';
import { getter, touchEnabled } from '@progress/kendo-common';
import * as i1 from '@progress/kendo-angular-intl';
import { DatePipe, NumberPipe } from '@progress/kendo-angular-intl';
import { orderBy } from '@progress/kendo-data-query';
import { xIcon, plusIcon, minusIcon, saveIcon, cancelOutlineIcon, trashIcon } from '@progress/kendo-svg-icons';
import { NgClass, NgIf, NgTemplateOutlet, NgFor } from '@angular/common';
import { IconWrapperComponent, IconsService } from '@progress/kendo-angular-icons';
import * as i6 from '@progress/kendo-angular-tooltip';
import { TooltipDirective, KENDO_TOOLTIP } from '@progress/kendo-angular-tooltip';
import * as i1$1 from '@progress/kendo-angular-l10n';
import { ComponentMessages, LocalizationService, L10N_PREFIX } from '@progress/kendo-angular-l10n';
import * as i4 from '@angular/forms';
import { FormArray, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { GridComponent, SelectionDirective, ToolbarTemplateDirective as ToolbarTemplateDirective$1, ColumnComponent as ColumnComponent$1, CellTemplateDirective as CellTemplateDirective$1 } from '@progress/kendo-angular-grid';
import { ButtonComponent, ButtonGroupComponent, DropDownButtonComponent } from '@progress/kendo-angular-buttons';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { FormFieldComponent, TextBoxDirective, NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { LabelComponent } from '@progress/kendo-angular-label';
import { DateTimePickerComponent, CalendarDOMService, CenturyViewService, DecadeViewService, MonthViewService, YearViewService, NavigationService as NavigationService$1, TimePickerDOMService, HoursService, MinutesService, SecondsService, MillisecondsService, DayPeriodService } from '@progress/kendo-angular-dateinputs';
import { DialogComponent, CustomMessagesComponent as CustomMessagesComponent$1, DialogActionsComponent, DialogContainerService, DialogService, WindowService, WindowContainerService } from '@progress/kendo-angular-dialog';
import { TabStripComponent, TabStripTabComponent, TabContentDirective, SplitterComponent, SplitterPaneComponent } from '@progress/kendo-angular-layout';
import * as i3 from '@progress/kendo-angular-popup';
import { PopupService } from '@progress/kendo-angular-popup';
import * as i3$1 from '@progress/kendo-angular-utils';
import { DragTargetContainerDirective } from '@progress/kendo-angular-utils';

/**
 * @hidden
 */
const _c0 = ["task"];
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = a0 => ({
  click: a0
});
const _c3 = (a0, a1) => ({
  $implicit: a0,
  elementWidth: a1
});
function GanttTaskComponent_ng_container_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.mapper.extractFromTask(ctx_r0.dataItem, "title"), " ");
  }
}
function GanttTaskComponent_ng_container_2_ng_template_5_Template(rf, ctx) {}
function GanttTaskComponent_ng_container_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 13)(2, "span", 14);
    i0.ɵɵelementContainerEnd();
  }
}
function GanttTaskComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 6)(3, "div", 7);
    i0.ɵɵtemplate(4, GanttTaskComponent_ng_container_2_ng_container_4_Template, 2, 1, "ng-container", 8)(5, GanttTaskComponent_ng_container_2_ng_template_5_Template, 0, 0, "ng-template", 9, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 10)(8, "span", 11);
    i0.ɵɵelement(9, "kendo-icon-wrapper", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, GanttTaskComponent_ng_container_2_ng_container_10_Template, 3, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const taskContent_r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", (tmp_3_0 = ctx_r0.draggedCompletionWidth) !== null && tmp_3_0 !== undefined ? tmp_3_0 : ctx_r0.completionOverlayWidth, "px");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.taskContentTemplate)("ngIfElse", taskContent_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.taskContentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c1, ctx_r0.dataItem));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(12, _c2, ctx_r0.onTaskDelete))("scope", ctx_r0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.xIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showDragHandles);
  }
}
function GanttTaskComponent_3_ng_template_0_Template(rf, ctx) {}
function GanttTaskComponent_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, GanttTaskComponent_3_ng_template_0_Template, 0, 0, "ng-template", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.taskTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3, ctx_r0.dataItem, ctx_r0.taskWidth));
  }
}
function GanttTaskComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", (tmp_2_0 = ctx_r0.draggedCompletionWidth) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r0.completionOverlayWidth, "px");
  }
}
function GanttTaskComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 16)(2, "div", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
  }
}
function GanttSummaryTaskComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r0.taskWidth, "px");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r0.completionOverlayWidth, "px");
  }
}
function GanttSummaryTaskComponent_ng_template_3_Template(rf, ctx) {}
function GanttSummaryTaskComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 8)(2, "div", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
  }
}
function GanttMilestoneTaskComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 3)(2, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("k-display-block", ctx_r0.touchEnabled);
  }
}
const _c4 = ["timelineRow"];
const _c5 = ["kendoGanttTasksTableBody", ""];
function GanttTasksTableBodyComponent_tr_0_kendo_gantt_milestone_task_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-milestone-task", 6);
    i0.ɵɵlistener("pointerenter", function GanttTasksTableBodyComponent_tr_0_kendo_gantt_milestone_task_3_Template_kendo_gantt_milestone_task_pointerenter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.taskPointerEnter.emit(ctx_r2.mapItemToTask(item_r2)));
    })("pointerleave", function GanttTasksTableBodyComponent_tr_0_kendo_gantt_milestone_task_3_Template_kendo_gantt_milestone_task_pointerleave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.taskPointerLeave.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r2 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataItem", item_r2.data)("level", item_r2.level)("activeView", ctx_r2.activeView)("taskClass", ctx_r2.taskClass)("selectable", ctx_r2.selectable)("isSelected", ctx_r2.isTaskSelected)("index", index_r5)("renderDependencyDragClues", ctx_r2.renderDependencyDragClues);
  }
}
function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_summary_task_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-summary-task", 9);
    i0.ɵɵlistener("pointerenter", function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_summary_task_0_Template_kendo_gantt_summary_task_pointerenter_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const item_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.taskPointerEnter.emit(ctx_r2.mapItemToTask(item_r2)));
    })("pointerleave", function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_summary_task_0_Template_kendo_gantt_summary_task_pointerleave_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.taskPointerLeave.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const item_r2 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataItem", item_r2.data)("level", item_r2.level)("template", ctx_r2.summaryTaskTemplate)("activeView", ctx_r2.activeView)("taskClass", ctx_r2.taskClass)("selectable", ctx_r2.selectable)("isSelected", ctx_r2.isTaskSelected)("isExpanded", ctx_r2.isExpanded)("index", index_r5)("renderDependencyDragClues", ctx_r2.renderDependencyDragClues);
  }
}
function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_task_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-task", 10);
    i0.ɵɵlistener("pointerenter", function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_task_1_Template_kendo_gantt_task_pointerenter_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const item_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.taskPointerEnter.emit(ctx_r2.mapItemToTask(item_r2)));
    })("pointerleave", function GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_task_1_Template_kendo_gantt_task_pointerleave_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.taskPointerLeave.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const item_r2 = ctx_r3.$implicit;
    const index_r5 = ctx_r3.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataItem", item_r2.data)("level", item_r2.level)("taskContentTemplate", ctx_r2.taskContentTemplate)("taskTemplate", ctx_r2.taskTemplate)("activeView", ctx_r2.activeView)("taskClass", ctx_r2.taskClass)("selectable", ctx_r2.selectable)("isSelected", ctx_r2.isTaskSelected)("index", index_r5)("renderDependencyDragClues", ctx_r2.renderDependencyDragClues);
  }
}
function GanttTasksTableBodyComponent_tr_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_summary_task_0_Template, 1, 10, "kendo-gantt-summary-task", 7)(1, GanttTasksTableBodyComponent_tr_0_ng_template_4_kendo_gantt_task_1_Template, 1, 10, "kendo-gantt-task", 8);
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", item_r2.hasChildren);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r2.hasChildren);
  }
}
function GanttTasksTableBodyComponent_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 3, 0)(2, "td", 4);
    i0.ɵɵtemplate(3, GanttTasksTableBodyComponent_tr_0_kendo_gantt_milestone_task_3_Template, 1, 8, "kendo-gantt-milestone-task", 5)(4, GanttTasksTableBodyComponent_tr_0_ng_template_4_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const task_r8 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.isMileStone(item_r2))("ngIfElse", task_r8);
  }
}
const _c6 = ["kendoGanttHeaderTableBody", ""];
function GanttHeaderTableBodyComponent_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵattribute("colspan", item_r1.span);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.text);
  }
}
function GanttHeaderTableBodyComponent_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵattribute("colspan", item_r2.span === 7 ? item_r2.span : 1)("title", item_r2.text);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.text);
  }
}
const _c7 = ["timelineContent"];
const _c8 = ["timelineColumns"];
const _c9 = ["timelineHeaderWrap"];
const _c10 = ["tasksContainer"];
const _c11 = ["dragPopupContainer"];
const _c12 = ["dependencyDragCreatePolyline"];
const _c13 = (a0, a1) => ({
  $implicit: a0,
  task: a1
});
function GanttTimelineComponent_tr_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = ctx.index;
    i0.ɵɵclassMapInterpolate1("k-table-row", i_r2 % 2 ? " k-table-alt-row" : "", "");
  }
}
function GanttTimelineComponent_col_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "col");
  }
}
function GanttTimelineComponent_td_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 29);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("k-nonwork-hour", ctx_r3.isNonWorking(item_r3));
  }
}
function GanttTimelineComponent_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31)(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "kendoNumber");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "ul", 33)(8, "li");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "kendoDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "kendoDate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.task == null ? null : ctx_r3.task.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 6, ctx_r3.task == null ? null : ctx_r3.task.completionRatio, "p"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r3.messageFor("tooltipStartDateText"), ": ", i0.ɵɵpipeBind2(10, 9, ctx_r3.task == null ? null : ctx_r3.task.start, "HH:mm a EEE, MMM d"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r3.messageFor("tooltipEndDateText"), ": ", i0.ɵɵpipeBind2(13, 12, ctx_r3.task == null ? null : ctx_r3.task.end, "HH:mm a EEE, MMM d"), "");
  }
}
function GanttTimelineComponent_ng_template_25_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function GanttTimelineComponent_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, GanttTimelineComponent_ng_template_25_ng_container_0_Template, 1, 0, "ng-container", 34);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.customTooltipTemplate.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c13, ctx_r3.task, ctx_r3.task));
  }
}
function GanttTimelineComponent_ng_template_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "kendoDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "kendoDate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r3.messageFor("tooltipStartDateText"), ": ", i0.ɵɵpipeBind2(3, 4, ctx_r3.dragResult == null ? null : ctx_r3.dragResult.start, "HH:mm a EEE, MMM d"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r3.messageFor("tooltipEndDateText"), ": ", i0.ɵɵpipeBind2(6, 7, ctx_r3.dragResult == null ? null : ctx_r3.dragResult.end, "HH:mm a EEE, MMM d"), "");
  }
}
function GanttTimelineComponent_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "kendoNumber");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r3.dragResult == null ? null : ctx_r3.dragResult.completionRatio, "p"));
  }
}
function GanttTimelineComponent__svg_polyline_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "polyline", 36);
  }
  if (rf & 2) {
    const dependency_r5 = ctx.$implicit;
    i0.ɵɵproperty("dependency", dependency_r5);
  }
}
function GanttTimelineComponent_div_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "div", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const tasksContainer_r6 = i0.ɵɵreference(21);
    i0.ɵɵstyleMapInterpolate3("top: 0px; height: ", tasksContainer_r6.offsetHeight, "px; left: ", ctx_r3.marquee.left, "px; width: ", ctx_r3.marquee.width, "px;");
  }
}
const _c14 = () => ({
  mode: "single"
});
function DependenciesTableComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function DependenciesTableComponent_ng_template_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addHandler());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵlistener("click", function DependenciesTableComponent_ng_template_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeHandler());
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("svgIcon", ctx_r1.plusIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getText("taskEditingDependenciesAddButtonText"), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r1.minusIcon)("disabled", ctx_r1.selectedKeys.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getText("taskEditingDependenciesRemoveButtonText"), " ");
  }
}
function DependenciesTableComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-dropdownlist", 7);
  }
  if (rf & 2) {
    const column_r3 = ctx.column;
    const rowIndex_r4 = ctx.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r1.tasks)("valuePrimitive", true)("formControl", ctx_r1.getFormControl(rowIndex_r4, column_r3.field));
  }
}
function DependenciesTableComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-dropdownlist", 8);
  }
  if (rf & 2) {
    const column_r5 = ctx.column;
    const rowIndex_r6 = ctx.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r1.dependencyTypes)("valuePrimitive", true)("formControl", ctx_r1.getFormControl(rowIndex_r6, column_r5.field));
  }
}
function TaskFieldsComponent_kendo_formfield_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-formfield");
    i0.ɵɵelement(1, "kendo-label", 8)(2, "input", 9, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r1 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", title_r1)("text", ctx_r1.getText("titleFieldInputLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.mapper.taskFields.title);
  }
}
function TaskFieldsComponent_kendo_formfield_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-formfield");
    i0.ɵɵelement(1, "kendo-label", 8)(2, "kendo-datetimepicker", 10, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const start_r3 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", 49, "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", start_r3)("text", ctx_r1.getText("startFieldInputLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.mapper.taskFields.start);
  }
}
function TaskFieldsComponent_kendo_formfield_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-formfield");
    i0.ɵɵelement(1, "kendo-label", 8)(2, "kendo-datetimepicker", 10, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const end_r4 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", 49, "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", end_r4)("text", ctx_r1.getText("endFieldInputLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.mapper.taskFields.end);
  }
}
function TaskFieldsComponent_kendo_formfield_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-formfield");
    i0.ɵɵelement(1, "kendo-label", 8)(2, "kendo-numerictextbox", 11, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const completionRatio_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", 49, "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", completionRatio_r5)("text", ctx_r1.getText("completionRatioFieldInputLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.mapper.taskFields.completionRatio)("min", 0)("max", 1)("decimals", 2)("step", 0.01);
  }
}
function EditDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-gantt-task-fields");
  }
}
function EditDialogComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-dependencies-table", 10);
    i0.ɵɵtwoWayListener("dependenciesChange", function EditDialogComponent_ng_template_6_Template_kendo_gantt_dependencies_table_dependenciesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.predecessors, $event) || (ctx_r1.predecessors = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tasks", ctx_r1.loadedTasks);
    i0.ɵɵtwoWayProperty("dependencies", ctx_r1.predecessors);
  }
}
function EditDialogComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-dependencies-table", 11);
    i0.ɵɵtwoWayListener("dependenciesChange", function EditDialogComponent_ng_template_8_Template_kendo_gantt_dependencies_table_dependenciesChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.successors, $event) || (ctx_r1.successors = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tasks", ctx_r1.loadedTasks);
    i0.ɵɵtwoWayProperty("dependencies", ctx_r1.successors);
  }
}
function ViewSelectorComponent_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const view_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", view_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getViewTypeText(view_r1));
  }
}
function ViewSelectorComponent_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ViewSelectorComponent_button_3_Template_button_click_0_listener() {
      const view_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick(view_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const view_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selected", view_r4 === ctx_r1.activeView);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getViewTypeText(view_r4));
  }
}
function ToolbarComponent_ng_container_0_kendo_gantt_add_task_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-gantt-add-task");
  }
}
function ToolbarComponent_ng_container_0_kendo_gantt_view_selector_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-view-selector", 3);
    i0.ɵɵlistener("activeViewChange", function ToolbarComponent_ng_container_0_kendo_gantt_view_selector_3_Template_kendo_gantt_view_selector_activeViewChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleViewChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("views", ctx_r1.views)("activeView", ctx_r1.activeView);
  }
}
function ToolbarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ToolbarComponent_ng_container_0_kendo_gantt_add_task_1_Template, 1, 0, "kendo-gantt-add-task", 0);
    i0.ɵɵelement(2, "span", 1);
    i0.ɵɵtemplate(3, ToolbarComponent_ng_container_0_kendo_gantt_view_selector_3_Template, 1, 2, "kendo-gantt-view-selector", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAddTask);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showViewSelector);
  }
}
function ToolbarComponent_1_ng_template_0_Template(rf, ctx) {}
function ToolbarComponent_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ToolbarComponent_1_ng_template_0_Template, 0, 0, "ng-template", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toolbarTemplateRef)("ngTemplateOutletContext", ctx_r1.context);
  }
}
const _c15 = a0 => ({
  dblclick: a0
});
const _c16 = (a0, a1, a2, a3) => ({
  click: a0,
  contextmenu: a1,
  dblclick: a2,
  mousedown: a3
});
function GanttComponent_kendo_gantt_toolbar_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-gantt-toolbar", 12);
    i0.ɵɵlistener("activeViewChange", function GanttComponent_kendo_gantt_toolbar_1_Template_kendo_gantt_toolbar_activeViewChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeActiveView($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showAddTask", ctx_r1.toolbarSettings.addTaskTool === "top" || ctx_r1.toolbarSettings.addTaskTool === "both")("showViewSelector", ctx_r1.toolbarSettings.viewSelectorTool === "top" || ctx_r1.toolbarSettings.viewSelectorTool === "both")("toolbarTemplate", ctx_r1.toolbarTemplate)("views", ctx_r1.viewTypes)("activeView", ctx_r1.activeView)("navigable", ctx_r1.navigable);
    i0.ɵɵattribute("aria-label", ctx_r1.toolbarAriaLabel);
  }
}
function GanttComponent_kendo_gantt_timeline_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-gantt-timeline", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("renderDependencyDragClues", ctx_r1.renderDependencyDragClues)("dragScrollSettings", ctx_r1.dragScrollSettings)("rows", ctx_r1.viewItems)("slots", ctx_r1.timelineSlots)("currentTimeMarker", ctx_r1.activeViewCurrentTimeMarker)("groupSlots", ctx_r1.timelineGroupSlots)("tableWidth", ctx_r1.tableWidth)("activeView", ctx_r1.activeView)("taskContentTemplate", ctx_r1.taskContentTemplate == null ? null : ctx_r1.taskContentTemplate.templateRef)("taskTemplate", ctx_r1.taskTemplate == null ? null : ctx_r1.taskTemplate.templateRef)("summaryTaskTemplate", ctx_r1.summaryTaskTemplate == null ? null : ctx_r1.summaryTaskTemplate.templateRef)("taskClass", ctx_r1.taskClass)("dependencies", ctx_r1.dependencies)("isExpanded", ctx_r1.isExpanded)("selectable", ctx_r1.selectable)("isTaskSelected", ctx_r1.isTaskSelected)("kendoEventsOutsideAngular", i0.ɵɵpureFunction4(20, _c16, ctx_r1.handleTimelineClick, ctx_r1.handleTimelineRightClick, ctx_r1.handleTimelineDblClick, ctx_r1.handleTimelineMouseDown))("customTooltipTemplate", ctx_r1.taskTooltipTemplate)("tooltipOptions", ctx_r1.taskTooltipOptions)("scope", ctx_r1);
  }
}
function GanttComponent_kendo_gantt_toolbar_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-gantt-toolbar", 14);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showAddTask", ctx_r1.toolbarSettings.addTaskTool === "bottom" || ctx_r1.toolbarSettings.addTaskTool === "both")("showViewSelector", ctx_r1.toolbarSettings.viewSelectorTool === "bottom" || ctx_r1.toolbarSettings.viewSelectorTool === "both")("toolbarTemplate", ctx_r1.toolbarTemplate)("views", ctx_r1.viewTypes)("activeView", ctx_r1.activeView)("navigable", ctx_r1.navigable);
    i0.ɵɵattribute("aria-label", ctx_r1.toolbarAriaLabel);
  }
}
function GanttComponent_kendo_gantt_edit_dialog_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-gantt-edit-dialog", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r1.data);
  }
}
function GanttComponent_kendo_dialog_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-dialog", 16);
    i0.ɵɵlistener("close", function GanttComponent_kendo_dialog_11_Template_kendo_dialog_close_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleConfirmationDialogClose());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "kendo-dialog-actions", 17);
    i0.ɵɵelement(4, "kendo-treelist-spacer");
    i0.ɵɵelementStart(5, "button", 18);
    i0.ɵɵlistener("click", function GanttComponent_kendo_dialog_11_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleDeleteConfirmation());
    });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 19);
    i0.ɵɵlistener("click", function GanttComponent_kendo_dialog_11_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleConfirmationDialogClose());
    });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("width", 575)("height", 170)("title", ctx_r1.getText("confirmationDialogTitle"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getText("confirmationDialogContent"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("primary", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getText("deleteButtonText"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getText("cancelButtonText"));
  }
}
function GanttComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
const packageMetadata = {
  name: '@progress/kendo-angular-gantt',
  productName: 'Kendo UI for Angular',
  productCode: 'KENDOUIANGULAR',
  productCodes: ['KENDOUIANGULAR'],
  publishDate: 1741163984,
  version: '18.1.1',
  licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/?utm_medium=product&utm_source=kendoangular&utm_campaign=kendo-ui-angular-purchase-license-keys-warning'
};

// TODO: add those keys to `import { Keys } from '@progress/kendo-angular-common';`
var NumpadKeys = /*#__PURE__*/function (NumpadKeys) {
  NumpadKeys[NumpadKeys["Digit1"] = 97] = "Digit1";
  NumpadKeys[NumpadKeys["Digit2"] = 98] = "Digit2";
  NumpadKeys[NumpadKeys["Digit3"] = 99] = "Digit3";
  NumpadKeys[NumpadKeys["Digit4"] = 100] = "Digit4";
  return NumpadKeys;
}(NumpadKeys || {});
/**
 * @hidden
 */
const isArrowUpDownKey = keyCode => [Keys.ArrowUp, Keys.ArrowDown].some(arrowKeyCode => keyCode === arrowKeyCode);
/**
 * @hidden
 */
const isNavigationKey = keyCode => [Keys.ArrowUp, Keys.ArrowDown, Keys.Home, Keys.End].some(navigationKeyCode => keyCode === navigationKeyCode);
/**
 * @hidden
 */
const isExpandCollapseKey = (keyCode, altKey) => {
  return altKey && [Keys.ArrowLeft, Keys.ArrowRight].some(navigationKeyCode => keyCode === navigationKeyCode);
};
/**
 * @hidden
 */
const isViewDigitKey = keyCode => [Keys.Digit1, NumpadKeys.Digit1, Keys.Digit2, NumpadKeys.Digit2, Keys.Digit3, NumpadKeys.Digit3, Keys.Digit4, NumpadKeys.Digit4].some(digitKeyCode => keyCode === digitKeyCode);
/**
 * @hidden
 *
 * Returns the corresponding view index for the pressed digit key (Digit 1 => 0, Digit 2 => 1, etc.).
 */
const getIndexFromViewDigitKeyCode = keyCode => {
  switch (keyCode) {
    case NumpadKeys.Digit1:
    case Keys.Digit1:
      return 0;
    case NumpadKeys.Digit2:
    case Keys.Digit2:
      return 1;
    case NumpadKeys.Digit3:
    case Keys.Digit3:
      return 2;
    case NumpadKeys.Digit4:
    case Keys.Digit4:
      return 3;
    default:
      return null;
  }
};

/**
 * @hidden
 */
let ScrollSyncService = /*#__PURE__*/(() => {
  class ScrollSyncService {
    ngZone;
    changes = new Subject();
    elements = [];
    subscriptions = new Subscription();
    syncingTimeline;
    syncingTreeList;
    constructor(ngZone) {
      this.ngZone = ngZone;
      this.subscriptions.add(this.changes.subscribe(args => {
        this.scroll(args);
      }));
    }
    registerElement(el, sourceType) {
      this.elements.push({
        element: el,
        sourceType
      });
      if (sourceType === "timeline" || sourceType === "treelist") {
        this.ngZone.runOutsideAngular(() => {
          const obs = fromEvent(el, 'scroll').pipe(map(({
            target: {
              scrollTop,
              scrollLeft
            }
          }) => ({
            scrollTop,
            scrollLeft,
            sourceType
          })));
          const comparisonFn = sourceType === 'timeline' ? (x, y) => x.scrollTop === y.scrollTop && x.scrollLeft === y.scrollLeft : (x, y) => x.scrollTop === y.scrollTop;
          this.subscriptions.add(obs.pipe(distinctUntilChanged(comparisonFn)).subscribe(event => this.changes.next(event)));
        });
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
      this.elements = null;
    }
    syncScrollTop(sourceType, targetType) {
      const source = this.elements.find(element => element.sourceType === sourceType);
      const target = this.elements.find(element => element.sourceType === targetType);
      // Need to wait for the splitter pane's content to be rendered
      this.ngZone.onStable.pipe(take(1)).subscribe(() => target.element.scrollTop = source.element.scrollTop);
    }
    resetTimelineScrollLeft() {
      const source = this.elements.find(element => element.sourceType === 'timeline');
      source.element.scrollLeft = 0;
    }
    scroll({
      scrollTop,
      scrollLeft,
      sourceType
    }) {
      this.ngZone.runOutsideAngular(() => {
        if (sourceType === 'timeline') {
          const header = this.elements.find(element => element.sourceType === 'header').element;
          header.scrollLeft = scrollLeft;
          if (!this.syncingTimeline) {
            this.syncingTreeList = true;
            const treelist = this.elements.find(element => element.sourceType === 'treelist').element;
            treelist.scrollTop = scrollTop;
          }
          this.syncingTimeline = false;
        }
        if (sourceType === 'treelist') {
          if (!this.syncingTreeList) {
            this.syncingTimeline = true;
            const timeline = this.elements.find(element => element.sourceType === 'timeline').element;
            timeline.scrollTop = scrollTop;
          }
          this.syncingTreeList = false;
        }
      });
    }
    static ɵfac = function ScrollSyncService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScrollSyncService)(i0.ɵɵinject(i0.NgZone));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScrollSyncService,
      factory: ScrollSyncService.ɵfac
    });
  }
  return ScrollSyncService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
const DEFAULT_DEPENDENCY_MODEL_FIELDS = Object.freeze({
  toId: 'toId',
  fromId: 'fromId',
  id: 'id',
  type: 'type'
});

/**
 * @hidden
 */
const DEFAULT_TASK_MODEL_FIELDS = Object.freeze({
  id: 'id',
  start: 'start',
  end: 'end',
  title: 'title',
  completionRatio: 'completionRatio',
  children: 'children'
});

/**
 * The dependency type when two tasks are connected.
 *
 * The supported values are:
 * * `FF`&mdash;from 'finish' to 'finish'
 * * `FS`&mdash;from 'finish' to 'start'
 * * `SS`&mdash;from 'start' to 'start'
 * * `SF`&mdash;from 'start' to 'finish'
 */
var DependencyType = /*#__PURE__*/function (DependencyType) {
  DependencyType[DependencyType["FF"] = 0] = "FF";
  DependencyType[DependencyType["FS"] = 1] = "FS";
  DependencyType[DependencyType["SF"] = 2] = "SF";
  DependencyType[DependencyType["SS"] = 3] = "SS"; // task B can't start before task A starts
  return DependencyType;
}(DependencyType || {});
/**
 * @hidden
 */
const isWorkDay = (date, start, end) => {
  return date.getDay() >= start && date.getDay() <= end;
};
/**
 * @hidden
 */
const isWorkHour = (date, start, end) => {
  return date.getHours() >= start && date.getHours() <= end;
};
/**
 * @hidden
 */
const isPresent = item => item !== null && item !== undefined;
/**
 * @hidden
 *
 * Normalized the data to an array in case a falsy value is passed
 * or a TreeListDataResult object (applicable for the data-binding directives).
 */
const normalizeGanttData = data => {
  if (!isPresent(data)) {
    return [];
  } else if (Array.isArray(data.data)) {
    return data.data;
  } else {
    return data;
  }
};
/**
 * @hidden
 */
const isArray = value => Array.isArray(value);
/**
 * @hidden
 *
 * Returns a new date with the specified hours, minutes, seconds and millliseconds set.
 * Only the hours are required, the rest of the params are set to `0` by default.
 */
const setTime$1 = (date, hours, minutes = 0, seconds = 0, milliseconds = 0) => {
  if (!isPresent(date)) {
    return null;
  }
  const result = cloneDate(date);
  result.setHours(hours);
  result.setMinutes(minutes);
  result.setSeconds(seconds);
  result.setMilliseconds(milliseconds);
  return result;
};
/**
 * @hidden
 *
 * Returns the last day of a week.
 * @param standingPoint - Any day of the target week.
 * @param firstWeekDay - The week's starting day (e.g. Monday, Tuesday, etc.)
 */
const lastDayOfWeek = (standingPoint, firstWeekDay) => {
  const followingWeek = addWeeks(standingPoint, 1);
  const firstDayOfFollowingWeek = firstDayInWeek(followingWeek, firstWeekDay);
  const lastDayOfTargetWeek = addDays(firstDayOfFollowingWeek, -1);
  return lastDayOfTargetWeek;
};
/**
 * @hidden
 *
 * Returns the total number of days in a month
 */
const getTotalDaysInMonth = date => {
  return lastDayOfMonth(date).getDate();
};
/**
 * @hidden
 *
 * Returns the total number of months between two dates
 * by excluding the months of the dates themselves.
 */
const getTotalMonthsInBetween = (start, end) => {
  const diff = end.getMonth() - start.getMonth() + 12 * (end.getFullYear() - start.getFullYear());
  return diff <= 1 ? 0 : diff - 1;
};
/**
 * Persists the initially resolved scrollbar width value.
 */
let SCROLLBAR_WIDTH;
/**
 * @hidden
 *
 * Gets the default scrollbar width accoring to the current environment.
 */
const scrollbarWidth = () => {
  if (!isDocumentAvailable()) {
    return;
  }
  // calculate scrollbar width only once, then return the cached value
  if (isNaN(SCROLLBAR_WIDTH)) {
    const div = document.createElement('div');
    div.style.cssText = 'overflow: scroll; overflow-x: hidden; zoom: 1; clear: both; display: block;';
    div.innerHTML = '&nbsp;';
    document.body.appendChild(div);
    SCROLLBAR_WIDTH = div.offsetWidth - div.scrollWidth;
    document.body.removeChild(div);
  }
  return SCROLLBAR_WIDTH;
};
/**
 * @hidden
 */
const isColumnGroup = column => column.isColumnGroup;
/**
 * @hidden
 */
const isNumber = contender => typeof contender === 'number' && !isNaN(contender);
/**
 * @hidden
 */
const isString = contender => typeof contender === 'string';
/**
 * @hidden
 *
 * Gets the closest timeline task wrapper element from an event target.
 * Restricts the search up to the provided parent element from the second param.
 */
const getClosestTaskWrapper = (element, parentScope) => {
  return closestInScope(element, matchesClasses('k-task-wrap'), parentScope);
};
/**
 * @hidden
 *
 * Checks whether the queried item or its parent items has a `k-task-wrap` selector.
 * Restricts the search up to the provided parent element from the second param.
 */
const isTaskWrapper = (contender, parentScope) => {
  const taskWrapper = closestInScope(contender, matchesClasses('k-task-wrap'), parentScope);
  return isPresent(taskWrapper);
};
/**
 * @hidden
 *
 * Gets the closest timeline task element from an event target.
 * Restricts the search up to the provided parent element from the second param.
 */
const getClosestTask = (element, parentScope) => {
  return closestInScope(element, matchesClasses('k-task'), parentScope);
};
/**
 * @hidden
 *
 * Gets the closest timeline task element index from an event target.
 * Uses the `data-task-index` attribute assigned to each task.
 * Restricts the search up to the provided parent element from the second param.
 */
const getClosestTaskIndex = (element, parentScope) => {
  const task = closestInScope(element, matchesClasses('k-task-wrap'), parentScope);
  if (!isPresent(task)) {
    return null;
  }
  return Number(task.getAttribute('data-task-index'));
};
/**
 * @hidden
 *
 * Checks whether the queried item or its parent items has a `k-task` selector.
 * Restricts the search up to the provided parent element from the second param.
 */
const isTask = (contender, parentScope) => {
  const task = closestInScope(contender, matchesClasses('k-task'), parentScope);
  return isPresent(task);
};
/**
 * @hidden
 *
 * Checks whether the queried item or its parent items has a `k-toolbar` selector.
 * Restricts the search up to the provided parent element from the second param.
 */
const isToolbar = (contender, parentScope) => {
  const toolbar = closestInScope(contender, matchesClasses('k-gantt-toolbar'), parentScope);
  return isPresent(toolbar);
};
/**
 * @hidden
 *
 * Checks whether the queried item or its parent items has a `k-task-actions` selector - used for the clear button.
 * Restricts the search up to the provided parent element from the second param.
 */
const isClearButton = (contender, parentScope) => {
  const clearButtonContainer = closestInScope(contender, matchesClasses('k-task-actions'), parentScope);
  return isPresent(clearButtonContainer);
};
/**
 * @hidden
 *
 * Checks whether the queried item has a `k-task-dot` selector - used for the dependency drag clues.
 */
const isDependencyDragClue = element => {
  if (!isPresent(element)) {
    return false;
  }
  return element.classList.contains('k-task-dot');
};
/**
 * @hidden
 *
 * Checks whether the queried item has a `k-task-dot` & `k-task-start` selector - used for the dependency drag start clues.
 */
const isDependencyDragStartClue = element => {
  if (!isPresent(element)) {
    return false;
  }
  return element.classList.contains('k-task-dot') && element.classList.contains('k-task-start');
};
/**
 * @hidden
 *
 * Gets the `DependencyType` for an attempted dependency create from the provided two elements.
 * The two linked drag clue HTML elements are used to extract this data (via their CSS classes).
 */
const getDependencyTypeFromTargetTasks = (fromTaskClue, toTaskClue) => {
  if (!isDependencyDragClue(fromTaskClue) || !isDependencyDragClue(toTaskClue)) {
    return null;
  }
  const fromTaskType = isDependencyDragStartClue(fromTaskClue) ? 'S' : 'F';
  const toTaskType = isDependencyDragStartClue(toTaskClue) ? 'S' : 'F';
  const dependencyTypeName = `${fromTaskType}${toTaskType}`;
  switch (dependencyTypeName) {
    case 'FF':
      return DependencyType.FF;
    case 'FS':
      return DependencyType.FS;
    case 'SF':
      return DependencyType.SF;
    case 'SS':
      return DependencyType.SS;
    default:
      return null;
  }
};
/**
 * @hidden
 *
 * Checks whether the two provided drag clues belong to the same task element.
 */
const sameTaskClues = (fromTaskClue, toTaskClue, parentScope) => {
  if (!isPresent(fromTaskClue) || !isPresent(toTaskClue)) {
    return false;
  }
  const fromTaskWrapper = getClosestTaskWrapper(fromTaskClue, parentScope);
  const toTaskWrapper = getClosestTaskWrapper(toTaskClue, parentScope);
  return fromTaskWrapper === toTaskWrapper;
};
/**
 * @hidden
 *
 * Fits a contender number between a min and max range.
 * If the contender is below the min value, the min value is returned.
 * If the contender is above the max value, the max value is returned.
 */
const fitToRange = (contender, min, max) => {
  if (!isPresent(contender) || contender < min) {
    return min;
  } else if (contender > max) {
    return max;
  } else {
    return contender;
  }
};
/**
 * @hidden
 *
 * Checks whether either of the two provided tasks is a parent of the other.
 */
const areParentChild = (taskA, taskB) => {
  let parentChildRelationship = false;
  let taskAParent = taskA;
  while (isPresent(taskAParent) && isPresent(taskAParent.data)) {
    if (taskAParent.data === taskB.data) {
      parentChildRelationship = true;
      break;
    }
    taskAParent = taskAParent.parent;
  }
  let taskBParent = taskB;
  while (!parentChildRelationship && isPresent(taskBParent) && isPresent(taskBParent.data)) {
    if (taskBParent.data === taskA.data) {
      parentChildRelationship = true;
      break;
    }
    taskBParent = taskBParent.parent;
  }
  return parentChildRelationship;
};
/**
 * @hidden
 *
 * Extracts an element from the provided client coords.
 * Using the `event.target` is not reliable under mobile devices with the current implementation of the draggable, so use this instead.
 */
const elementFromPoint = (clientX, clientY) => {
  if (!isDocumentAvailable()) {
    return null;
  }
  return document.elementFromPoint(clientX, clientY);
};

/**
 * @hidden
 */
let MappingService = /*#__PURE__*/(() => {
  class MappingService {
    /**
     * Gets or sets the model fields for the task data items.
     * Uses the default values for fields which are not specified.
     */
    set taskFields(fields) {
      this._taskFields = {
        ...DEFAULT_TASK_MODEL_FIELDS,
        ...fields
      };
    }
    get taskFields() {
      return this._taskFields;
    }
    /**
     * Gets or sets the model fields for the depenency data items.
     * Uses the default values for fields which are not specified.
     */
    set dependencyFields(fields) {
      this._dependencyFields = {
        ...DEFAULT_DEPENDENCY_MODEL_FIELDS,
        ...fields
      };
    }
    get dependencyFields() {
      return this._dependencyFields;
    }
    _taskFields = {
      ...DEFAULT_TASK_MODEL_FIELDS
    };
    _dependencyFields = {
      ...DEFAULT_DEPENDENCY_MODEL_FIELDS
    };
    /**
     * Retrieves the value for the specified task field.
     * Supports nested fields as well (e.g. 'manager.id').
     */
    extractFromTask(dataItem, field) {
      if (!isPresent(this.taskFields)) {
        return null;
      }
      return getter(this.taskFields[field])(dataItem);
    }
    /**
     * Retrieves the value for the specified dependency field.
     * Supports nested fields as well (e.g. 'manager.id').
     */
    extractFromDependency(dataItem, field) {
      if (!isPresent(this.dependencyFields)) {
        return null;
      }
      return getter(this.dependencyFields[field])(dataItem);
    }
    static ɵfac = function MappingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MappingService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MappingService,
      factory: MappingService.ɵfac
    });
  }
  return MappingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let DependencyDomService = /*#__PURE__*/(() => {
  class DependencyDomService {
    mapper;
    /**
     * Emits each time some of the tasks or the view have changed.
     * Fires also on the first change of the table rows and the parent container.
     */
    get taskChanges() {
      return this.notifier.asObservable();
    }
    get dependencyDomArgs() {
      return {
        tasks: this.tasks,
        contentContainer: this.contentContainer,
        timelineRow: this.timelineRow
      };
    }
    notifier = new Subject();
    /**
     * The row element in the Timeline part of the Gantt.
     */
    timelineRow;
    /**
     * Used to get retrieve the offset of the task elements relative to the parent container.
     */
    contentContainer;
    /**
     * Maps each rendered task to its HTML element.
     * Uses the task ID field value as key.
     */
    tasks = new Map();
    constructor(mapper) {
      this.mapper = mapper;
    }
    ngOnDestroy() {
      this.tasks.clear();
      this.tasks = null;
      this.contentContainer = null;
    }
    registerTimelineRow(timelineRow) {
      this.timelineRow = timelineRow;
      this.notifyChanges();
    }
    registerContentContainer(contentContainer) {
      this.contentContainer = contentContainer;
      this.notifyChanges();
    }
    registerTask(task, element) {
      const id = this.mapper.extractFromTask(task, 'id');
      this.tasks.set(id, element);
      this.notifyChanges();
    }
    unregisterTask(task) {
      const id = this.mapper.extractFromTask(task, 'id');
      this.tasks.delete(id);
      this.notifyChanges();
    }
    /**
     * Notifies all dependency directives that a change in one of the elements has occured.
     */
    notifyChanges() {
      this.notifier.next(this.dependencyDomArgs);
    }
    static ɵfac = function DependencyDomService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DependencyDomService)(i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DependencyDomService,
      factory: DependencyDomService.ɵfac
    });
  }
  return DependencyDomService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
/**
 * @hidden
 */
let CurrentTimeMarkerService = /*#__PURE__*/(() => {
  class CurrentTimeMarkerService {
    renderer;
    cdr;
    container;
    slots = [];
    rows = [];
    currentTimeMarker;
    rowHeight;
    rtl;
    activeView;
    get deltaOffset() {
      if (this.slotIndex >= 0) {
        const total = this.slots[this.slotIndex].end.getTime() - this.slots[this.slotIndex].start.getTime();
        if (total > 0) {
          const currentTimeValue = this.now.getTime() - this.slots[this.slotIndex].start.getTime();
          const fractionInsideCell = currentTimeValue / total;
          const deltaOffsetToSlot = this.slotIndex * this.slotWidth;
          const deltaOffsetInsideSlot = fractionInsideCell * this.slotWidth;
          return deltaOffsetToSlot + deltaOffsetInsideSlot;
        }
        return 0;
      }
    }
    get slotWidth() {
      return this.slots[0]?.slotWidth;
    }
    get slotIndex() {
      return this.slots.indexOf(this.slots.find(slot => slot.start <= this.now && slot.end > this.now));
    }
    get height() {
      return this.rows.length * this.rowHeight;
    }
    get interval() {
      if (typeof this.currentTimeMarker === 'boolean') {
        return MS_PER_MINUTE;
      }
      return this.currentTimeMarker?.updateInterval || MS_PER_MINUTE;
    }
    now = new Date(Date.now());
    currentTimeTimeout;
    timeMarkerDiv;
    constructor(renderer, cdr) {
      this.renderer = renderer;
      this.cdr = cdr;
    }
    ngOnDestroy() {
      clearTimeout(this.currentTimeTimeout);
    }
    removeTimeMarker() {
      if (this.timeMarkerDiv) {
        this.renderer.removeChild(this.container.nativeElement, this.timeMarkerDiv);
        clearTimeout(this.currentTimeTimeout);
        this.cdr.detectChanges();
      }
    }
    createTimeMarker = () => {
      if (!isDocumentAvailable()) {
        return;
      }
      this.removeTimeMarker();
      if (this.slotIndex >= 0) {
        this.now = new Date(Date.now());
        this.timeMarkerDiv = this.renderer.createElement('div');
        this.renderer.addClass(this.timeMarkerDiv, 'k-current-time');
        this.renderer.setStyle(this.timeMarkerDiv, 'width', '1px');
        this.renderer.setStyle(this.timeMarkerDiv, 'top', '0px');
        this.renderer.setStyle(this.timeMarkerDiv, `${this.rtl ? 'right' : 'left'}`, this.deltaOffset + 'px');
        this.renderer.appendChild(this.container.nativeElement, this.timeMarkerDiv);
        this.renderer.setStyle(this.timeMarkerDiv, 'height', this.height + 'px');
        this.currentTimeTimeout = setTimeout(this.createTimeMarker, this.interval || MS_PER_MINUTE);
      }
    };
    static ɵfac = function CurrentTimeMarkerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CurrentTimeMarkerService)(i0.ɵɵinject(i0.Renderer2), i0.ɵɵinject(i0.ChangeDetectorRef));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CurrentTimeMarkerService,
      factory: CurrentTimeMarkerService.ɵfac
    });
  }
  return CurrentTimeMarkerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 *
 * Gets the offset (top and left values) relative to a target element.
 */
const getOffsetRelativeToParent = (element, targetParent) => {
  const offset = {
    top: 0,
    left: 0
  };
  if (!targetParent.contains(element)) {
    return offset;
  }
  let offsetParent = element;
  while (offsetParent && offsetParent !== targetParent) {
    offset.top += offsetParent.offsetTop;
    offset.left += offsetParent.offsetLeft;
    offsetParent = offsetParent.offsetParent;
  }
  return offset;
};
/**
 * @hidden
 */
const getElementRect = (element, relativeContainer) => {
  const {
    top,
    left
  } = getOffsetRelativeToParent(element, relativeContainer);
  return {
    top: top + element.offsetHeight / 2,
    left: left,
    right: left + element.offsetWidth
  };
};
/**
 * @hidden
 */
const dependencyCoordinates = (from, to, rowHeight, type, minDistanceBeforeTurn, arrowSize) => {
  const points = [];
  const minTurnHeight = Math.floor(rowHeight / 2);
  const drawingDown = from.top < to.top;
  let top, left;
  // FF and SS are composed of 4 connected polyline points (not counting the arrow)
  /*
      [[[]]]-       -[[[]]]
            |       |
      [[[]]]-       -[[[]]]
   */
  if (type === DependencyType.FF || type === DependencyType.SS) {
    // polyline start from first task
    const dir = type === DependencyType.SS ? 'left' : 'right';
    top = from.top;
    left = from[dir];
    points.push({
      top,
      left
    });
    // first turn point
    left = Math[dir === 'left' ? 'min' : 'max'](from[dir], to[dir]);
    left = dir === 'left' ? left - minDistanceBeforeTurn : left + minDistanceBeforeTurn;
    points.push({
      top,
      left
    });
    // second turn point
    top = to.top;
    points.push({
      top,
      left
    });
    // second task reached
    left = dir === 'left' ? to[dir] - arrowSize : to[dir] + arrowSize;
    points.push({
      top,
      left
    });
    // arrow pointing to the second task
    points.push(...getArrow(top, left, dir !== 'left', arrowSize));
  } else {
    // FS and SF are composed of 4 or 6 connected polyline points (not counting the arrow), depending on the position of the tasks
    /*
        [[[]]]-               [[[]]]-
              |                     |
              -[[[]]]           -----
                                |
                                -[[[]]]
    */
    const startDir = type === DependencyType.SF ? 'left' : 'right';
    const endDir = type === DependencyType.SF ? 'right' : 'left';
    const additionalTurn = type === DependencyType.SF ? from[startDir] - minDistanceBeforeTurn * 2 < to[endDir] : from[startDir] + minDistanceBeforeTurn * 2 > to[endDir];
    // polyline start from first task
    top = from.top;
    left = from[startDir];
    points.push({
      top,
      left
    });
    // first turn point
    left = startDir === 'left' ? left - minDistanceBeforeTurn : left + minDistanceBeforeTurn;
    points.push({
      top,
      left
    });
    // if second task start is before the first task end in FS
    // if second task end is after the first task start in SF
    if (additionalTurn) {
      // additional turn start
      top = drawingDown ? top + minTurnHeight : top - minTurnHeight;
      points.push({
        top,
        left
      });
      // additional turn end
      left = startDir === 'left' ? to[endDir] + minDistanceBeforeTurn : to[endDir] - minDistanceBeforeTurn;
      points.push({
        top,
        left
      });
    }
    // second task level reached
    top = to.top;
    points.push({
      top,
      left
    });
    // second task element reached
    left = endDir === 'left' ? to[endDir] - arrowSize : to[endDir] + arrowSize;
    points.push({
      top,
      left
    });
    // arrow pointing to the second task
    points.push(...getArrow(top, left, endDir !== 'left', arrowSize));
  }
  return points;
};
const getArrow = (top, left, isArrowWest, arrowSize) => {
  const points = isArrowWest ? getArrowWest(top, left, arrowSize) : getArrowEast(top, left, arrowSize);
  return points;
};
const getArrowWest = (top, left, arrowSize) => {
  const points = [];
  points.push({
    top: top - arrowSize / 2,
    left
  });
  points.push({
    top,
    left: left - arrowSize + 1
  });
  points.push({
    top: top + arrowSize / 2,
    left
  });
  points.push({
    top,
    left
  });
  return points;
};
const getArrowEast = (top, left, arrowSize) => {
  const points = [];
  points.push({
    top: top + arrowSize / 2,
    left
  });
  points.push({
    top,
    left: left + arrowSize - 1
  });
  points.push({
    top: top - arrowSize / 2,
    left
  });
  points.push({
    top,
    left
  });
  return points;
};
/**
 * @hidden
 *
 * Translates the provided client `left` and `top` coords to coords relative to the provided container.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSSOM_View/Coordinate_systems#standard_cssom_coordinate_systems
 */
const clientToOffsetCoords = (clientLeft, clientTop, offsetContainer) => {
  // client (viewport) coordinates of the target container
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect#value
  const offsetContainerClientRect = offsetContainer.getBoundingClientRect();
  return {
    left: clientLeft - offsetContainerClientRect.left + offsetContainer.scrollLeft,
    top: clientTop - offsetContainerClientRect.top + offsetContainer.scrollTop
  };
};
/**
 * @hidden
 *
 * Retrieves the `left` and `top` values of the center of the provided element.
 * The retrieved values are relative to the current viewport (client values).
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSSOM_View/Coordinate_systems#standard_cssom_coordinate_systems
 */
const getElementClientCenterCoords = element => {
  // client (viewport) coordinates of the targeted element
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect#value
  const {
    left,
    top,
    width,
    height
  } = element.getBoundingClientRect();
  return {
    left: left + width / 2,
    top: top + height / 2
  };
};

/**
 * Defines the size of the arrow that will be drawn at the end of each Gantt dependency.
 */
const ARROW_SIZE = 4;
/**
 * Defines the distance the polyline will cover from the task element before making a turn.
 */
const MIN_DISTANCE_BEFORE_TURN = 10;
/**
 * @hidden
 */
let GanttDependencyDirective = /*#__PURE__*/(() => {
  class GanttDependencyDirective {
    polyline;
    zone;
    renderer;
    mapper;
    dependencyDomService;
    dependency;
    subscriptions = new Subscription();
    constructor(polyline, zone, renderer, mapper, dependencyDomService) {
      this.polyline = polyline;
      this.zone = zone;
      this.renderer = renderer;
      this.mapper = mapper;
      this.dependencyDomService = dependencyDomService;
      this.subscriptions.add(dependencyDomService.taskChanges.pipe(switchMap(changes =>
      // reacts only on the very last event emission,
      // ensures that the tasks are drawn in the DOM
      this.zone.onStable.pipe(take(1), map(() => changes)))).subscribe(changes => this.updatePoints(changes)));
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    ngOnChanges(changes) {
      if (isPresent(changes['dependency'])) {
        this.updatePoints(this.dependencyDomService.dependencyDomArgs);
      }
    }
    updatePoints({
      timelineRow,
      contentContainer,
      tasks
    }) {
      if (!isPresent(timelineRow) || !isPresent(contentContainer) || !isPresent(tasks) || tasks.size === 0 || !tasks.has(this.mapper.extractFromDependency(this.dependency, 'fromId')) || !tasks.has(this.mapper.extractFromDependency(this.dependency, 'toId'))) {
        this.clearPoints();
        return;
      }
      const fromCoordinates = getElementRect(tasks.get(this.mapper.extractFromDependency(this.dependency, 'fromId')), contentContainer);
      const toCoordinates = getElementRect(tasks.get(this.mapper.extractFromDependency(this.dependency, 'toId')), contentContainer);
      const timelineRowHeight = isDocumentAvailable() ? timelineRow.getBoundingClientRect().height : 0;
      const points = dependencyCoordinates(fromCoordinates, toCoordinates, timelineRowHeight, this.dependency.type, MIN_DISTANCE_BEFORE_TURN, ARROW_SIZE);
      this.drawPoints(points);
    }
    clearPoints() {
      this.renderer.setAttribute(this.polyline.nativeElement, 'points', '');
    }
    drawPoints(points) {
      if (!isPresent(points) || points.length === 0) {
        this.clearPoints();
        return;
      }
      const parsedCoords = points.map(({
        left,
        top
      }) => `${left},${top}`).join(' ');
      this.renderer.setAttribute(this.polyline.nativeElement, 'points', parsedCoords);
    }
    static ɵfac = function GanttDependencyDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttDependencyDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttDependencyDirective,
      selectors: [["", "kendoGanttDependency", ""]],
      inputs: {
        dependency: "dependency"
      },
      standalone: true,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return GanttDependencyDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let NavigationService = /*#__PURE__*/(() => {
  class NavigationService {
    zone;
    renderer;
    scrollSyncService;
    /**
     * Notifies when the tasks' focused and interactive (tabindex) state has changed.
     *
     * All tasks are rendered with tabindex="-1".
     * When one is clicked, or when some navigation key keyboard key is pressed, it should be focused, assigned the focus class, and its tabindex updated to 0.
     * All other tasks should get -1 tabindex and have the focus class removed from them.
     */
    taskStatusChanges = new Subject();
    /**
     * Specifies whether navigation is enabled.
     */
    get enabled() {
      return this._enabled;
    }
    /**
     * Used to retrieve read-only data about the currently active task.
     */
    get activeTask() {
      return {
        activeIndex: this.activeTimelineIndex,
        isFocused: this.isTimelineFocused
      };
    }
    /**
     * Persists the expected Timeline focused task index.
     * When the cells in the TreeList are navigated through, the expected Timeline focus target should also change,
     * in order to allow tabbing from the TreeList to the same row in the Timeline.
     */
    set activeTimelineIndex(index) {
      this._activeTimelineIndex = index;
    }
    get activeTimelineIndex() {
      const firstAvailableIndex = 0;
      const lastAvailableIndex = this.metadata.treeList.view.data.length - 1;
      return fitToRange(this._activeTimelineIndex, firstAvailableIndex, lastAvailableIndex);
    }
    /**
     * Persists the expected TreeList focused cell coords.
     * When the tasks in the Timeline are navigated through, the expected TreeList focus target should also change,
     * in order to allow back-tabbing from the Timeline to the same row in the TreeList.
     */
    set activeTreeListCell(cell) {
      this._activeTreeListCell = cell;
    }
    get activeTreeListCell() {
      const firstAvailableIndex = 0;
      const lastAvailableRowIndex = this.treeListHeaderRowsCount + this.metadata.treeList.view.data.length - 1;
      const rowIndex = fitToRange(this._activeTreeListCell.rowIndex, firstAvailableIndex, lastAvailableRowIndex);
      const lastAvailableColIndex = this.metadata.columns.length;
      const colIndex = fitToRange(this._activeTreeListCell.colIndex, firstAvailableIndex, lastAvailableColIndex);
      return {
        rowIndex,
        colIndex
      };
    }
    /**
     * Keeps track of whether the Timeline part is focused.
     * Used when the index of the task elements change (tasks are changed, pushed to, spliced from, etc.)
     * and their status should be updated accordingly.
     */
    isTimelineFocused = false;
    /**
     * The TreeList row index takes into account the header and filter rows.
     * Used when translating Timeline task indices to TreeList row indices.
     */
    get treeListHeaderRowsCount() {
      // captures nested group header rows + filter row if we start supporting it at some point
      return this.metadata.treeListElement.querySelectorAll('.k-grid-header tr').length;
    }
    /**
     * Keeps track of which part has last been focused.
     * Used when calling `gantt.focus()` to determine which part of the component should receive focus.
     */
    treeListLastActive = false;
    /**
     * Keeps track of which part has last been focused.
     * Used when calling `gantt.focus()` to determine which part of the component should receive focus.
     */
    timelineLastActive = false;
    metadata;
    _enabled = false;
    _activeTimelineIndex = 0;
    _activeTreeListCell = {
      rowIndex: 0,
      colIndex: 0
    };
    eventListenerDisposers;
    constructor(zone, renderer, scrollSyncService) {
      this.zone = zone;
      this.renderer = renderer;
      this.scrollSyncService = scrollSyncService;
    }
    initialize(metadata) {
      // no private property setters in TypeScript, so use a getter and a poorly named private prop for this value
      this._enabled = true;
      this.metadata = metadata;
      // TODO: fix in the splitter package and remove
      // move the splitbar HTML element between the two panes to keep the visial tabbing order in tact
      const splitbar = this.metadata.host.querySelector('.k-splitbar');
      if (isPresent(splitbar) && isPresent(splitbar.previousElementSibling) && isPresent(splitbar.after)) {
        splitbar.after(splitbar.previousElementSibling);
      }
      this.zone.runOutsideAngular(() => {
        this.eventListenerDisposers = [this.renderer.listen(this.metadata.treeListElement, 'mousedown', this.focusTreeList.bind(this)), this.renderer.listen(this.metadata.treeListElement, 'focusin', this.handleTreeListFocusIn.bind(this)), this.renderer.listen(this.metadata.timelineElement, 'mousedown', this.handleTimelineMousedown.bind(this)), this.renderer.listen(this.metadata.timelineElement, 'focusin', this.handleTimelineFocusIn.bind(this)), this.renderer.listen(this.metadata.timelineElement, 'focusout', this.handleTimelineFocusOut.bind(this))];
      });
    }
    ngOnDestroy() {
      if (isPresent(this.eventListenerDisposers)) {
        this.eventListenerDisposers.forEach(removeListener => removeListener());
        this.eventListenerDisposers = null;
      }
      this.metadata = null;
    }
    /**
     * Focuses either the last active TreeList cell, or the last active Timeline task,
     * dependening on which of the two last held focus.
     *
     * Focuses the first TreeList cell by default.
     */
    focusLastActiveItem() {
      if (this.metadata.data.length === 0 || !this.treeListLastActive && !this.timelineLastActive) {
        this.focusCell(0, 0);
      } else if (this.treeListLastActive) {
        const {
          rowIndex,
          colIndex
        } = this.activeTreeListCell;
        this.metadata.treeList.focusCell(rowIndex, colIndex);
      } else if (this.timelineLastActive) {
        this.focusTask(this.activeTimelineIndex);
      }
    }
    /**
     * Focuses the targeted TreeList cell regardless of the last peresisted target.
     */
    focusCell(rowIndex, colIndex) {
      this.activeTreeListCell = {
        rowIndex,
        colIndex
      };
      this.activeTimelineIndex = rowIndex - this.treeListHeaderRowsCount;
      this.metadata.treeList.focusCell(this.activeTreeListCell.rowIndex, this.activeTreeListCell.colIndex);
    }
    /**
     * Focuses the targeted Timeline task regardless of the last peresisted target.
     */
    focusTask(index) {
      this.activeTimelineIndex = index;
      this.isTimelineFocused = true;
      this.activeTreeListCell = {
        rowIndex: index + this.treeListHeaderRowsCount,
        colIndex: this.activeTreeListCell.colIndex
      };
      this.notifyTaskStatusChange();
    }
    /**
     * Updates the focus target flags and notifies the active task to update its focused state.
     */
    handleTimelineFocusIn({
      target
    }) {
      this.treeListLastActive = false;
      this.timelineLastActive = true;
      this.isTimelineFocused = true;
      if (isTask(target, this.metadata.timelineElement)) {
        this.notifyTaskStatusChange();
      }
    }
    /**
     * Updates the timeline focus state flag and notifies the active task to update its focused state.
     */
    handleTimelineFocusOut({
      relatedTarget
    }) {
      this.isTimelineFocused = this.metadata.timelineElement.contains(relatedTarget);
      // update the task element only if the new focus target is not in the Timeline - focus change between tasks is handled in the focusin handler
      if (!isTask(relatedTarget, this.metadata.timelineElement)) {
        this.notifyTaskStatusChange();
      }
    }
    /**
     * Updates the focus target flags and corrects the TreeList focus target if needed.
     * As the TreeList will keep its last focused cell with tabindex="0",
     * this methods forcefully focuses the correct cell,
     * when navigating in the Timeline has updated the expected TreeList focus target.
     */
    handleTreeListFocusIn(event) {
      this.treeListLastActive = true;
      this.timelineLastActive = false;
      // if the previous focus target was in the TreeList, rely on its component navigation and just record the focused item index
      if (this.metadata.treeListElement.contains(event.relatedTarget)) {
        const {
          colIndex,
          rowIndex
        } = this.metadata.treeList.activeCell;
        this.activeTreeListCell = {
          colIndex,
          rowIndex
        };
      } else {
        // if the previous focus target was outside the TreeList, ensure the expected focus coords are used
        const {
          rowIndex,
          colIndex
        } = this.activeTreeListCell;
        this.metadata.treeList.focusCell(rowIndex, colIndex); // activates the target cell even if it has tabindex="-1"
      }
      this.activeTimelineIndex = this.metadata.treeList.activeCell.dataRowIndex;
      this.notifyTaskStatusChange();
      if (this.metadata.treeList.activeCell.dataRowIndex >= 0) {
        this.scrollHorizontallyToTask();
        this.scrollSyncService.syncScrollTop('treelist', 'timeline');
      }
    }
    updateActiveTimeLineIndex(index) {
      this.activeTimelineIndex = index;
    }
    updateActiveTreeListCell() {
      this.activeTreeListCell = {
        rowIndex: this.activeTimelineIndex + this.treeListHeaderRowsCount,
        colIndex: this.activeTreeListCell.colIndex
      };
    }
    /**
     * Fires the `taskStatusChanges` event with active and focused status retrieved from
     * `this.activeTimelineIndex` and `this.isTimelineFocused`.
     */
    notifyTaskStatusChange() {
      this.taskStatusChanges.next(this.activeTask);
    }
    /**
     * Scrolls horizontally to the beginning of the target task if the beginning of its content is not in the viewport.
     */
    scrollHorizontallyToTask() {
      const index = this.activeTimelineIndex;
      const task = this.metadata.timelineElement.querySelectorAll('.k-task-wrap').item(index);
      if (!isPresent(task)) {
        return;
      }
      // scroll horizontally to the item if less than 200px from the beginning of its content are visible
      const targetVisibleWidth = 200;
      const isScrollBeforeTask = this.metadata.timelineElement.clientWidth + this.metadata.timelineElement.scrollLeft < task.offsetLeft + targetVisibleWidth;
      const isScrollAfterTask = this.metadata.timelineElement.scrollLeft > task.offsetLeft;
      if (isScrollBeforeTask || isScrollAfterTask) {
        this.metadata.timelineElement.scrollLeft = task.offsetLeft;
      }
    }
    /**
     * Filters for task mousedown in the Timeline.
     */
    handleTimelineMousedown({
      target
    }) {
      if (isTask(target, this.metadata.host) && !isClearButton(target, this.metadata.host)) {
        const taskIndex = getClosestTaskIndex(target, this.metadata.host);
        this.focusTask(taskIndex);
      }
    }
    /**
     * Focus the TreeList on TreeList mousedown.
     * A nasty hack to trick `handleTreeListFocusIn` into regarding the previous focus target as again the TreeList.
     * Otherwise cell clicks are wrongly overwritten in `handleTreeListFocusIn` and the click focus target is not respected.
     */
    focusTreeList() {
      this.metadata.treeList.focus();
    }
    static ɵfac = function NavigationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationService)(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i0.Renderer2), i0.ɵɵinject(ScrollSyncService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NavigationService,
      factory: NavigationService.ɵfac
    });
  }
  return NavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let EditService = /*#__PURE__*/(() => {
  class EditService {
    mapper;
    showEditingDialog = new Subject();
    taskDelete = new Subject();
    editEvent = new Subject();
    addEvent = new Subject();
    taskFormGroup;
    dataItem;
    getSelectedItem;
    hasChildren;
    fetchChildren;
    set dependencies(items) {
      // Can this whole thing be moved to edit-dialog? Dependencies might not be needed here
      const dataItemId = this.mapper.extractFromTask(this.dataItem, 'id');
      this.predecessors = items.filter(item => this.mapper.extractFromDependency(item, 'toId') === dataItemId);
      this.successors = items.filter(item => this.mapper.extractFromDependency(item, 'fromId') === dataItemId);
    }
    get dependencies() {
      return [...this.predecessors, ...this.successors];
    }
    predecessors = [];
    successors = [];
    updatedItems = [];
    deletedItems = [];
    constructor(mapper) {
      this.mapper = mapper;
    }
    createEditDialog(dataItem, taskFormGroup, dependencies) {
      this.dataItem = dataItem;
      this.taskFormGroup = taskFormGroup;
      this.dependencies = dependencies;
      this.showEditingDialog.next(true);
    }
    closeEditDialog() {
      this.showEditingDialog.next(false);
      this.dataItem = undefined;
      this.taskFormGroup = undefined;
      this.dependencies = [];
      this.updatedItems = [];
      this.deletedItems = [];
    }
    triggerEditEvent(editResultType) {
      this.editEvent.next({
        taskFormGroup: this.taskFormGroup,
        dataItem: this.dataItem,
        dependencies: {
          createdItems: this.getCreatedDependencies(),
          updatedItems: this.updatedItems,
          deletedItems: this.deletedItems
        },
        editResultType
      });
    }
    updateDependencies(item) {
      if (!this.isNew(item)) {
        // update
        const index = this.itemIndex(item, this.updatedItems);
        if (index !== -1) {
          this.updatedItems.splice(index, 1, item);
        } else {
          this.updatedItems.push(item);
        }
      }
    }
    getCreatedDependencies() {
      return this.dependencies.filter(item => this.mapper.extractFromDependency(item, 'id') === null);
    }
    deleteDependency(item) {
      const updatedIndex = this.itemIndex(item, this.updatedItems);
      if (updatedIndex !== -1) {
        this.updatedItems.splice(updatedIndex, 1);
      }
      if (!this.isNew(item)) {
        this.deletedItems.push(item);
      }
    }
    loadTasks(initialValues, isInitializer = true) {
      return forkJoin(initialValues.map(v => this.getElementById(v))).pipe(map(value => value.reduce((acc, item) => acc = acc.concat(normalizeGanttData(item)), [])), expand(values => {
        if (values.some(el => this.hasChildren(el))) {
          return this.loadTasks(values, false);
        }
        return EMPTY;
      }), reduce((acc, values) => acc.concat(values), isInitializer ? [...initialValues] : []));
    }
    getElementById(item) {
      const children = this.fetchChildren(item);
      if (isObservable(children)) {
        return children;
      }
      return of(children);
    }
    itemIndex = (item, data) => {
      return data.findIndex(dataItem => this.mapper.extractFromTask(dataItem, 'id') === this.mapper.extractFromTask(item, 'id'));
    };
    isNew(item) {
      return !isPresent(this.mapper.extractFromDependency(item, 'id'));
    }
    static ɵfac = function EditService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EditService)(i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: EditService,
      factory: EditService.ɵfac
    });
  }
  return EditService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let OptionChangesService = /*#__PURE__*/(() => {
  class OptionChangesService {
    viewChanges = new EventEmitter();
    columnChanges = new EventEmitter();
    dateFormatChanges = new EventEmitter();
    notifyColumnChanges() {
      this.columnChanges.emit();
    }
    notifyViewChanges() {
      this.viewChanges.emit();
    }
    notifyDateFormatChanges() {
      this.dateFormatChanges.emit();
    }
    static ɵfac = function OptionChangesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OptionChangesService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OptionChangesService,
      factory: OptionChangesService.ɵfac
    });
  }
  return OptionChangesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const setTime = (origin, candidate) => {
  const date = cloneDate(origin);
  date.setHours(candidate.getHours(), candidate.getMinutes(), candidate.getSeconds(), candidate.getMilliseconds());
  return date;
};
/**
 * @hidden
 */
const DAY_FORMAT = 'E d/MM';
/**
 * @hidden
 */
const HOUR_FORMAT = 'HH:mm aa';
/**
 * @hidden
 */
const MONTH_FORMAT = 'MMM';
/**
 * @hidden
 */
const YEAR_FORMAT = 'yyyy';
const END_OF_DAY_DATE = new Date(1980, 0, 1, 23, 59, 59, 999);
/**
 * @hidden
 */
class TimelineBaseViewService {
  intlService;
  mapper;
  options;
  _viewStart = 0;
  constructor(intlService, mapper) {
    this.intlService = intlService;
    this.mapper = mapper;
  }
  get viewStart() {
    return this._viewStart;
  }
  /**
   *
   * @param tasks - The tasks which are going to be rendered in the table
   * @returns {Object} - An object containing the range start and end dates
   */
  getRange(tasks) {
    if (!tasks || !tasks.length) {
      return {
        start: new Date(),
        end: new Date()
      };
    }
    const startResult = orderBy(tasks, [{
      field: this.mapper.taskFields.start,
      dir: 'asc'
    }]);
    const endResult = orderBy(tasks, [{
      field: this.mapper.taskFields.end,
      dir: 'desc'
    }]);
    const rangeStart = new Date(this.mapper.extractFromTask(startResult[0], 'start')) || new Date();
    const rangeEnd = new Date(this.mapper.extractFromTask(endResult[0], 'end')) || new Date();
    const start = this.getStartOffset(rangeStart);
    const end = this.getEndOffset(rangeEnd);
    this._viewStart = Number(start);
    return {
      start: new Date(start),
      end: new Date(end)
    };
  }
  /**
   *
   * @param start - The tasks' range start date
   * @param end - The tasks' range end date
   * @returns {Array<Object>} - A collection containing the hour slots
   */
  getHours(start, end, customDateFormat) {
    const slots = [];
    const workDayStart = this.intlService.parseDate(this.options.workDayStart).getHours();
    const workDayEnd = this.intlService.parseDate(this.options.workDayEnd).getHours();
    // TODO: retrieve from option?
    const hourSpan = 1;
    let startDate = new Date(start);
    const hoursFormat = customDateFormat ? customDateFormat : HOUR_FORMAT;
    const endDate = new Date(end);
    while (startDate < endDate) {
      const slotEnd = new Date(startDate);
      const isWorkSlot = isWorkHour(slotEnd, workDayStart, workDayEnd);
      slotEnd.setHours(slotEnd.getHours() + hourSpan);
      slots.push({
        start: startDate,
        end: slotEnd,
        isWorking: isWorkSlot,
        text: this.intlService.formatDate(startDate, hoursFormat, this.intlService.localeId),
        span: 1,
        slotWidth: this.options.slotWidth
      });
      startDate = slotEnd;
    }
    return slots;
  }
  /**
   *
   * @param start - The tasks' range start date
   * @param end - The tasks' range end date
   * @returns {Array<Object>} - A collection containing the day slots
   */
  getDays(start, end, customDateFormat) {
    const slots = [];
    let startDay = new Date(start);
    const dayFormat = customDateFormat ? customDateFormat : DAY_FORMAT;
    const endDay = new Date(end);
    while (startDay <= endDay) {
      // Get the days with cleared time values (except for start and end day)
      const nextDay = getDate(addDays(startDay, 1));
      const isWorking = isWorkDay(startDay, this.options.workWeekStart, this.options.workWeekEnd);
      // Need to get the end date with correct hours (important for day view)
      const slotEnd = endDay < nextDay ? endDay : nextDay;
      slots.push({
        start: startDay,
        end: slotEnd,
        isWorking: isWorking,
        text: this.intlService.formatDate(startDay, dayFormat, this.intlService.localeId),
        span: 1,
        slotWidth: this.options.slotWidth
      });
      startDay = nextDay;
    }
    return slots;
  }
  getWeeks(start, end, customDateFormat) {
    const weekStart = this.intlService.firstDay();
    const slots = [];
    let startDay = new Date(start);
    const dayFormat = customDateFormat ? customDateFormat : DAY_FORMAT;
    const endDay = new Date(end);
    while (startDay <= endDay) {
      const lastWeekDay = lastDayOfWeek(startDay, weekStart);
      const slotEnd = lastWeekDay > endDay ? endDay : lastWeekDay;
      const daySlots = this.getDays(startDay, slotEnd);
      const span = daySlots.length;
      const firstDay = this.intlService.formatDate(firstDayInWeek(getDate(startDay), weekStart), dayFormat, this.intlService.localeId);
      const lastDay = this.intlService.formatDate(slotEnd, dayFormat, this.intlService.localeId);
      if (span > 0) {
        slots.push({
          start: daySlots[0].start,
          end: setTime(daySlots[span - 1].end, END_OF_DAY_DATE),
          text: `${firstDay} - ${lastDay}`,
          span: span,
          slotWidth: this.options.slotWidth
        });
      }
      startDay = firstDayInWeek(addWeeks(slotEnd, 1), weekStart);
    }
    return slots;
  }
  getMonths(start, end, isMainViewType, customDateFormat) {
    const slots = [];
    let startDay = new Date(start);
    const monthFormat = customDateFormat ? customDateFormat : MONTH_FORMAT;
    const endDay = new Date(end);
    while (startDay < endDay) {
      const endMonth = lastDayOfMonth(startDay);
      const slotEnd = endDay < endMonth ? endDay : endMonth;
      const daySlots = this.getDays(startDay, slotEnd);
      const weekSlots = this.getWeeks(startDay, slotEnd);
      const span = isMainViewType ? daySlots.length : weekSlots.length;
      const monthStart = firstDayOfMonth(getDate(startDay));
      const shortText = this.intlService.formatDate(monthStart, monthFormat, this.intlService.localeId);
      if (span > 0) {
        slots.push({
          start: isMainViewType ? daySlots[0].start : weekSlots[0].start,
          end: isMainViewType ? daySlots[span - 1] : setTime(weekSlots[span - 1].end, END_OF_DAY_DATE),
          span: span,
          text: shortText,
          slotWidth: this.options.slotWidth
        });
      }
      startDay = firstDayOfMonth(addMonths(slotEnd, 1));
    }
    return slots;
  }
  getYears(start, end, customDateFormat) {
    const slots = [];
    let startDay = new Date(start);
    const endDay = new Date(end);
    const yearFormat = customDateFormat ? customDateFormat : YEAR_FORMAT;
    while (startDay < endDay) {
      const yearEnd = lastDayOfMonth(lastMonthOfYear(startDay));
      const slotEnd = endDay < yearEnd ? endDay : yearEnd;
      const monthSlots = this.getMonths(startDay, slotEnd);
      const span = monthSlots.length;
      if (span > 0) {
        slots.push({
          start: monthSlots[0].start,
          end: setTime(monthSlots[span - 1].end, END_OF_DAY_DATE),
          span: span,
          text: this.intlService.formatDate(slotEnd, yearFormat),
          slotWidth: this.options.slotWidth
        });
      }
      startDay = addDays(slotEnd, 1);
    }
    return slots;
  }
}

/**
 * @hidden
 */
let TimelineDayViewService = /*#__PURE__*/(() => {
  class TimelineDayViewService extends TimelineBaseViewService {
    constructor(intlService, mapper) {
      super(intlService, mapper);
    }
    /**
     * Gets a date an hour before the first task start with minutes, seconds, milliseconds cleared.
     */
    getStartOffset(rangeStart) {
      return setTime$1(rangeStart, rangeStart.getHours() - 1);
    }
    /**
     * Gets a date an hour after the last task end with minutes, seconds, milliseconds cleared.
     */
    getEndOffset(rangeEnd) {
      return setTime$1(rangeEnd, rangeEnd.getHours() + 1);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {number}
     */
    getTableWidth(tasks) {
      const timeSlots = this.getSlots(tasks)[1];
      const slotWidth = this.options.slotWidth;
      return Math.round(timeSlots.length * slotWidth);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {Array<Object>} - A collection containing the day and hours slots
     * Used to render the number of columns and the header
     */
    getSlots(tasks) {
      // will return the header rows slots
      const slots = [];
      const {
        start,
        end
      } = this.getRange(tasks);
      const daySlots = this.getDays(start, end, this.options.timelineHeadersDateFormat?.groupHeaderDateFormat);
      const hourSlots = [];
      for (let i = 0; i < daySlots.length; i++) {
        const daySlot = daySlots[i];
        const hours = this.getHours(daySlot.start, daySlot.end, this.options.timelineHeadersDateFormat?.columnHeaderDateFormat);
        daySlot.span = hours.length;
        hourSlots.push(...hours);
      }
      slots.push(daySlots, hourSlots);
      return slots;
    }
    static ɵfac = function TimelineDayViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineDayViewService)(i0.ɵɵinject(i1.IntlService), i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimelineDayViewService,
      factory: TimelineDayViewService.ɵfac
    });
  }
  return TimelineDayViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let TimelineMonthViewService = /*#__PURE__*/(() => {
  class TimelineMonthViewService extends TimelineBaseViewService {
    constructor(intlService, mapper) {
      super(intlService, mapper);
    }
    /**
     * Gets a week before the first week in which a task starts.
     */
    getStartOffset(rangeStart) {
      const weekStart = this.intlService.firstDay();
      const firstDay = firstDayInWeek(getDate(rangeStart), weekStart);
      return addWeeks(getDate(firstDay), -1);
    }
    /**
     * Gets a week after the last week in which a task ends.
     */
    getEndOffset(rangeEnd) {
      const weekStart = this.intlService.firstDay();
      const lastDay = addDays(firstDayInWeek(getDate(rangeEnd), weekStart), 6);
      return addWeeks(getDate(lastDay), 1);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {number}
     */
    getTableWidth(tasks) {
      const timeSlots = this.getSlots(tasks)[1];
      const slotWidth = this.options.slotWidth;
      return Math.round(timeSlots.length * slotWidth);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {Array<Object>} - A collection containing the months and weeks slots
     * Used to render the number of columns and the header
     */
    getSlots(tasks) {
      // will return the header rows slots
      const slots = [];
      const {
        start,
        end
      } = this.getRange(tasks);
      const months = this.getMonths(start, end, true, this.options.timelineHeadersDateFormat?.groupHeaderDateFormat);
      const weeks = this.getWeeks(start, end, this.options.timelineHeadersDateFormat?.columnHeaderDateFormat);
      slots.push(months, weeks);
      return slots;
    }
    static ɵfac = function TimelineMonthViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineMonthViewService)(i0.ɵɵinject(i1.IntlService), i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimelineMonthViewService,
      factory: TimelineMonthViewService.ɵfac
    });
  }
  return TimelineMonthViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let TimelineWeekViewService = /*#__PURE__*/(() => {
  class TimelineWeekViewService extends TimelineBaseViewService {
    constructor(intlService, mapper) {
      super(intlService, mapper);
    }
    /**
     * Gets a date a day before the first task start with hours, minutes, seconds, milliseconds cleared.
     */
    getStartOffset(rangeStart) {
      return addDays(getDate(rangeStart), -1);
    }
    /**
     * Gets a date a day after the last task start with hours, minutes, seconds, milliseconds cleared.
     */
    getEndOffset(rangeEnd) {
      return addDays(getDate(rangeEnd), 1);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {number}
     */
    getTableWidth(tasks) {
      const timeSlots = this.getSlots(tasks)[1];
      const slotWidth = this.options.slotWidth;
      return Math.round(timeSlots.length * slotWidth);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {Array<Object>} - A collection containing the day and hours slots
     * Used to render the number of columns and the header
     */
    getSlots(tasks) {
      // will return the header rows slots
      const slots = [];
      const {
        start,
        end
      } = this.getRange(tasks);
      const weeks = this.getWeeks(start, end, this.options.timelineHeadersDateFormat?.groupHeaderDateFormat);
      const days = this.getDays(start, end, this.options.timelineHeadersDateFormat?.columnHeaderDateFormat);
      slots.push(weeks, days);
      return slots;
    }
    static ɵfac = function TimelineWeekViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineWeekViewService)(i0.ɵɵinject(i1.IntlService), i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimelineWeekViewService,
      factory: TimelineWeekViewService.ɵfac
    });
  }
  return TimelineWeekViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let TimeLineYearViewService = /*#__PURE__*/(() => {
  class TimeLineYearViewService extends TimelineBaseViewService {
    constructor(intlService, mapper) {
      super(intlService, mapper);
    }
    getTableWidth(tasks) {
      const timeSlots = this.getSlots(tasks)[1];
      const slotWidth = this.options.slotWidth;
      return Math.round(timeSlots.length * slotWidth);
    }
    getStartOffset(rangeStart) {
      const monthStart = firstDayOfMonth(rangeStart);
      return addMonths(getDate(monthStart), -1);
    }
    /**
     *
     */
    getEndOffset(rangeEnd) {
      const monthEnd = lastDayOfMonth(rangeEnd);
      return addMonths(getDate(monthEnd), 1);
    }
    /**
     *
     * @param tasks - The tasks which are going to be rendered in the table
     * @returns {Array<Object>} - A collection containing the years and months slots
     *
     * Used to render the number of columns and the header
     */
    getSlots(tasks) {
      // will return the header rows slots
      const slots = [];
      const {
        start,
        end
      } = this.getRange(tasks);
      const years = this.getYears(start, end, this.options.timelineHeadersDateFormat?.groupHeaderDateFormat);
      const months = this.getMonths(start, end, false, this.options.timelineHeadersDateFormat?.columnHeaderDateFormat);
      slots.push(years, months);
      return slots;
    }
    static ɵfac = function TimeLineYearViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimeLineYearViewService)(i0.ɵɵinject(i1.IntlService), i0.ɵɵinject(MappingService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimeLineYearViewService,
      factory: TimeLineYearViewService.ɵfac
    });
  }
  return TimeLineYearViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
const services = {
  day: TimelineDayViewService,
  week: TimelineWeekViewService,
  month: TimelineMonthViewService,
  year: TimeLineYearViewService
};
/**
 * @hidden
 */
let TimelineViewService = /*#__PURE__*/(() => {
  class TimelineViewService {
    injector;
    viewChange = new EventEmitter();
    constructor(injector) {
      this.injector = injector;
    }
    service(view) {
      const serviceType = services[view];
      return serviceType ? this.injector.get(serviceType) : null;
    }
    static ɵfac = function TimelineViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineViewService)(i0.ɵɵinject(i0.Injector));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimelineViewService,
      factory: TimelineViewService.ɵfac
    });
  }
  return TimelineViewService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let TaskDragService = /*#__PURE__*/(() => {
  class TaskDragService {
    mapper;
    zone;
    taskDraggable;
    drag = new Subject();
    dragEnd = new Subject();
    dragStart = new Subject();
    tasksContainer;
    tasksContainerRect;
    scrollableContainer;
    currentDragTask;
    currentDragTaskRect;
    leftDragHandle;
    rightDragHandle;
    completionRatioHandle;
    tasks = [];
    editedProp;
    prevX;
    prevWidth;
    prevLeft;
    prevScrollLeft;
    newRange;
    offsetX;
    maxWidth;
    newCompletionRatio;
    constructor(mapper, zone) {
      this.mapper = mapper;
      this.zone = zone;
    }
    registerTask(task) {
      if (!this.tasks.some(t => t === task)) {
        this.tasks.push(task);
      }
    }
    onDragStart(args) {
      this.tasksContainerRect = this.tasksContainer.getBoundingClientRect();
      this.currentDragTask = this.tasks.find(t => t.taskElement.nativeElement.contains(args.dragTarget) || t.taskElement.nativeElement.nextElementSibling === args.dragTarget);
      const taskEl = this.currentDragTask.taskElement.nativeElement;
      this.currentDragTaskRect = taskEl.getBoundingClientRect();
      this.completionRatioHandle = args.dragTarget.classList.contains('k-task-draghandle');
      this.leftDragHandle = args.dragTarget.classList.contains('k-resize-w');
      this.rightDragHandle = args.dragTarget.classList.contains('k-resize-e');
      this.editedProp = this.leftDragHandle ? 'start' : this.rightDragHandle ? 'end' : 'both';
      this.dragStart.next(args);
    }
    onDrag(args) {
      if (this.completionRatioHandle) {
        // completion ratio handle drag
        const taskWidth = this.currentDragTaskRect.width;
        const scrollLeft = this.scrollableContainer?.scrollLeft;
        const scrollDelta = isPresent$1(this.prevScrollLeft) ? this.prevScrollLeft - scrollLeft : 0;
        const completionWidth = Math.min(Math.max(args.dragEvent.clientX - this.currentDragTaskRect.left - scrollDelta, 0), taskWidth);
        const newCompletionRatio = completionWidth / taskWidth;
        this.currentDragTask.draggedCompletionWidth = completionWidth;
        !this.prevScrollLeft && (this.prevScrollLeft = scrollLeft);
        this.newCompletionRatio = newCompletionRatio;
        this.drag.next({
          start: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'start'),
          end: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'end'),
          completionRatio: newCompletionRatio,
          dragEvent: args,
          item: this.currentDragTask.dataItem,
          offset: this.prevX,
          width: this.prevWidth
        });
      } else {
        // task resize or drag
        const marquee = this.calculateMarquee(args, this.leftDragHandle, this.rightDragHandle);
        if (!marquee) {
          return;
        }
        const {
          left,
          width
        } = marquee;
        this.newRange = this.calculateStartEnd(this.editedProp, width, left);
        this.drag.next({
          start: this.newRange.start,
          end: this.newRange.end,
          completionRatio: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'completionRatio'),
          dragEvent: args,
          item: this.currentDragTask.dataItem,
          offset: left,
          width
        });
      }
    }
    onDragEnd(args) {
      if (this.completionRatioHandle) {
        this.dragEnd.next({
          start: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'start'),
          end: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'end'),
          completionRatio: this.newCompletionRatio,
          dragEvent: args,
          item: this.currentDragTask.dataItem,
          offset: this.prevX,
          width: this.prevWidth
        });
      } else {
        this.dragEnd.next({
          start: this.newRange.start,
          end: this.newRange.end,
          completionRatio: this.mapper.extractFromTask(this.currentDragTask.dataItem, 'completionRatio'),
          dragEvent: args,
          item: this.currentDragTask.dataItem,
          offset: this.prevX,
          width: this.prevWidth
        });
      }
      this.prevWidth = this.prevX = this.prevLeft = this.prevScrollLeft = this.offsetX = this.maxWidth = this.newCompletionRatio = null;
      this.currentDragTaskRect = this.currentDragTask = this.currentDragTask.draggedCompletionWidth = this.editedProp = this.newRange = null;
      this.leftDragHandle = this.rightDragHandle = this.completionRatioHandle = false;
    }
    calculateMarquee(e, leftDragHandle, rightDragHandle) {
      const clientX = e.dragEvent.clientX;
      // Update container rect when dragging outside of it to avoid miscalculations
      // coming from scrolling the whole page during dragging a task
      if (clientX < this.tasksContainerRect.x || clientX > this.tasksContainerRect.right) {
        this.zone.runOutsideAngular(() => {
          this.tasksContainerRect = this.tasksContainer.getBoundingClientRect();
          this.currentDragTaskRect = this.currentDragTask.taskElement.nativeElement.getBoundingClientRect();
        });
        return;
      }
      const scrollLeft = this.scrollableContainer?.scrollLeft;
      const scrollDelta = isPresent$1(this.prevScrollLeft) ? this.prevScrollLeft - scrollLeft : 0;
      let left, width;
      if (leftDragHandle) {
        if (!isPresent$1(this.maxWidth)) {
          this.maxWidth = this.currentDragTaskRect.right - this.tasksContainerRect.x + scrollLeft;
        }
        left = Math.min(Math.max(clientX - this.tasksContainerRect.x - scrollDelta, 0), this.maxWidth);
        width = Math.min(Math.max(this.currentDragTaskRect.right - clientX + scrollDelta, 0), this.maxWidth);
      } else if (rightDragHandle) {
        if (!isPresent$1(this.maxWidth)) {
          this.maxWidth = this.tasksContainerRect.right - this.currentDragTaskRect.x;
        }
        left = this.prevLeft ?? this.currentDragTaskRect.x - this.tasksContainerRect.x;
        width = Math.min(Math.max(clientX - this.tasksContainerRect.x - left - scrollDelta, 0), this.maxWidth);
      } else {
        // dragging the whole task
        if (!isPresent$1(this.offsetX)) {
          this.offsetX = e.dragEvent.offsetX;
        }
        left = Math.max(clientX - this.tasksContainerRect.x - this.offsetX - scrollDelta, 0);
      }
      const cursorLeft = clientX - this.tasksContainerRect.x;
      // out of limits (0, max possible width) when dragging the left handle
      if (this.leftDragHandle && (cursorLeft < 0 || this.maxWidth < cursorLeft)) {
        return {
          left: cursorLeft < 0 ? 0 : this.maxWidth,
          width
        };
      }
      // out of limits (0, max possible width) when dragging right handle
      if (rightDragHandle && clientX < this.currentDragTaskRect.x || clientX > this.tasksContainerRect.right) {
        return {
          left,
          width: clientX < this.currentDragTaskRect.x ? 0 : this.maxWidth
        };
      }
      // out of limits (start < view start || end > view end) when dragging the whole task
      if (!(this.leftDragHandle || this.rightDragHandle) && (left < 0 || clientX + this.currentDragTaskRect.width - scrollDelta - this.offsetX > this.tasksContainerRect.right)) {
        return {
          left: Math.min(Math.max(left, 0), this.tasksContainerRect.width - this.currentDragTaskRect.width),
          width: this.currentDragTaskRect.width
        };
      }
      this.prevX = clientX;
      this.prevLeft = left;
      this.prevWidth = width;
      !this.prevScrollLeft && (this.prevScrollLeft = scrollLeft);
      return {
        left,
        width: width ?? this.currentDragTaskRect.width
      };
    }
    calculateStartEnd(editedProp, width, left) {
      const startDate = this.mapper.extractFromTask(this.currentDragTask.dataItem, 'start');
      const endDate = this.mapper.extractFromTask(this.currentDragTask.dataItem, 'end');
      const duration = endDate - startDate;
      const delta = left - this.currentDragTaskRect.x + this.tasksContainerRect.x;
      if (editedProp === 'both') {
        if (duration) {
          const delta = left - this.currentDragTaskRect.x + this.tasksContainerRect.left;
          const coef = delta / this.currentDragTask.taskWidth;
          const deltaMs = duration * coef;
          const newStart = new Date(startDate.getTime() + deltaMs);
          const newEnd = new Date(newStart.getTime() + duration);
          return {
            start: newStart,
            end: newEnd
          };
        } else {
          // milestone task      
          const initialOffset = this.currentDragTaskRect.x - this.tasksContainerRect.x;
          const msPerPx = (startDate - this.currentDragTask.viewService.viewStart) / initialOffset;
          const deltaMs = delta * msPerPx;
          return {
            start: new Date(startDate.getTime() + deltaMs),
            end: new Date(startDate.getTime() + deltaMs)
          };
        }
      }
      const coef = width / this.currentDragTask.taskWidth;
      const newDuration = duration * coef;
      const newPropDate = editedProp === 'start' ? new Date(endDate - newDuration) : new Date(startDate.getTime() + newDuration);
      const newStart = editedProp === 'start' ? newPropDate : startDate;
      const newEnd = editedProp === 'end' ? newPropDate : endDate;
      return {
        start: newStart,
        end: newEnd
      };
    }
    static ɵfac = function TaskDragService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TaskDragService)(i0.ɵɵinject(MappingService), i0.ɵɵinject(i0.NgZone));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TaskDragService,
      factory: TaskDragService.ɵfac
    });
  }
  return TaskDragService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const slotUnitDuration = {
  day: MS_PER_HOUR,
  week: MS_PER_DAY,
  month: MS_PER_DAY * 7
};
const FOCUSED_CLASS = 'k-focus';
/**
 * @hidden
 */
let GanttTaskBase = /*#__PURE__*/(() => {
  class GanttTaskBase {
    mapper;
    timelineViewService;
    dependencyDomService;
    optionChangesService;
    cdr;
    navigationService;
    wrapperClass = true;
    get taskIndexAttribute() {
      return this.index;
    }
    /**
     * Points to the `.k-task` element of the template (present in all three task types).
     */
    taskElement;
    dataItem;
    index;
    level;
    renderDependencyDragClues;
    selectable;
    isSelected;
    // better to be set in a service and retrieved from it whenever needed?
    activeView;
    taskClass;
    get ariaSelected() {
      // assigning null will not render the attribute at all (desired in selectable="false" mode)
      return this.selectable ? String(this.isSelected(this.dataItem)) : null;
    }
    get slotUnitDuration() {
      return slotUnitDuration[this.activeView];
    }
    get viewService() {
      return this.timelineViewService.service(this.activeView);
    }
    get slotWidth() {
      return this.viewService.options.slotWidth;
    }
    get taskWidth() {
      const taskStart = this.mapper.extractFromTask(this.dataItem, 'start');
      const taskEnd = this.mapper.extractFromTask(this.dataItem, 'end');
      if (this.activeView === 'year') {
        if (!taskStart || !taskEnd) {
          return;
        }
        const monthsDiff = Math.max(getTotalMonthsInBetween(taskStart, taskEnd), 0);
        const totalDaysInStartMonth = getTotalDaysInMonth(taskStart);
        if (monthsDiff > 0 || monthsDiff === 0 && taskStart.getMonth() !== taskEnd.getMonth()) {
          const startFraction = (totalDaysInStartMonth - taskStart.getDate()) / totalDaysInStartMonth;
          const endFraction = taskEnd.getDate() / getTotalDaysInMonth(taskEnd);
          return (startFraction + monthsDiff + endFraction) * this.slotWidth;
        } else {
          const fraction = (taskEnd.getDate() - taskStart.getDate()) / totalDaysInStartMonth;
          return fraction * this.slotWidth;
        }
      }
      const itemDuration = taskEnd - taskStart;
      const durationInSlotUnits = itemDuration / this.slotUnitDuration;
      const width = durationInSlotUnits * this.slotWidth;
      return width;
    }
    /**
     * The `left` style prop has to be applied to the host element (.k-task-wrap), as the drag clue elements are displayed on .k-task-wrap hover.
     * Applying the `left` offset to the inner .k-task element leaves the .k-task-wrap element rendered with an offset of 0 somewhere on the left
     * and hovering just the .k-task element doesn't expose the drag clues.
     * Additionally, positioning the entire container takes care of positioning the hints as well.
     */
    get taskOffset() {
      const taskStart = this.mapper.extractFromTask(this.dataItem, 'start');
      const taskEnd = this.mapper.extractFromTask(this.dataItem, 'end');
      const viewStart = this.viewService.viewStart;
      if (this.activeView === 'year') {
        if (!taskStart || !taskEnd) {
          return;
        }
        const viewStartDate = new Date(viewStart);
        const offsetSlots = getTotalMonthsInBetween(viewStartDate, new Date(firstDayOfMonth(taskStart))) + 1;
        const currentMonthOffset = taskStart.getDate() / getTotalDaysInMonth(taskStart);
        return (offsetSlots + currentMonthOffset) * this.slotWidth;
      }
      const timeAfterViewStart = taskStart - viewStart;
      const offsetInSlotUnits = timeAfterViewStart / this.slotUnitDuration;
      const offset = offsetInSlotUnits * this.slotWidth;
      return offset;
    }
    get completionOverlayWidth() {
      const overlayWidth = this.taskWidth * this.mapper.extractFromTask(this.dataItem, 'completionRatio');
      // fall-back to 0 in case no completionRatio is provided
      return isNumber(overlayWidth) ? overlayWidth : 0;
    }
    draggedCompletionWidth;
    taskDragService;
    completionDragResult;
    subscriptions = new Subscription();
    constructor(mapper,
    // left public to be available for usage in the templates
    timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService) {
      this.mapper = mapper;
      this.timelineViewService = timelineViewService;
      this.dependencyDomService = dependencyDomService;
      this.optionChangesService = optionChangesService;
      this.cdr = cdr;
      this.navigationService = navigationService;
      this.taskDragService = inject(TaskDragService, {
        optional: true
      });
      this.subscriptions.add(this.optionChangesService.viewChanges.subscribe(() => this.cdr.markForCheck()));
      this.subscriptions.add(this.navigationService.taskStatusChanges.subscribe(this.updateActiveState.bind(this)));
    }
    ngOnInit() {
      const taskStart = this.mapper.extractFromTask(this.dataItem, 'start');
      const taskEnd = this.mapper.extractFromTask(this.dataItem, 'end');
      if (isDevMode()) {
        const taskTitle = this.mapper.extractFromTask(this.dataItem, 'title');
        if (!taskStart || !taskEnd) {
          console.warn(`Task ${taskTitle} is missing a start or end date.`);
        }
        if (taskStart && taskEnd && taskStart > taskEnd) {
          console.warn(`Task ${taskTitle} has a start date that is after the end date.`);
        }
      }
    }
    ngAfterViewInit() {
      this.taskDragService?.registerTask(this);
    }
    ngOnChanges(changes) {
      if (isPresent(changes['dataItem'])) {
        if (isPresent(changes['dataItem'].previousValue)) {
          this.dependencyDomService.unregisterTask(changes['dataItem'].previousValue);
        }
        this.dependencyDomService.registerTask(this.dataItem, this.taskElement.nativeElement);
      } else if (isPresent(changes['activeView'])) {
        this.dependencyDomService.notifyChanges();
      }
      if (this.navigationService.enabled && isPresent(changes['index'])) {
        this.updateActiveState(this.navigationService.activeTask);
      }
    }
    ngOnDestroy() {
      if (isPresent(this.dataItem)) {
        this.dependencyDomService.unregisterTask(this.dataItem);
      }
      this.subscriptions.unsubscribe();
    }
    updateActiveState({
      activeIndex,
      isFocused
    }) {
      const isActive = activeIndex === this.index;
      const tabindex = isActive ? '0' : '-1';
      this.taskElement.nativeElement.setAttribute('tabindex', tabindex);
      if (isActive && isFocused) {
        this.taskElement.nativeElement.focus();
        this.taskElement.nativeElement.classList.add(FOCUSED_CLASS);
      } else {
        this.taskElement.nativeElement.classList.remove(FOCUSED_CLASS);
      }
    }
    static ɵfac = function GanttTaskBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTaskBase)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(TimelineViewService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NavigationService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttTaskBase,
      selectors: [["kendo-gantt-task-base"]],
      viewQuery: function GanttTaskBase_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.taskElement = _t.first);
        }
      },
      hostVars: 5,
      hostBindings: function GanttTaskBase_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-task-index", ctx.taskIndexAttribute);
          i0.ɵɵstyleProp("left", ctx.taskOffset, "px");
          i0.ɵɵclassProp("k-task-wrap", ctx.wrapperClass);
        }
      },
      inputs: {
        dataItem: "dataItem",
        index: "index",
        level: "level",
        renderDependencyDragClues: "renderDependencyDragClues",
        selectable: "selectable",
        isSelected: "isSelected",
        activeView: "activeView",
        taskClass: "taskClass"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return GanttTaskBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttTaskComponent = /*#__PURE__*/(() => {
  class GanttTaskComponent extends GanttTaskBase {
    editService;
    taskContentTemplate;
    taskTemplate;
    xIcon = xIcon;
    touchEnabled = touchEnabled;
    get showDragHandles() {
      return isPresent$1(this.taskDragService);
    }
    constructor(editService, mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService) {
      super(mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService);
      this.editService = editService;
    }
    onTaskDelete() {
      this.editService.dataItem = this.dataItem;
      this.editService.taskDelete.next(this.dataItem);
    }
    static ɵfac = function GanttTaskComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTaskComponent)(i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(TimelineViewService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NavigationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttTaskComponent,
      selectors: [["kendo-gantt-task"]],
      inputs: {
        taskContentTemplate: "taskContentTemplate",
        taskTemplate: "taskTemplate"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttTaskBase,
        useExisting: forwardRef(() => GanttTaskComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 12,
      consts: [["task", ""], ["taskContent", ""], ["role", "treeitem", 1, "k-task", "k-task-single", 3, "ngClass"], [4, "ngIf"], ["class", "k-task-draghandle", 3, "left", 4, "ngIf"], ["aria-hidden", "true", 1, "k-task-complete"], [1, "k-task-content"], [1, "k-task-template"], [4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true", 1, "k-task-actions"], [1, "k-link", "k-task-delete", 3, "kendoEventsOutsideAngular", "scope"], ["icon", "x", 3, "svgIcon"], [1, "k-resize-handle", "k-resize-w"], [1, "k-resize-handle", "k-resize-e"], [1, "k-task-draghandle"], [1, "k-task-dot", "k-task-start", "k-touch-action-none"], [1, "k-task-dot", "k-task-end", "k-touch-action-none"]],
      template: function GanttTaskComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵtemplate(2, GanttTaskComponent_ng_container_2_Template, 11, 14, "ng-container", 3)(3, GanttTaskComponent_3_Template, 1, 5, null, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, GanttTaskComponent_div_4_Template, 1, 2, "div", 4)(5, GanttTaskComponent_ng_container_5_Template, 3, 4, "ng-container", 3);
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("width", ctx.taskWidth, "px");
          i0.ɵɵclassProp("k-selected", ctx.isSelected(ctx.dataItem));
          i0.ɵɵproperty("ngClass", ctx.taskClass(ctx.dataItem));
          i0.ɵɵattribute("title", ctx.mapper.extractFromTask(ctx.dataItem, "title"))("aria-selected", ctx.ariaSelected)("aria-level", ctx.level + 1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.taskTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.taskTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDragHandles);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.renderDependencyDragClues);
        }
      },
      dependencies: [NgClass, NgIf, NgTemplateOutlet, EventsOutsideAngularDirective, IconWrapperComponent],
      encapsulation: 2
    });
  }
  return GanttTaskComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttSummaryTaskComponent = /*#__PURE__*/(() => {
  class GanttSummaryTaskComponent extends GanttTaskBase {
    summaryWrapperClass = true;
    template;
    isExpanded;
    touchEnabled = touchEnabled;
    get ariaExpanded() {
      // if no callback is provided, all child items are displayed and the item is regarded as expanded
      // replicates the TreeList aria-expanded behavior
      const isExpanded = !isPresent(this.isExpanded) || this.isExpanded(this.dataItem);
      return String(isExpanded);
    }
    constructor(mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService) {
      super(mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService);
    }
    static ɵfac = function GanttSummaryTaskComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttSummaryTaskComponent)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(TimelineViewService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NavigationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttSummaryTaskComponent,
      selectors: [["kendo-gantt-summary-task"]],
      hostVars: 2,
      hostBindings: function GanttSummaryTaskComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("k-summary-wrap", ctx.summaryWrapperClass);
        }
      },
      inputs: {
        template: "template",
        isExpanded: "isExpanded"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttTaskBase,
        useExisting: forwardRef(() => GanttSummaryTaskComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 17,
      consts: [["task", ""], ["summaryTemplate", ""], ["role", "treeitem", 1, "k-task", "k-task-summary", 3, "ngClass"], ["class", "k-task-summary-progress", 3, "width", 4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"], [1, "k-task-summary-progress"], [1, "k-task-summary-complete"], [1, "k-task-dot", "k-task-start", "k-touch-action-none"], [1, "k-task-dot", "k-task-end", "k-touch-action-none"]],
      template: function GanttSummaryTaskComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2, 0);
          i0.ɵɵtemplate(2, GanttSummaryTaskComponent_div_2_Template, 2, 4, "div", 3)(3, GanttSummaryTaskComponent_ng_template_3_Template, 0, 0, "ng-template", 4, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, GanttSummaryTaskComponent_ng_container_5_Template, 3, 4, "ng-container", 5);
        }
        if (rf & 2) {
          const summaryTemplate_r2 = i0.ɵɵreference(4);
          i0.ɵɵstyleProp("width", ctx.taskWidth, "px");
          i0.ɵɵclassProp("k-selected", ctx.isSelected(ctx.dataItem));
          i0.ɵɵproperty("ngClass", ctx.taskClass(ctx.dataItem));
          i0.ɵɵattribute("title", ctx.mapper.extractFromTask(ctx.dataItem, "title"))("aria-selected", ctx.ariaSelected)("aria-expanded", ctx.ariaExpanded)("aria-level", ctx.level + 1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.template)("ngIfElse", summaryTemplate_r2);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction2(14, _c3, ctx.dataItem, ctx.taskWidth));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.renderDependencyDragClues);
        }
      },
      dependencies: [NgClass, NgIf, NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return GanttSummaryTaskComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttMilestoneTaskComponent = /*#__PURE__*/(() => {
  class GanttMilestoneTaskComponent extends GanttTaskBase {
    milestoneWrapperClass = true;
    touchEnabled = touchEnabled;
    constructor(mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService) {
      super(mapper, timelineViewService, dependencyDomService, optionChangesService, cdr, navigationService);
    }
    static ɵfac = function GanttMilestoneTaskComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttMilestoneTaskComponent)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(TimelineViewService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NavigationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttMilestoneTaskComponent,
      selectors: [["kendo-gantt-milestone-task"]],
      hostVars: 2,
      hostBindings: function GanttMilestoneTaskComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("k-milestone-wrap", ctx.milestoneWrapperClass);
        }
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttTaskBase,
        useExisting: forwardRef(() => GanttMilestoneTaskComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 3,
      vars: 7,
      consts: [["task", ""], ["role", "treeitem", 1, "k-task", "k-task-milestone", 3, "ngClass"], [4, "ngIf"], [1, "k-task-dot", "k-task-start", "k-touch-action-none"], [1, "k-task-dot", "k-task-end", "k-touch-action-none"]],
      template: function GanttMilestoneTaskComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 1, 0);
          i0.ɵɵtemplate(2, GanttMilestoneTaskComponent_ng_container_2_Template, 3, 4, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("k-selected", ctx.isSelected(ctx.dataItem));
          i0.ɵɵproperty("ngClass", ctx.taskClass(ctx.dataItem));
          i0.ɵɵattribute("title", ctx.mapper.extractFromTask(ctx.dataItem, "title"))("aria-selected", ctx.ariaSelected)("aria-level", ctx.level + 1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.renderDependencyDragClues);
        }
      },
      dependencies: [NgClass, NgIf],
      encapsulation: 2
    });
  }
  return GanttMilestoneTaskComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttTasksTableBodyComponent = /*#__PURE__*/(() => {
  class GanttTasksTableBodyComponent {
    dependencyDomService;
    mapper;
    set timelineRow(timelineRow) {
      // register the row value only when the first row is rendered
      // with server-side data-binding, the rows rendering could be delayed
      if (isPresent(timelineRow)) {
        this.dependencyDomService.registerTimelineRow(timelineRow.nativeElement);
      }
    }
    selectable;
    rows;
    activeView;
    taskContentTemplate;
    taskTemplate;
    summaryTaskTemplate;
    taskClass;
    isExpanded;
    isTaskSelected;
    renderDependencyDragClues;
    taskPointerEnter = new EventEmitter();
    taskPointerLeave = new EventEmitter();
    constructor(dependencyDomService, mapper) {
      this.dependencyDomService = dependencyDomService;
      this.mapper = mapper;
    }
    trackBy = (_, item) => this.mapper.extractFromTask(item, 'id');
    isMileStone(item) {
      return !item.hasChildren && isEqual(this.mapper.extractFromTask(item.data, 'start'), this.mapper.extractFromTask(item.data, 'end'));
    }
    mapItemToTask(item) {
      const mappedItem = ['id', 'title', 'completionRatio', 'start', 'end'].reduce((acc, curr) => {
        acc[curr] = this.mapper.extractFromTask(item.data, curr);
        return acc;
      }, {});
      return mappedItem;
    }
    static ɵfac = function GanttTasksTableBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTasksTableBodyComponent)(i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(MappingService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttTasksTableBodyComponent,
      selectors: [["", "kendoGanttTasksTableBody", ""]],
      viewQuery: function GanttTasksTableBodyComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c4, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timelineRow = _t.first);
        }
      },
      inputs: {
        selectable: "selectable",
        rows: "rows",
        activeView: "activeView",
        taskContentTemplate: "taskContentTemplate",
        taskTemplate: "taskTemplate",
        summaryTaskTemplate: "summaryTaskTemplate",
        taskClass: "taskClass",
        isExpanded: "isExpanded",
        isTaskSelected: "isTaskSelected",
        renderDependencyDragClues: "renderDependencyDragClues"
      },
      outputs: {
        taskPointerEnter: "taskPointerEnter",
        taskPointerLeave: "taskPointerLeave"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      attrs: _c5,
      decls: 1,
      vars: 2,
      consts: [["timelineRow", ""], ["task", ""], ["class", "k-table-row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "k-table-row"], [1, "k-table-td"], [3, "dataItem", "level", "activeView", "taskClass", "selectable", "isSelected", "index", "renderDependencyDragClues", "pointerenter", "pointerleave", 4, "ngIf", "ngIfElse"], [3, "pointerenter", "pointerleave", "dataItem", "level", "activeView", "taskClass", "selectable", "isSelected", "index", "renderDependencyDragClues"], [3, "dataItem", "level", "template", "activeView", "taskClass", "selectable", "isSelected", "isExpanded", "index", "renderDependencyDragClues", "pointerenter", "pointerleave", 4, "ngIf"], [3, "dataItem", "level", "taskContentTemplate", "taskTemplate", "activeView", "taskClass", "selectable", "isSelected", "index", "renderDependencyDragClues", "pointerenter", "pointerleave", 4, "ngIf"], [3, "pointerenter", "pointerleave", "dataItem", "level", "template", "activeView", "taskClass", "selectable", "isSelected", "isExpanded", "index", "renderDependencyDragClues"], [3, "pointerenter", "pointerleave", "dataItem", "level", "taskContentTemplate", "taskTemplate", "activeView", "taskClass", "selectable", "isSelected", "index", "renderDependencyDragClues"]],
      template: function GanttTasksTableBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, GanttTasksTableBodyComponent_tr_0_Template, 6, 2, "tr", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.rows)("ngForTrackBy", ctx.trackBy);
        }
      },
      dependencies: [NgFor, NgIf, GanttMilestoneTaskComponent, GanttSummaryTaskComponent, GanttTaskComponent],
      encapsulation: 2
    });
  }
  return GanttTasksTableBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
var ScrollDirection = /*#__PURE__*/function (ScrollDirection) {
  ScrollDirection[ScrollDirection["Backwards"] = -1] = "Backwards";
  ScrollDirection[ScrollDirection["Forward"] = 1] = "Forward";
  return ScrollDirection;
}(ScrollDirection || {});
/**
 * @hidden
 */
var ScrollAxis = /*#__PURE__*/function (ScrollAxis) {
  ScrollAxis["Vertical"] = "scrollTop";
  ScrollAxis["Horizontal"] = "scrollLeft";
  return ScrollAxis;
}(ScrollAxis || {});
/**
 * @hidden
 *
 * Notifies the timeline-scroll.directive to scroll into view to requested coordinates.
 * The scrolling is performed based on client (viewport) coordinates.
 */
let TimelineScrollService = /*#__PURE__*/(() => {
  class TimelineScrollService {
    horizontalScroll = new Subject();
    verticalScroll = new Subject();
    scrollCancel = new Subject();
    ngOnDestroy() {
      this.horizontalScroll.complete();
      this.verticalScroll.complete();
      this.scrollCancel.complete();
    }
    requestHorizontalScroll(clientTop) {
      this.horizontalScroll.next(clientTop);
    }
    requestVerticalScroll(clientLeft) {
      this.verticalScroll.next(clientLeft);
    }
    requestScrollCancel() {
      this.scrollCancel.next();
    }
    static ɵfac = function TimelineScrollService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineScrollService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TimelineScrollService,
      factory: TimelineScrollService.ɵfac
    });
  }
  return TimelineScrollService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 *
 * Checks if the beginning of the scrollable element is reached (top/left).
 * Floors the top value.
 */
const isUpperLimitReached = (element, axis) => Math.floor(element[axis]) <= 0;
/**
 * @hidden
 *
 * Checks if the end of the scrollable element is reached (bottom/right).
 * Ceils the top value.
 */
const isBottomLimitReached = (element, axis) => {
  const elementSize = axis === ScrollAxis.Horizontal ? element.scrollWidth - element.clientWidth : element.scrollHeight - element.clientHeight;
  return Math.ceil(element[axis]) >= elementSize;
};
/**
 * @hidden
 *
 * Scrolls the element in the given direction by the provided step in the provided scroll axis.
 *
 * If the targeted scroll incrementation doesn't yield any result due to device pixel ratio issues (https://github.com/dimitar-pechev/RenderingIndependentScrollOffsets#readme),
 * increments the step with 1px and again attempts to change the scrollTop of the element, until the content is actually scrolled.
 *
 * Cuts the operation short after 20 unsuccessful attempts to prevent infinite loops in possible corner-case scenarios.
 */
const scrollElement = (element, step, direction, scrollAxis) => {
  if (!(isPresent(element) && isDocumentAvailable())) {
    return;
  }
  const initialScrollPosition = element[scrollAxis];
  let currentStep = step;
  let iterations = 0;
  while (initialScrollPosition === element[scrollAxis] && !(direction === ScrollDirection.Backwards && isUpperLimitReached(element, scrollAxis)) && !(direction === ScrollDirection.Forward && isBottomLimitReached(element, scrollAxis)) && iterations < 20 // cut the operation short in 20 attempts - in case of a wild corner case
  ) {
    element[scrollAxis] += currentStep * direction;
    // try with a larger step if the current one doesn't update the scroll position successfully
    currentStep += 1;
    iterations += 1;
  }
};
/**
 * @hidden
 *
 * As client coordinates are not restricted to the range 0px - {viewportSize}px, but can have negative starting values or ending values greater than the viewport size,
 * this function extracts the visible boundaries of the provided element - fall-backing to 0 when the top/left are below 0,
 * and fall-backing to the actual visible size of the container for bottom/right.
 */
const getViewportBoundaries = element => {
  const elementRect = element.getBoundingClientRect();
  // if the beginning of the scrollable container is above/before the current viewport, fall-back to 0
  const topLimit = Math.max(elementRect.top, 0);
  const leftLimit = Math.max(elementRect.left, 0);
  // if the end of the scrollable container is beneath/after the current viewport, fall-back to its client height
  // add the distance from the start of the viewport to the beginning of the container to ensure scrolling bottom begins when the actual end of the container is reached
  const bottomLimit = topLimit + Math.min(elementRect.bottom, element.clientHeight);
  const rightLimit = leftLimit + Math.min(elementRect.right, element.clientWidth);
  return {
    top: topLimit,
    bottom: bottomLimit,
    left: leftLimit,
    right: rightLimit
  };
};

/**
 * @hidden
 */
let TimelineScrollableDirective = /*#__PURE__*/(() => {
  class TimelineScrollableDirective {
    timelineScrollableContainer;
    scrollService;
    zone;
    scrollSettings;
    subscriptions = new Subscription();
    verticalScrollInterval;
    horizontalScrollInterval;
    constructor(timelineScrollableContainer, scrollService, zone) {
      this.timelineScrollableContainer = timelineScrollableContainer;
      this.scrollService = scrollService;
      this.zone = zone;
      this.subscriptions.add(this.scrollService.horizontalScroll.subscribe(this.scrollHorizontallyTo.bind(this)));
      this.subscriptions.add(this.scrollService.verticalScroll.subscribe(this.scrollVerticallyTo.bind(this)));
      this.subscriptions.add(this.scrollService.scrollCancel.subscribe(this.cancelScroll.bind(this)));
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    scrollHorizontallyTo(left) {
      this.zone.runOutsideAngular(() => {
        const container = this.timelineScrollableContainer.nativeElement;
        const visibleBoundaries = getViewportBoundaries(container);
        if (left < visibleBoundaries.left + this.scrollSettings.threshold) {
          this.horizontalScrollInterval = setInterval(() => scrollElement(container, this.scrollSettings.step, ScrollDirection.Backwards, ScrollAxis.Horizontal), this.scrollSettings.interval);
        } else if (left > visibleBoundaries.right - this.scrollSettings.threshold) {
          this.horizontalScrollInterval = setInterval(() => scrollElement(container, this.scrollSettings.step, ScrollDirection.Forward, ScrollAxis.Horizontal), this.scrollSettings.interval);
        }
      });
    }
    scrollVerticallyTo(top) {
      this.zone.runOutsideAngular(() => {
        const container = this.timelineScrollableContainer.nativeElement;
        const visibleBoundaries = getViewportBoundaries(container);
        if (top < visibleBoundaries.top + this.scrollSettings.threshold) {
          this.verticalScrollInterval = setInterval(() => scrollElement(container, this.scrollSettings.step, ScrollDirection.Backwards, ScrollAxis.Vertical), this.scrollSettings.interval);
        } else if (top > visibleBoundaries.bottom - this.scrollSettings.threshold) {
          this.verticalScrollInterval = setInterval(() => scrollElement(container, this.scrollSettings.step, ScrollDirection.Forward, ScrollAxis.Vertical), this.scrollSettings.interval);
        }
      });
    }
    cancelScroll() {
      if (isPresent(this.verticalScrollInterval)) {
        clearInterval(this.verticalScrollInterval);
        this.verticalScrollInterval = null;
      }
      if (isPresent(this.horizontalScrollInterval)) {
        clearInterval(this.horizontalScrollInterval);
        this.horizontalScrollInterval = null;
      }
    }
    static ɵfac = function TimelineScrollableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineScrollableDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TimelineScrollService), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TimelineScrollableDirective,
      selectors: [["", "kendoGanttTimelineScrollable", ""]],
      inputs: {
        scrollSettings: "scrollSettings"
      },
      standalone: true
    });
  }
  return TimelineScrollableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttHeaderTableBodyComponent = /*#__PURE__*/(() => {
  class GanttHeaderTableBodyComponent {
    tbodyClass = true;
    groupSlots;
    slots;
    static ɵfac = function GanttHeaderTableBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttHeaderTableBodyComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttHeaderTableBodyComponent,
      selectors: [["", "kendoGanttHeaderTableBody", ""]],
      hostVars: 2,
      hostBindings: function GanttHeaderTableBodyComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("k-table-tbody", ctx.tbodyClass);
        }
      },
      inputs: {
        groupSlots: "groupSlots",
        slots: "slots"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      attrs: _c6,
      decls: 4,
      vars: 2,
      consts: [[1, "k-table-row"], ["class", "k-header k-table-td", 4, "ngFor", "ngForOf"], [1, "k-header", "k-table-td"]],
      template: function GanttHeaderTableBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "tr", 0);
          i0.ɵɵtemplate(1, GanttHeaderTableBodyComponent_td_1_Template, 2, 2, "td", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "tr", 0);
          i0.ɵɵtemplate(3, GanttHeaderTableBodyComponent_td_3_Template, 2, 3, "td", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.groupSlots);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.slots);
        }
      },
      dependencies: [NgFor],
      encapsulation: 2
    });
  }
  return GanttHeaderTableBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents a template that defines the whole content of the Task tooltip.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoGanttTaskTooltipTemplate` directive inside the `<kendo-gantt>` tag.
 *
 * The template context is set to the respective data item.
 *
 * @example
 * ```ts-preview
 * _@Component({
 *      selector: 'my-app',
 *      template: `
 *          <kendo-gantt [kendoGanttHierarchyBinding]="data">
 *              <ng-template kendoGanttTaskTooltipTemplate let-dataItem>
 *                  <div [style]="'color: white; font-size: 8px;'">
 *                      {{ dataItem.title }} - {{ dataItem.completionRatio * 100 }}% complete;
 *                  </div>
 *              </ng-template>
 *          </kendo-gantt>
 *      `
 * })
 * class AppComponent {
 *     public data: any[] = sampleTasks;
 * }
 * ```
 */
let GanttTaskTooltipTemplateDirective = /*#__PURE__*/(() => {
  class GanttTaskTooltipTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function GanttTaskTooltipTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTaskTooltipTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttTaskTooltipTemplateDirective,
      selectors: [["", "kendoGanttTaskTooltipTemplate", ""]],
      standalone: true
    });
  }
  return GanttTaskTooltipTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 *
 * Needed to keep the Gantt's LocalizationService reference and be able to use it component's inside the TabStrip
 */
let GanttLocalizationService = /*#__PURE__*/(() => {
  class GanttLocalizationService {
    localizationService;
    constructor(localizationService) {
      this.localizationService = localizationService;
    }
    get(token) {
      return this.localizationService.get(token);
    }
    static ɵfac = function GanttLocalizationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttLocalizationService)(i0.ɵɵinject(i1$1.LocalizationService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GanttLocalizationService,
      factory: GanttLocalizationService.ɵfac
    });
  }
  return GanttLocalizationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let GanttTimelineComponent = /*#__PURE__*/(() => {
  class GanttTimelineComponent {
    scrollSyncService;
    dependencyDomService;
    renderer;
    zone;
    currentTimeMarkerService;
    localization;
    taskDragService;
    /**
     * Represents the scrollable container of the timeline content.
     * Used externally by the DependencyDragCreateDirective.
     */
    timelineContent;
    timelineColumns;
    timelineHeaderWrap;
    tasksContainer;
    tooltip;
    /**
     * Represents the view container ref used for rendering the dependency drag popop.
     * Used externally by the DependencyDragCreateDirective.
     */
    dragPopupContainer;
    /**
     * Represents the polyline element used for rendering the dependency drag editing interaction.
     * Used externally by the DependencyDragCreateDirective.
     */
    dependencyDragCreatePolyline;
    rows;
    slots;
    groupSlots;
    tableWidth;
    activeView;
    taskContentTemplate;
    taskTemplate;
    summaryTaskTemplate;
    taskClass;
    renderDependencyDragClues;
    dragScrollSettings;
    currentTimeMarker;
    customTooltipTemplate;
    tooltipOptions;
    selectable;
    isTaskSelected;
    isExpanded;
    dependencies = [];
    // as all drag-and-drop operations are on the timeline container, use a single draggable instance
    timelineContainerPress = new EventEmitter();
    timelineContainerDrag = new EventEmitter();
    timelineContainerRelease = new EventEmitter();
    /**
     * Specifies whether the draggable will attach or detach its pointer event listeners.
     */
    get draggableEnabled() {
      return this.renderDependencyDragClues;
    }
    task;
    dragResult;
    dragging = false;
    completion = false;
    marquee = {
      show: false,
      left: 0,
      width: 0
    };
    dragOffset;
    subscriptions = new Subscription();
    popupRef;
    constructor(scrollSyncService, dependencyDomService, renderer, zone, currentTimeMarkerService, localization, taskDragService) {
      this.scrollSyncService = scrollSyncService;
      this.dependencyDomService = dependencyDomService;
      this.renderer = renderer;
      this.zone = zone;
      this.currentTimeMarkerService = currentTimeMarkerService;
      this.localization = localization;
      this.taskDragService = taskDragService;
      this.subscriptions.add(
      // task changes indicates change in row content, number, height, etc.
      this.dependencyDomService.taskChanges.pipe(filter(args => isPresent(args.timelineRow)), switchMap(args => this.zone.onStable.pipe(take(1), map(() => args))) // ensure the content is rendered
      ).subscribe(({
        timelineRow
      }) => {
        const timelineRowHeight = isDocumentAvailable() ? timelineRow.getBoundingClientRect().height : 0;
        this.currentTimeMarkerService.rowHeight = timelineRowHeight;
        this.currentTimeMarkerService.currentTimeMarker = this.currentTimeMarker;
        this.currentTimeMarkerService.slots = this.slots;
        this.currentTimeMarkerService.rows = this.rows;
        this.currentTimeMarkerService.activeView = this.activeView;
        this.createTimeMarker();
        this.renderer.setStyle(this.timelineColumns.nativeElement, 'height', `${(this.rows || []).length * timelineRowHeight}px`);
      }));
      if (!taskDragService) {
        return;
      }
      this.subscriptions.add(taskDragService.dragStart.subscribe(e => {
        if (e.dragTarget.classList.contains('k-task-draghandle')) {
          this.completion = true;
          const taskRect = this.taskDragService.currentDragTaskRect;
          this.tooltip.position = 'top';
          this.tooltip.callout = true;
          this.tooltip.offset = taskRect.height + 6;
          this.tooltip.collision = {
            horizontal: 'fit',
            vertical: 'fit'
          };
        } else {
          this.dragging = true;
        }
      }));
      this.subscriptions.add(taskDragService.drag.subscribe(e => {
        this.dragResult = {
          start: e.start,
          end: e.end,
          completionRatio: e.completionRatio
        };
        if (this.completion) {
          const dragHandle = e.dragEvent.dragTarget;
          this.tooltip.show(dragHandle);
        } else {
          this.marquee.show = true;
          this.marquee.left = e.offset;
          this.marquee.width = e.width;
          const taskEl = this.taskDragService.currentDragTask.taskElement;
          const taskRect = this.taskDragService.currentDragTaskRect;
          this.tooltip.hide();
          this.tooltip.position = this.taskDragService.rightDragHandle ? 'right' : 'left';
          this.tooltip.collision = {
            horizontal: 'fit',
            vertical: 'fit'
          };
          this.tooltip.show(taskEl);
          this.popupRef = this.tooltip.popupRef;
          const popup = this.popupRef?.popup.instance;
          const popupEl = popup?.container.nativeElement;
          const popupHeight = popupEl?.offsetHeight ?? 0;
          const popupWidth = popupEl?.offsetWidth ?? 0;
          const taskMove = !(this.taskDragService.leftDragHandle || this.taskDragService.rightDragHandle);
          this.popupRef && (this.popupRef.popupElement.style.zIndex += 1000000);
          this.popupRef && (popup.margin = {
            horizontal: taskMove ? taskRect.left - e.offset - this.taskDragService.tasksContainerRect.left - popupWidth / 2 : e.width - taskEl.nativeElement.clientWidth - popupWidth / 2,
            vertical: (taskEl.nativeElement.clientHeight + popupHeight) / 2
          });
        }
      }));
      this.subscriptions.add(taskDragService.dragEnd.subscribe(() => {
        this.marquee = {
          show: false,
          left: 0,
          width: 0
        };
        this.dragging = this.completion = false;
        this.tooltip.hide();
        this.dragResult = null;
        this.tooltip.position = this.tooltipOptions.position;
        this.tooltip.offset = 6;
      }));
    }
    ngOnChanges(changes) {
      if (changes['currentTimeMarker']) {
        this.createTimeMarker();
      }
    }
    ngAfterViewInit() {
      this.currentTimeMarkerService.slots = this.slots;
      this.currentTimeMarkerService.rows = this.rows;
      this.currentTimeMarkerService.container = this.timelineContent;
      const timelineHeader = this.timelineHeaderWrap.nativeElement;
      const rightContainer = this.timelineContent.nativeElement;
      this.scrollSyncService.registerElement(rightContainer, 'timeline');
      this.scrollSyncService.registerElement(timelineHeader, 'header');
      this.dependencyDomService.registerContentContainer(this.tasksContainer.nativeElement);
      if (this.taskDragService) {
        this.zone.onStable.pipe(take(1)).subscribe(() => {
          this.taskDragService.tasksContainer = this.tasksContainer.nativeElement;
          this.taskDragService.scrollableContainer = this.tasksContainer.nativeElement.closest('.k-grid-content');
          this.taskDragService.tasksContainerRect = this.tasksContainer.nativeElement.getBoundingClientRect();
        });
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    isNonWorking(item) {
      return item.hasOwnProperty('isWorking') && !item.isWorking;
    }
    messageFor(token) {
      return this.localization.get(token);
    }
    createTimeMarker() {
      this.zone.runOutsideAngular(() => {
        this.currentTimeMarkerService.removeTimeMarker();
        if (typeof this.currentTimeMarker === 'boolean' && this.currentTimeMarker || this.currentTimeMarker?.enabled) {
          this.currentTimeMarkerService.createTimeMarker();
        }
      });
    }
    static ɵfac = function GanttTimelineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTimelineComponent)(i0.ɵɵdirectiveInject(ScrollSyncService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(CurrentTimeMarkerService), i0.ɵɵdirectiveInject(GanttLocalizationService), i0.ɵɵdirectiveInject(TaskDragService, 8));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttTimelineComponent,
      selectors: [["kendo-gantt-timeline"]],
      viewQuery: function GanttTimelineComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c7, 7);
          i0.ɵɵviewQuery(_c8, 7);
          i0.ɵɵviewQuery(_c9, 7);
          i0.ɵɵviewQuery(_c10, 7);
          i0.ɵɵviewQuery(TooltipDirective, 5);
          i0.ɵɵviewQuery(_c11, 5, ViewContainerRef);
          i0.ɵɵviewQuery(_c12, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timelineContent = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timelineColumns = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timelineHeaderWrap = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tasksContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragPopupContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dependencyDragCreatePolyline = _t.first);
        }
      },
      inputs: {
        rows: "rows",
        slots: "slots",
        groupSlots: "groupSlots",
        tableWidth: "tableWidth",
        activeView: "activeView",
        taskContentTemplate: "taskContentTemplate",
        taskTemplate: "taskTemplate",
        summaryTaskTemplate: "summaryTaskTemplate",
        taskClass: "taskClass",
        renderDependencyDragClues: "renderDependencyDragClues",
        dragScrollSettings: "dragScrollSettings",
        currentTimeMarker: "currentTimeMarker",
        customTooltipTemplate: "customTooltipTemplate",
        tooltipOptions: "tooltipOptions",
        selectable: "selectable",
        isTaskSelected: "isTaskSelected",
        isExpanded: "isExpanded",
        dependencies: "dependencies"
      },
      outputs: {
        timelineContainerPress: "timelineContainerPress",
        timelineContainerDrag: "timelineContainerDrag",
        timelineContainerRelease: "timelineContainerRelease"
      },
      standalone: true,
      features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 38,
      vars: 34,
      consts: [["timelineHeaderWrap", ""], ["timelineContent", ""], ["timelineColumns", ""], ["tooltip", "kendoTooltip", "tasksContainer", ""], ["tooltipTemplate", ""], ["customTooltip", ""], ["resizingTooltip", ""], ["completionRatioTooltip", ""], ["dependencyDragCreatePolyline", ""], ["dragPopupContainer", ""], [1, "k-gantt-timeline", "k-grid", "k-grid-md"], [1, "k-grid-header"], [1, "k-grid-header-wrap"], ["role", "presentation", 1, "k-table", "k-table-md", "k-grid-header-table"], ["kendoGanttHeaderTableBody", "", 3, "groupSlots", "slots"], ["tabindex", "-1", "role", "tree", "aria-roledescription", "Timeline", "kendoGanttTimelineScrollable", "", "kendoDraggable", "", 1, "k-grid-content", 3, "kendoPress", "kendoDrag", "kendoRelease", "scrollSettings", "enableDrag"], [1, "k-gantt-tables"], ["role", "presentation", 1, "k-table", "k-table-md", "k-grid-table", "k-gantt-rows"], [1, "k-table-tbody"], [3, "class", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "k-table", "k-table-md", "k-gantt-columns"], [4, "ngFor", "ngForOf"], [1, "k-table-row"], ["class", "k-table-td", 3, "k-nonwork-hour", 4, "ngFor", "ngForOf"], ["kendoTooltip", "", "filter", ".k-task", "role", "presentation", 1, "k-table", "k-table-md", "k-gantt-tasks", 3, "tooltipTemplate", "position", "callout", "tooltipClass", "showOn"], ["kendoGanttTasksTableBody", "", 1, "k-table-tbody", 3, "taskPointerEnter", "taskPointerLeave", "rows", "activeView", "taskContentTemplate", "taskTemplate", "summaryTaskTemplate", "taskClass", "isExpanded", "selectable", "isTaskSelected", "renderDependencyDragClues"], [1, "k-gantt-dependencies-svg"], ["kendoGanttDependency", "", 3, "dependency", 4, "ngFor", "ngForOf"], ["class", "k-marquee k-gantt-marquee", 3, "style", 4, "ngIf"], [1, "k-table-td"], [1, "k-task-content"], [1, "k-task-details"], [1, "k-task-pct"], [1, "k-reset"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "k-tooltip-content"], ["kendoGanttDependency", "", 3, "dependency"], [1, "k-marquee", "k-gantt-marquee"], [1, "k-marquee-color"]],
      template: function GanttTimelineComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 12, 0)(4, "table", 13);
          i0.ɵɵelement(5, "tbody", 14);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "div", 15, 1);
          i0.ɵɵlistener("kendoPress", function GanttTimelineComponent_Template_div_kendoPress_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.timelineContainerPress.emit($event));
          })("kendoDrag", function GanttTimelineComponent_Template_div_kendoDrag_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.timelineContainerDrag.emit($event));
          })("kendoRelease", function GanttTimelineComponent_Template_div_kendoRelease_6_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.timelineContainerRelease.emit($event));
          });
          i0.ɵɵelementStart(8, "div", 16)(9, "table", 17)(10, "tbody", 18);
          i0.ɵɵtemplate(11, GanttTimelineComponent_tr_11_Template, 2, 3, "tr", 19);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(12, "table", 20, 2)(14, "colgroup");
          i0.ɵɵtemplate(15, GanttTimelineComponent_col_15_Template, 1, 0, "col", 21);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "tbody", 18)(17, "tr", 22);
          i0.ɵɵtemplate(18, GanttTimelineComponent_td_18_Template, 1, 2, "td", 23);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(19, "table", 24, 3)(22, "tbody", 25);
          i0.ɵɵlistener("taskPointerEnter", function GanttTimelineComponent_Template_tbody_taskPointerEnter_22_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.task = $event);
          })("taskPointerLeave", function GanttTimelineComponent_Template_tbody_taskPointerLeave_22_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.task = null);
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(23, GanttTimelineComponent_ng_template_23_Template, 14, 15, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(25, GanttTimelineComponent_ng_template_25_Template, 1, 5, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(27, GanttTimelineComponent_ng_template_27_Template, 7, 10, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(29, GanttTimelineComponent_ng_template_29_Template, 4, 4, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(31, "svg", 26);
          i0.ɵɵtemplate(32, GanttTimelineComponent__svg_polyline_32_Template, 1, 1, "polyline", 27);
          i0.ɵɵelement(33, "polyline", null, 8);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(35, GanttTimelineComponent_div_35_Template, 2, 5, "div", 28);
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementContainer(36, null, 9);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const tooltipTemplate_r7 = i0.ɵɵreference(24);
          const customTooltip_r8 = i0.ɵɵreference(26);
          const resizingTooltip_r9 = i0.ɵɵreference(28);
          const completionRatioTooltip_r10 = i0.ɵɵreference(30);
          i0.ɵɵadvance(4);
          i0.ɵɵstyleProp("width", ctx.tableWidth, "px");
          i0.ɵɵadvance();
          i0.ɵɵproperty("groupSlots", ctx.groupSlots)("slots", ctx.slots);
          i0.ɵɵadvance();
          i0.ɵɵproperty("scrollSettings", ctx.dragScrollSettings)("enableDrag", ctx.draggableEnabled);
          i0.ɵɵadvance(3);
          i0.ɵɵstyleProp("width", ctx.tableWidth, "px");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.rows);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("width", ctx.tableWidth, "px");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.slots);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.slots);
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("border-collapse", "collapse")("width", ctx.tableWidth, "px");
          i0.ɵɵproperty("tooltipTemplate", ctx.completion ? completionRatioTooltip_r10 : ctx.dragging ? resizingTooltip_r9 : ctx.customTooltipTemplate ? customTooltip_r8 : tooltipTemplate_r7)("position", ctx.tooltipOptions.position)("callout", !ctx.dragging)("tooltipClass", ctx.dragging ? "k-gantt-resize-hint" : undefined)("showOn", ctx.dragging || ctx.completion ? "none" : "hover");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("rows", ctx.rows)("activeView", ctx.activeView)("taskContentTemplate", ctx.taskContentTemplate)("taskTemplate", ctx.taskTemplate)("summaryTaskTemplate", ctx.summaryTaskTemplate)("taskClass", ctx.taskClass)("isExpanded", ctx.isExpanded)("selectable", ctx.selectable)("isTaskSelected", ctx.isTaskSelected)("renderDependencyDragClues", ctx.renderDependencyDragClues);
          i0.ɵɵadvance(10);
          i0.ɵɵproperty("ngForOf", ctx.dependencies);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.marquee.show);
        }
      },
      dependencies: [GanttHeaderTableBodyComponent, TimelineScrollableDirective, DraggableDirective, NgFor, GanttTasksTableBodyComponent, GanttDependencyDirective, i6.TooltipDirective, NgIf, DatePipe, NumberPipe, NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return GanttTimelineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The base class for the column components of the Gantt.
 */
let GanttColumnBase = /*#__PURE__*/(() => {
  class GanttColumnBase extends ColumnBase {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵGanttColumnBase_BaseFactory;
      return function GanttColumnBase_Factory(__ngFactoryType__) {
        return (ɵGanttColumnBase_BaseFactory || (ɵGanttColumnBase_BaseFactory = i0.ɵɵgetInheritedFactory(GanttColumnBase)))(__ngFactoryType__ || GanttColumnBase);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttColumnBase,
      selectors: [["kendo-gantt-column-base"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function GanttColumnBase_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return GanttColumnBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the column cell template of the Gantt.
 * Helps to customize the content of the cells. To define the cell template, nest an `<ng-template>` tag
 * with the `kendoGanttCellTemplate` directive inside the respective column tag.
 *
 * The template context is set to the current data item and the following additional fields are passed:
 * - `dataItem`&mdash;The current data item. Represents the default context that will be assigned to any template variable which utilizes the `let-x` syntax&mdash;for example, `let-dataItem`.
 * - `columnIndex`&mdash;The current column index. Use it as an alias for a template variable by utilizing the `let-columnIndex="columnIndex"` syntax.
 * - `column`&mdash;The current column instance. Use it as an alias for a template variable by utilizing the `let-column="column"` syntax.
 * - `cellContext`&mdash;An object used to pass context information to built-in directives.
 * - `hasChildren`&mdash;Specifies if the item has children.
 * - `isExpanded`&mdash;Specifies if the item is expanded.
 * - `level`&mdash;The hierarchy level of the item.
 * - `loading`&mdash;Specifies if the item children are currently loading.
 * - `rowIndex`&mdash;The current row index. Use it as an alias for a template variable by utilizing the `let-rowIndex="rowIndex"` syntax.
 */
let CellTemplateDirective = /*#__PURE__*/(() => {
  class CellTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function CellTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CellTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CellTemplateDirective,
      selectors: [["", "kendoGanttCellTemplate", ""]],
      standalone: true
    });
  }
  return CellTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the template for the column menu in the Gantt. Provides an option for
 * customizing the content of the column menu for all or for specific columns.
 * To define the content template, nest an `<ng-template>` tag with the
 * `kendoGanttColumnMenuTemplate` directive inside the `<kendo-gantt-column>` component.
 *
 *  The column menu service and the current column are available as context variables:
 * - `service`&mdash;Represents the ColumnMenuService.
 * - `column`&mdash;Represents the Gantt column.
 */
let ColumnMenuTemplateDirective = /*#__PURE__*/(() => {
  class ColumnMenuTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function ColumnMenuTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColumnMenuTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ColumnMenuTemplateDirective,
      selectors: [["", "kendoGanttColumnMenuTemplate", ""]],
      standalone: true
    });
  }
  return ColumnMenuTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 * Represents the filter-cell template.
 *
 * The template context is set to the filter descriptor and the following additional fields are passed:
 * - `column`&mdash;The current column instance. Use it as an alias for a template variable by utilizing the `let-column="column"` syntax.
 * - `filter`&mdash;The filter descriptor.
 * - `cellContext`&mdash;An object used to pass context information to built-in directives.
 */
let FilterCellTemplateDirective = /*#__PURE__*/(() => {
  class FilterCellTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function FilterCellTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterCellTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FilterCellTemplateDirective,
      selectors: [["", "kendoGanttFilterCellTemplate", ""]],
      standalone: true
    });
  }
  return FilterCellTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the filter-menu template.
 *
 * The column, current filter and the filter service are available as context variables:
 * - `column`&mdash;The current column instance. Use it as an alias for a template variable by utilizing the `let-column="column"` syntax.
 * - `filter`&mdash;The filter descriptor.
 * - `cellContext`&mdash;An object used to pass context information to built-in directives.
 */
let FilterMenuTemplateDirective = /*#__PURE__*/(() => {
  class FilterMenuTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function FilterMenuTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilterMenuTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FilterMenuTemplateDirective,
      selectors: [["", "kendoGanttFilterMenuTemplate", ""]],
      standalone: true
    });
  }
  return FilterMenuTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the column footer cell template of the Gantt.
 *
 * Helps to customize the table footer cell for the column.
 * To define a footer template, nest an `<ng-template>` tag with the
 * [`kendoGanttFooterTemplate`]({% slug api_gantt_footertemplatedirective %}) directive inside the `<kendo-gantt-column>` tag.
 *
 *  The current column, column index and field are available as context variables:
 * * `column`&mdash;Points to the instance of the current [`ColumnComponent`]({% slug api_gantt_ganttcolumncomponent %}).
 * * `columnIndex`&mdash;Defines the current column index.
 * * `field`&mdash;The name of the column field, if set.
 */
let FooterTemplateDirective = /*#__PURE__*/(() => {
  class FooterTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function FooterTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FooterTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FooterTemplateDirective,
      selectors: [["", "kendoGanttFooterTemplate", ""]],
      standalone: true
    });
  }
  return FooterTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the column header cell template of the Gantt.
 * Helps to customize the table header cell for the column.
 * To define a header template, nest an `<ng-template>` tag with the
 * [`kendoGanttHeaderTemplate`]({% slug api_gantt_headertemplatedirective %}) directive inside the `<kendo-gantt-column>` tag.
 *
 *  The current column and column index are available as context variables:
 * * `column`&mdash;Points to the instance of the current [`ColumnComponent`]({% slug api_gantt_ganttcolumncomponent %}).
 * * `columnIndex`&mdash;Defines the current column index.
 */
let HeaderTemplateDirective = /*#__PURE__*/(() => {
  class HeaderTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function HeaderTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: HeaderTemplateDirective,
      selectors: [["", "kendoGanttHeaderTemplate", ""]],
      standalone: true
    });
  }
  return HeaderTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the column edit-cell template of the Gantt.
 * Helps to customize the content of the edited cells. To define the cell template, nest an `<ng-template>`
 * tag with the `kendoGanttEditTemplate` directive inside a `<kendo-gantt-column>` tag.
 *
 * The template context contains the following fields:
 * - `column`&mdash;The current column instance.
 * - `dataItem`&mdash;The current data item.
 * - `cellContext`&mdash;An object used to pass context information to built-in directives.
 * - `formGroup`&mdash;The current [`FormGroup`](link:site.data.urls.angular['formgroupapi']).
 * If you use the Gantt inside [Template-Driven Forms](link:site.data.urls.angular['forms']), it will be `undefined`.
 * - `isNew`&mdash;The state of the current item.
 * - `rowIndex`&mdash;The current row index. If inside a new item row, `rowIndex` is `-1`.
 */
let EditTemplateDirective = /*#__PURE__*/(() => {
  class EditTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function EditTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EditTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: EditTemplateDirective,
      selectors: [["", "kendoGanttEditTemplate", ""]],
      standalone: true
    });
  }
  return EditTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GanttColumnComponent = /*#__PURE__*/(() => {
  class GanttColumnComponent extends ColumnComponent {
    options;
    headerTemplates = new QueryList();
    footerTemplate;
    columnMenuTemplates = new QueryList();
    template;
    editTemplate;
    filterCellTemplate;
    filterMenuTemplate;
    /**
     * Defines the filter type that is displayed inside the filter row. The default value is `text`.
     */
    filter = 'text';
    /**
     * Defines if a filter UI will be displayed for this column. The default value is `true`.
     */
    filterable = true;
    /**
     * @hidden
     *
     * Defines the editor type.
     * Used when the column enters the edit mode. The default value is `text`.
     */
    editor = 'text';
    /**
     * @hidden
     *
     * Defines whether the column is editable. The default value is `true`.
     */
    editable = true;
    constructor(options, parent) {
      super(parent);
      this.options = options;
    }
    ngOnChanges() {
      this.options.notifyColumnChanges();
    }
    static ɵfac = function GanttColumnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttColumnComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(GanttColumnBase, 13));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttColumnComponent,
      selectors: [["kendo-gantt-column"]],
      contentQueries: function GanttColumnComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, FooterTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, CellTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, EditTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, FilterCellTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, FilterMenuTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, HeaderTemplateDirective, 4);
          i0.ɵɵcontentQuery(dirIndex, ColumnMenuTemplateDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterCellTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterMenuTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplates = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnMenuTemplates = _t);
        }
      },
      inputs: {
        filter: "filter",
        filterable: "filterable",
        editor: "editor",
        editable: "editable"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttColumnBase,
        useExisting: forwardRef(() => GanttColumnComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function GanttColumnComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return GanttColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GanttColumnGroupComponent = /*#__PURE__*/(() => {
  class GanttColumnGroupComponent extends ColumnGroupComponent {
    options;
    /**
     * @hidden
     */
    children = new QueryList();
    /**
     * @hidden
     */
    headerTemplates;
    constructor(options, parent) {
      super(parent);
      this.options = options;
      if (parent && parent.isSpanColumn) {
        throw new Error('ColumnGroupComponent cannot be nested inside SpanColumnComponent');
      }
    }
    ngOnChanges() {
      this.options.notifyColumnChanges();
    }
    static ɵfac = function GanttColumnGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttColumnGroupComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(GanttColumnBase, 13));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttColumnGroupComponent,
      selectors: [["kendo-gantt-column-group"]],
      contentQueries: function GanttColumnGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, GanttColumnBase, 4);
          i0.ɵɵcontentQuery(dirIndex, HeaderTemplateDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplates = _t);
        }
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttColumnBase,
        useExisting: forwardRef(() => GanttColumnGroupComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function GanttColumnGroupComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return GanttColumnGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GanttSpanColumnComponent = /*#__PURE__*/(() => {
  class GanttSpanColumnComponent extends SpanColumnComponent {
    options;
    /**
     * @hidden
     */
    childColumns = new QueryList();
    template = new QueryList();
    editTemplate = new QueryList();
    constructor(options, parent) {
      super(parent);
      this.options = options;
    }
    ngOnChanges() {
      this.options.notifyColumnChanges();
    }
    static ɵfac = function GanttSpanColumnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttSpanColumnComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(GanttColumnBase, 13));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttSpanColumnComponent,
      selectors: [["kendo-gantt-span-column"]],
      contentQueries: function GanttSpanColumnComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, GanttColumnComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, CellTemplateDirective, 4);
          i0.ɵɵcontentQuery(dirIndex, EditTemplateDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childColumns = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editTemplate = _t);
        }
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: GanttColumnBase,
        useExisting: forwardRef(() => GanttSpanColumnComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function GanttSpanColumnComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return GanttSpanColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
const hasChildren = () => false;
/**
 * @hidden
 */
const fetchChildren = () => of([]);
/**
 * @hidden
 */
const rowClassCallback = () => null;
/**
 * @hidden
 */
const taskClassCallback = () => null;
/**
 * @hidden
 */
const isSelected = () => false;

/**
 * Called every time a user leaves an edited cell.
 */
class CellCloseEvent extends PreventableEvent {
  /**
   * The data item.
   */
  dataItem;
  /**
   * Indicates if the data item is new or existing.
   */
  isNew;
  /**
   * The Gantt column that will be closed.
   */
  column;
  /**
   * The [`FormGroup`](link:site.data.urls.angular['formgroupapi']) that is used to edit the cell which will be closed.
   */
  formGroup;
  /**
   * The DOM event that caused the `cellClose` event.
   * May not be present if `cellClose` was caused by an API call.
   */
  originalEvent;
  /**
   * The `GanttComponent` instance.
   */
  sender;
  /**
   * The `TaskEditItem` associated with the edited task.
   * The parent item is accessible through the `parent` property,
   * and allows traversing all ancestors that need to be updated.
   */
  item;
  constructor(options) {
    super();
    Object.assign(this, options);
  }
}

/**
 * @hidden
 */
const DEFAULT_TREELIST_PANE_SETTINGS = Object.freeze({
  collapsible: true,
  collapsed: false
});
/**
 * @hidden
 */
const DEFAULT_TIMELINE_PANE_SETTINGS = Object.freeze({
  collapsible: true,
  collapsed: false,
  size: '50%',
  resizable: true
});

/**
 * Represents a template that defines the whole content of the task component.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoGanttTaskTemplate` directive inside the `<kendo-gantt>` tag.
 *
 * The template context is set to the current data item. The following additional field is passed:
 * - `elementWidth`&mdash;The current task wrapper element's calculated width in pixels based on its start and end date.
 * Use it as an alias for a template variable by utilizing the `let-elementWidth="elementWidth"` syntax.
 * Useful for calculations related to rendering custom elements representing the task progress.
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-gantt [kendoGanttHierarchyBinding]="data">
 *            <ng-template kendoGanttTaskTemplate let-dataItem let-elementWidth="elementWidth">
 *                {{ dataItem.title }} - {{ dataItem.completionRatio * 100 }}% complete
 *            </ng-template>
 *        </kendo-gantt>
 *    `
 * })
 * class AppComponent {
 *    public data: any[] = sampleTasks;
 * }
 * ```
 */
let GanttTaskTemplateDirective = /*#__PURE__*/(() => {
  class GanttTaskTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function GanttTaskTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTaskTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttTaskTemplateDirective,
      selectors: [["", "kendoGanttTaskTemplate", ""]],
      standalone: true
    });
  }
  return GanttTaskTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents a template that defines the whole content of the summary task component.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoGanttSummaryTaskTemplate` directive inside the `<kendo-gantt>` tag.
 *
 * The template context is set to the current data item. The following additional field is passed:
 * - `elementWidth`&mdash;The current summary task wrapper element's calculated width in pixels based on its start and end date.
 * Use it as an alias for a template variable by utilizing the `let-elementWidth="elementWidth"` syntax.
 * Useful for calculations related to rendering custom elements representing the task progress.
 *
 * @example
 * ```ts-preview
 * _@Component({
 *      selector: 'my-app',
 *      template: `
 *          <kendo-gantt [kendoGanttHierarchyBinding]="data">
 *              <ng-template kendoGanttSummaryTaskTemplate let-dataItem let-elementWidth="elementWidth">
 *                  <div [style]="'color: white; font-size: 8px;'">
 *                      {{ dataItem.title }} - {{ dataItem.completionRatio * 100 }}% complete; width: {{ elementWidth }}
 *                  </div>
 *              </ng-template>
 *          </kendo-gantt>
 *      `
 * })
 * class AppComponent {
 *     public data: any[] = sampleTasks;
 * }
 * ```
 */
let GanttSummaryTaskTemplateDirective = /*#__PURE__*/(() => {
  class GanttSummaryTaskTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function GanttSummaryTaskTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttSummaryTaskTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttSummaryTaskTemplateDirective,
      selectors: [["", "kendoGanttSummaryTaskTemplate", ""]],
      standalone: true
    });
  }
  return GanttSummaryTaskTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents a template that defines the text content section of the task component.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoGanttTaskContentTemplate` directive inside the `<kendo-gantt>` tag.
 *
 * The template context is set to the current data item.
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-gantt [kendoGanttHierarchyBinding]="data">
 *            <ng-template kendoGanttTaskContentTemplate let-dataItem>
 *                {{ dataItem.title }} - {{ dataItem.completionRatio * 100 }}% complete
 *            </ng-template>
 *        </kendo-gantt>
 *    `
 * })
 * class AppComponent {
 *    public data: any[] = sampleTasks;
 * }
 * ```
 */
let GanttTaskContentTemplateDirective = /*#__PURE__*/(() => {
  class GanttTaskContentTemplateDirective {
    templateRef;
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function GanttTaskContentTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttTaskContentTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttTaskContentTemplateDirective,
      selectors: [["", "kendoGanttTaskContentTemplate", ""]],
      standalone: true
    });
  }
  return GanttTaskContentTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Represents the toolbar template of the Gantt.
 *
 * The template context has the following field:
 * - `position`&mdash;The position at which the toolbar template is rendered. The possible values are `'top'` and `'bottom'`.
 *
 * @example
 * ```ts-preview
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *       <div class="example-config">
 *         <input type="radio" kendoRadioButton id="top" name="position" value="top" checked (click)="positionChange($event)"/>
 *         <kendo-label class="k-radio-label" for="top">Top</kendo-label><br/>
 *         <input type="radio" kendoRadioButton id="bottom" name="position" value="bottom" (click)="positionChange($event)"/>
 *         <kendo-label class="k-radio-label" for="bottom">Bottom</kendo-label><br/>
 *         <input type="radio" kendoRadioButton id="both" name="position" value="both" (click)="positionChange($event)"/>
 *         <kendo-label class="k-radio-label" for="both">Both</kendo-label><br/>
 *       </div>
 *       <kendo-gantt [[kendoGanttHierarchyBinding]="data"]="data" [style.height.px]="400">
 *            <ng-template kendoGanttToolbarTemplate [position]="position" let-position="position">
 *                <button kendoButton (click)="onClick()">Custom action</button>
 *            </ng-template>
 *        </kendo-gantt>
 *     `
 * })
 *
 * class AppComponent {
 *     public position: 'top' | 'bottom' | 'both' = 'top';
 *
 *     public data = [{
 *       id: 7,
 *       title: "Software validation, research and implementation",
 *       orderId: 0,
 *       start: new Date("2014-06-02T00:00:00.000Z"),
 *       end: new Date("2014-07-12T00:00:00.000Z"),
 *       completionRatio: 0.45708333333333334,
 *       isExpanded: true,
 *       children: [{
 *               id: 11,
 *               title: "Research",
 *               orderId: 1,
 *               start: new Date("2014-06-02T00:00:00.000Z"),
 *               end: new Date("2014-06-07T00:00:00.000Z"),
 *               completionRatio: 0.5766666666666667,
 *               isExpanded: true,
 *               children: [{
 *                       id: 19,
 *                       title: "Validation with Customers",
 *                       orderId: 0,
 *                       start: new Date("2014-06-02T00:00:00.000Z"),
 *                       end: new Date("2014-06-04T00:00:00.000Z"),
 *                       completionRatio: 0.25,
 *                       isExpanded: true
 *                   },
 *                   {
 *                       id: 20,
 *                       title: "Market Research",
 *                       orderId: 1,
 *                       start: new Date("2014-06-02T00:00:00.000Z"),
 *                       end: new Date("2014-06-03T02:00:00.000Z"),
 *                       completionRatio: 0.82,
 *                       isExpanded: true
 *                   },
 *                   {
 *                       id: 39,
 *                       title: "Functional and Technical Specification",
 *                       orderId: 2,
 *                       start: new Date("2014-06-04T00:00:00.000Z"),
 *                       end: new Date("2014-06-07T00:00:00.000Z"),
 *                       completionRatio: 0.66,
 *                       isExpanded: true
 *                   }]
 *           }]
 *       };
 *
 *     public positionChange(event: MouseEvent): void {
 *        this.position = event.target['defaultValue'];
 *     }
 *
 *     public onClick(): void {
 *         console.log("button was clicked");
 *     }
 * }
 *
 * ```
 */
let ToolbarTemplateDirective = /*#__PURE__*/(() => {
  class ToolbarTemplateDirective {
    templateRef;
    _position = "top";
    /**
     * Defines the Gantt Toolbar that will use this template.
     *
     * The possible values are:
     * - `top`&mdash;The template will be rendered in the top toolbar (if present) only.
     * - `bottom`&mdash;The template will be rendered in the bottom toolbar (if present) only.
     * - `both`&mdash;The template will be rendered in both toolbars (if present).
     */
    set position(position) {
      this._position = position;
    }
    get position() {
      return this._position;
    }
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static ɵfac = function ToolbarTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToolbarTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ToolbarTemplateDirective,
      selectors: [["", "kendoGanttToolbarTemplate", ""]],
      inputs: {
        position: "position"
      },
      standalone: true
    });
  }
  return ToolbarTemplateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The base class for the timeline view components of the Gantt.
 */
let ViewBase = /*#__PURE__*/(() => {
  class ViewBase {
    optionChangesService;
    dependencyDomService;
    /**
     * The width of the time slot headers. Values are treated as pixels.
     *
     * @default 100
     */
    slotWidth = 100;
    /**
     * Sets the date format for the Grouped and Column headers.
     */
    timelineHeadersDateFormat;
    /**
     * Specifies the current time marker settings.
     * If not set, the value is taken from the Gantt component
     * [`currentTimeMarker`]({% slug api_gantt_ganttcomponent %}#toc-currentTimeMarker) property.
     *
     */
    currentTimeMarker;
    /**
     *
     * @hidden
     */
    constructor(optionChangesService, dependencyDomService) {
      this.optionChangesService = optionChangesService;
      this.dependencyDomService = dependencyDomService;
    }
    ngOnChanges(changes) {
      if (anyChanged(['slotWidth'], changes)) {
        this.optionChangesService.notifyColumnChanges();
        this.dependencyDomService.notifyChanges();
      }
      if (anyChanged(['timelineHeadersDateFormat'], changes)) {
        this.optionChangesService.notifyDateFormatChanges();
      }
    }
    static ɵfac = function ViewBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewBase)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ViewBase,
      selectors: [["kendo-gantt-view-base"]],
      inputs: {
        slotWidth: "slotWidth",
        timelineHeadersDateFormat: "timelineHeadersDateFormat",
        currentTimeMarker: "currentTimeMarker"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return ViewBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
const getEditItem = (dataItem, data, mapper) => {
  const treeListDataItem = data.find(item => mapper.extractFromTask(item.data, 'id') === mapper.extractFromTask(dataItem, 'id'));
  return mapPath(treeListDataItem);
};
const mapPath = item => ({
  dataItem: item.data,
  parent: item.parent.data ? mapPath(item.parent) : null
});

/**
 * @hidden
 */
let DependenciesTableComponent = /*#__PURE__*/(() => {
  class DependenciesTableComponent {
    mapper;
    editService;
    localizationService;
    // TODO: should consist of only valid connection tasks
    tasks;
    dependencies;
    dependencyType;
    dependenciesChange = new EventEmitter();
    selectedKeys = [];
    formGroups = new FormArray([]);
    dependencyTypes = this.getDependencyTypes();
    plusIcon = plusIcon;
    minusIcon = minusIcon;
    get taskId() {
      return this.editService.dataItem.id;
    }
    // The target dependency id field
    // e.g. if Predecessors, we have the `fromId` which is the currently edited task,
    // while the `toId` is missing (needs to be selected by the user)
    get dependencyIdField() {
      return this.dependencyType === 'predecessor' ? 'fromId' : 'toId';
    }
    constructor(mapper, editService, localizationService) {
      this.mapper = mapper;
      this.editService = editService;
      this.localizationService = localizationService;
    }
    ngOnInit() {
      // generate the FormGroups per each Grid row
      if (this.formGroups.controls.length === 0) {
        const fields = this.mapper.dependencyFields;
        this.dependencies.forEach(item => {
          const formGroup = new FormGroup({
            [fields.id]: new FormControl(this.mapper.extractFromDependency(item, 'id')),
            [fields.fromId]: new FormControl(this.mapper.extractFromDependency(item, 'fromId'), Validators.required),
            [fields.toId]: new FormControl(this.mapper.extractFromDependency(item, 'toId'), Validators.required),
            [fields.type]: new FormControl(this.mapper.extractFromDependency(item, 'type'), Validators.required)
          });
          this.formGroups.push(formGroup);
        });
      }
      this.formGroups.valueChanges.subscribe(val => {
        this.formGroups.controls.forEach(control => {
          if (control.dirty) {
            this.editService.updateDependencies(control.value);
          }
        });
        this.dependenciesChange.emit(val);
      });
    }
    getFormControl(dataItemIndex, field) {
      // return the FormControl for the respective column editor
      return this.formGroups.controls.find((_control, index) => index === dataItemIndex).get(this.mapper.dependencyFields[field]);
    }
    getText(token) {
      return this.localizationService.get(token);
    }
    getDependencyTypes() {
      const types = Object.keys(DependencyType).filter(value => typeof DependencyType[value] === 'number').map(type => {
        return {
          type,
          id: DependencyType[type]
        };
      });
      return types;
    }
    addHandler() {
      const fields = this.mapper.dependencyFields;
      const formGroup = new FormGroup({
        [fields.id]: new FormControl(),
        [fields.fromId]: new FormControl(this.dependencyIdField === 'toId' ? this.taskId : null, Validators.required),
        [fields.toId]: new FormControl(this.dependencyIdField === 'fromId' ? this.taskId : null, Validators.required),
        [fields.type]: new FormControl(null, Validators.required)
      });
      this.formGroups.push(formGroup);
    }
    removeHandler() {
      const [selectedIndex] = this.selectedKeys;
      const item = this.formGroups.at(selectedIndex).value;
      this.editService.deleteDependency(item);
      this.formGroups.removeAt(selectedIndex);
    }
    static ɵfac = function DependenciesTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DependenciesTableComponent)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(GanttLocalizationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DependenciesTableComponent,
      selectors: [["kendo-gantt-dependencies-table"]],
      inputs: {
        tasks: "tasks",
        dependencies: "dependencies",
        dependencyType: "dependencyType"
      },
      outputs: {
        dependenciesChange: "dependenciesChange"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 6,
      vars: 8,
      consts: [["kendoGridSelectBy", "", 3, "selectedKeysChange", "data", "selectable", "selectedKeys", "height"], ["kendoGridToolbarTemplate", ""], [3, "title", "field"], ["kendoGridCellTemplate", ""], ["field", "type", 3, "title"], ["kendoButton", "", "icon", "plus", 3, "click", "svgIcon"], ["kendoButton", "", "icon", "minus", 3, "click", "svgIcon", "disabled"], ["textField", "title", "valueField", "id", 3, "data", "valuePrimitive", "formControl"], ["textField", "type", "valueField", "id", 3, "data", "valuePrimitive", "formControl"]],
      template: function DependenciesTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "kendo-grid", 0);
          i0.ɵɵtwoWayListener("selectedKeysChange", function DependenciesTableComponent_Template_kendo_grid_selectedKeysChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedKeys, $event) || (ctx.selectedKeys = $event);
            return $event;
          });
          i0.ɵɵtemplate(1, DependenciesTableComponent_ng_template_1_Template, 4, 5, "ng-template", 1);
          i0.ɵɵelementStart(2, "kendo-grid-column", 2);
          i0.ɵɵtemplate(3, DependenciesTableComponent_ng_template_3_Template, 1, 3, "ng-template", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "kendo-grid-column", 4);
          i0.ɵɵtemplate(5, DependenciesTableComponent_ng_template_5_Template, 1, 3, "ng-template", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("data", ctx.dependencies)("selectable", i0.ɵɵpureFunction0(7, _c14));
          i0.ɵɵtwoWayProperty("selectedKeys", ctx.selectedKeys);
          i0.ɵɵproperty("height", 275);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("title", ctx.getText("taskEditingDependenciesGridNameColumnTitle"))("field", ctx.dependencyIdField);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("title", ctx.getText("taskEditingDependenciesGridTypeColumnTitle"));
        }
      },
      dependencies: [GridComponent, SelectionDirective, ToolbarTemplateDirective$1, ButtonComponent, ColumnComponent$1, CellTemplateDirective$1, DropDownListComponent, ReactiveFormsModule, i4.NgControlStatus, i4.FormControlDirective],
      encapsulation: 2
    });
  }
  return DependenciesTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let TaskFieldsComponent = /*#__PURE__*/(() => {
  class TaskFieldsComponent {
    mapper;
    editService;
    localizationService;
    constructor(mapper, editService, localizationService) {
      this.mapper = mapper;
      this.editService = editService;
      this.localizationService = localizationService;
    }
    /**
     * @hidden
     */
    get formGroup() {
      return this.editService.taskFormGroup;
    }
    getText(token) {
      return this.localizationService.get(token);
    }
    static ɵfac = function TaskFieldsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TaskFieldsComponent)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(GanttLocalizationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TaskFieldsComponent,
      selectors: [["kendo-gantt-task-fields"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 7,
      vars: 5,
      consts: [["title", ""], ["start", ""], ["end", ""], ["completionRatio", ""], [1, "k-form", "k-form-md", 3, "formGroup"], [4, "ngIf"], [1, "k-hstack"], [3, "width", 4, "ngIf"], [3, "for", "text"], ["kendoTextBox", "", 3, "formControlName"], [3, "formControlName"], ["format", "p2", 3, "formControlName", "min", "max", "decimals", "step"]],
      template: function TaskFieldsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "form", 4);
          i0.ɵɵtemplate(1, TaskFieldsComponent_kendo_formfield_1_Template, 4, 3, "kendo-formfield", 5);
          i0.ɵɵelementStart(2, "div", 6);
          i0.ɵɵtemplate(3, TaskFieldsComponent_kendo_formfield_3_Template, 4, 5, "kendo-formfield", 7);
          i0.ɵɵelement(4, "kendo-treelist-spacer");
          i0.ɵɵtemplate(5, TaskFieldsComponent_kendo_formfield_5_Template, 4, 5, "kendo-formfield", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, TaskFieldsComponent_kendo_formfield_6_Template, 4, 9, "kendo-formfield", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.formGroup.get(ctx.mapper.taskFields.title));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.formGroup.get(ctx.mapper.taskFields.start));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.formGroup.get(ctx.mapper.taskFields.end));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.formGroup.get(ctx.mapper.taskFields.completionRatio));
        }
      },
      dependencies: [ReactiveFormsModule, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, NgIf, FormFieldComponent, LabelComponent, TextBoxDirective, DateTimePickerComponent, TreeListSpacerComponent, NumericTextBoxComponent],
      encapsulation: 2
    });
  }
  return TaskFieldsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let EditDialogComponent = /*#__PURE__*/(() => {
  class EditDialogComponent {
    mapper;
    editService;
    cdr;
    localizationService;
    data;
    loadedTasks;
    saveIcon = saveIcon;
    cancelIcon = cancelOutlineIcon;
    deleteIcon = trashIcon;
    constructor(mapper, editService, cdr, localizationService) {
      this.mapper = mapper;
      this.editService = editService;
      this.cdr = cdr;
      this.localizationService = localizationService;
    }
    ngOnInit() {
      this.editService.loadTasks(this.data).subscribe(value => {
        this.loadedTasks = value;
      });
    }
    get predecessors() {
      return this.editService.predecessors;
    }
    set predecessors(items) {
      this.editService.predecessors = items;
    }
    get successors() {
      return this.editService.successors;
    }
    set successors(items) {
      this.editService.successors = items;
    }
    getText(token) {
      return this.localizationService.get(token);
    }
    getDependencyType(typeId) {
      return DependencyType[typeId];
    }
    handleEditingResult(editResultType) {
      this.editService.triggerEditEvent(editResultType);
    }
    handleTaskDelete() {
      this.editService.taskDelete.next(this.editService.dataItem);
    }
    static ɵfac = function EditDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EditDialogComponent)(i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.LocalizationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: EditDialogComponent,
      selectors: [["kendo-gantt-edit-dialog"]],
      inputs: {
        data: "data"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 17,
      vars: 22,
      consts: [[3, "close", "title", "width", "height", "autoFocusedElement"], [3, "closeTitle"], [3, "keepTabContent"], [3, "title", "selected"], ["kendoTabContent", ""], [3, "title"], ["layout", "start"], ["kendoButton", "", "themeColor", "primary", "icon", "save", 3, "click", "svgIcon"], ["kendoButton", "", "icon", "cancel-outline", 3, "click", "svgIcon"], ["kendoButton", "", "themeColor", "primary", "fillMode", "flat", "icon", "delete", 3, "svgIcon", "kendoEventsOutsideAngular", "scope"], ["dependencyType", "predecessor", 3, "dependenciesChange", "tasks", "dependencies"], ["dependencyType", "successor", 3, "dependenciesChange", "tasks", "dependencies"]],
      template: function EditDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "kendo-dialog", 0);
          i0.ɵɵlistener("close", function EditDialogComponent_Template_kendo_dialog_close_0_listener() {
            return ctx.handleEditingResult("cancel");
          });
          i0.ɵɵelement(1, "kendo-dialog-messages", 1);
          i0.ɵɵelementStart(2, "kendo-tabstrip", 2)(3, "kendo-tabstrip-tab", 3);
          i0.ɵɵtemplate(4, EditDialogComponent_ng_template_4_Template, 1, 0, "ng-template", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "kendo-tabstrip-tab", 5);
          i0.ɵɵtemplate(6, EditDialogComponent_ng_template_6_Template, 1, 2, "ng-template", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "kendo-tabstrip-tab", 5);
          i0.ɵɵtemplate(8, EditDialogComponent_ng_template_8_Template, 1, 2, "ng-template", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(9, "kendo-dialog-actions", 6)(10, "button", 7);
          i0.ɵɵlistener("click", function EditDialogComponent_Template_button_click_10_listener() {
            return ctx.handleEditingResult("save");
          });
          i0.ɵɵtext(11);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "button", 8);
          i0.ɵɵlistener("click", function EditDialogComponent_Template_button_click_12_listener() {
            return ctx.handleEditingResult("cancel");
          });
          i0.ɵɵtext(13);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(14, "kendo-treelist-spacer");
          i0.ɵɵelementStart(15, "button", 9);
          i0.ɵɵtext(16);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("title", ctx.getText("taskEditingDialogTitle"))("width", 575)("height", 470)("autoFocusedElement", ".k-actions .k-button-solid-primary");
          i0.ɵɵadvance();
          i0.ɵɵproperty("closeTitle", ctx.getText("taskEditingDialogCloseTitle"));
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("height", 345, "px");
          i0.ɵɵproperty("keepTabContent", true);
          i0.ɵɵadvance();
          i0.ɵɵproperty("title", ctx.getText("taskEditingGeneralTabTitle"))("selected", true);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("title", ctx.getText("taskEditingPredecessorsTabTitle"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("title", ctx.getText("taskEditingSuccessorsTabTitle"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("svgIcon", ctx.saveIcon);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.getText("saveButtonText"), " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("svgIcon", ctx.cancelIcon);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.getText("cancelButtonText"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("svgIcon", ctx.deleteIcon)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(20, _c2, ctx.handleTaskDelete))("scope", ctx);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.getText("deleteButtonText"), " ");
        }
      },
      dependencies: [DialogComponent, CustomMessagesComponent$1, TabStripComponent, TabStripTabComponent, TabContentDirective, TaskFieldsComponent, DependenciesTableComponent, DialogActionsComponent, ButtonComponent, TreeListSpacerComponent, EventsOutsideAngularDirective],
      encapsulation: 2
    });
  }
  return EditDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let ToolbarNavigationService = /*#__PURE__*/(() => {
  class ToolbarNavigationService {
    renderer;
    focusableContent;
    focusIndex = 0;
    constructor(renderer) {
      this.renderer = renderer;
    }
    updateFocus() {
      this.focusableContent.forEach(el => {
        this.renderer.setAttribute(el, 'tabindex', '-1');
      });
      this.renderer.setAttribute(this.focusableContent[this.focusIndex], 'tabindex', '0');
      this.focusableContent[this.focusIndex].focus();
    }
    static ɵfac = function ToolbarNavigationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToolbarNavigationService)(i0.ɵɵinject(i0.Renderer2));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToolbarNavigationService,
      factory: ToolbarNavigationService.ɵfac
    });
  }
  return ToolbarNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Gantt ViewSelector component. Shows the currently active view type, and allows switching to another view type.
 */
let ViewSelectorComponent = /*#__PURE__*/(() => {
  class ViewSelectorComponent {
    localizationService;
    hostClass = true;
    /**
     * The collection of the timeline view types in the current Gantt configuration.
     */
    views;
    /**
     * The currently active view type.
     * @default 'week'
     */
    activeView = 'week';
    /**
     * Fires each time the user selects a different view type. The event data contains the type of the newly selected view.
     */
    activeViewChange = new EventEmitter();
    constructor(localizationService) {
      this.localizationService = localizationService;
    }
    /**
     * @hidden
     */
    onClick(viewType) {
      if (viewType !== this.activeView) {
        this.activeViewChange.emit(viewType);
      }
    }
    /**
     * @hidden
     */
    getViewTypeText(viewType) {
      return this.localizationService.get(`${viewType}ViewText`);
    }
    /**
     * @hidden
     */
    onActiveViewChange(event) {
      this.activeViewChange.emit(event.target.value);
    }
    static ɵfac = function ViewSelectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewSelectorComponent)(i0.ɵɵdirectiveInject(i1$1.LocalizationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ViewSelectorComponent,
      selectors: [["kendo-gantt-view-selector"]],
      hostVars: 2,
      hostBindings: function ViewSelectorComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("k-gantt-views-wrapper", ctx.hostClass);
        }
      },
      inputs: {
        views: "views",
        activeView: "activeView"
      },
      outputs: {
        activeViewChange: "activeViewChange"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 4,
      vars: 4,
      consts: [["aria-label", "View Selector", 1, "k-dropdownlist", "k-picker", "k-rounded-md", "k-views-dropdown", 3, "change", "value"], [3, "value", 4, "ngFor", "ngForOf"], ["selection", "single", 1, "k-gantt-views", 3, "navigable"], ["kendoButton", "", "type", "button", 3, "selected", "click", 4, "ngFor", "ngForOf"], [3, "value"], ["kendoButton", "", "type", "button", 3, "click", "selected"]],
      template: function ViewSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "select", 0);
          i0.ɵɵlistener("change", function ViewSelectorComponent_Template_select_change_0_listener($event) {
            return ctx.onActiveViewChange($event);
          });
          i0.ɵɵtemplate(1, ViewSelectorComponent_option_1_Template, 2, 2, "option", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "kendo-buttongroup", 2);
          i0.ɵɵtemplate(3, ViewSelectorComponent_button_3_Template, 2, 2, "button", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("value", ctx.activeView);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.views);
          i0.ɵɵadvance();
          i0.ɵɵproperty("navigable", false);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.views);
        }
      },
      dependencies: [NgFor, ReactiveFormsModule, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, ButtonGroupComponent, ButtonComponent],
      encapsulation: 2
    });
  }
  return ViewSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The UI for adding new items to the Gantt.
 * Use it within a toolbar template to provide a custom icon or list of options.
 */
let GanttAddTaskComponent = /*#__PURE__*/(() => {
  class GanttAddTaskComponent {
    localizationService;
    editService;
    ngZone;
    /**
     * Sets the data of the DropDownButton.
     * > The data has to be provided in an array-like list.
     */
    data;
    /**
     * Defines the name of an existing icon in a Kendo UI theme.
     * @default 'plus'
     */
    icon = 'plus';
    /**
     * Defines an [`SVGIcon`](slug:api_icons_svgicon) icon to be rendered inside the `GanttAddTaskComponent` using
     * a [`KendoSVGIcon`](slug:api_icons_svgiconcomponent) component.
     */
    svgIcon = plusIcon;
    constructor(localizationService, editService, ngZone) {
      this.localizationService = localizationService;
      this.editService = editService;
      this.ngZone = ngZone;
      !this.data && (this.data = [{
        text: this.getText('addChildText'),
        type: 'addChild'
      }, {
        text: this.getText('addAboveText'),
        type: 'addAbove'
      }, {
        text: this.getText('addBelowText'),
        type: 'addBelow'
      }]);
    }
    /**
     * @hidden
     */
    getText(message) {
      return this.localizationService.get(message);
    }
    /**
     * @hidden
     */
    handleOpen(e) {
      if (!this.editService.getSelectedItem()) {
        e.preventDefault();
      }
    }
    /**
     * @hidden
     */
    handleMouseClick() {
      if (!this.editService.getSelectedItem()) {
        this.ngZone.run(() => {
          this.editService.addEvent.next({
            selectedItem: null,
            actionType: 'addTask'
          });
        });
      }
    }
    /**
     * @hidden
     */
    handleItemClick(e) {
      this.editService.addEvent.next({
        actionType: e.type,
        selectedItem: null
      });
    }
    static ɵfac = function GanttAddTaskComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttAddTaskComponent)(i0.ɵɵdirectiveInject(i1$1.LocalizationService), i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttAddTaskComponent,
      selectors: [["kendo-gantt-add-task"]],
      inputs: {
        data: "data",
        icon: "icon",
        svgIcon: "svgIcon"
      },
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 8,
      consts: [[3, "itemClick", "open", "data", "icon", "svgIcon", "kendoEventsOutsideAngular", "scope"]],
      template: function GanttAddTaskComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "kendo-dropdownbutton", 0);
          i0.ɵɵlistener("itemClick", function GanttAddTaskComponent_Template_kendo_dropdownbutton_itemClick_0_listener($event) {
            return ctx.handleItemClick($event);
          })("open", function GanttAddTaskComponent_Template_kendo_dropdownbutton_open_0_listener($event) {
            return ctx.handleOpen($event);
          });
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("data", ctx.data)("icon", ctx.icon)("svgIcon", ctx.svgIcon)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(6, _c2, ctx.handleMouseClick))("scope", ctx);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.getText("addTaskText"), " ");
        }
      },
      dependencies: [DropDownButtonComponent, EventsOutsideAngularDirective],
      encapsulation: 2
    });
  }
  return GanttAddTaskComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let ToolbarComponent = /*#__PURE__*/(() => {
  class ToolbarComponent {
    hostEl;
    navigationService;
    context = {};
    role = 'toolbar';
    toolbarSizingClass = true;
    clickHandler(ev) {
      if (this.navigable) {
        const closestFocusable = closest(ev.target, isFocusable);
        const targetIndex = this.navigationService.focusableContent.indexOf(closestFocusable);
        if (targetIndex > -1) {
          this.navigationService.focusIndex = targetIndex;
        }
        this.navigationService.updateFocus();
      }
    }
    arrowLeftListener() {
      if (this.navigable && isDocumentAvailable()) {
        this.navigationService.focusIndex--;
        if (this.navigationService.focusIndex < 0) {
          this.navigationService.focusIndex = this.navigationService.focusableContent.length - 1;
        }
        this.navigationService.updateFocus();
      }
    }
    arrowRightListener() {
      if (this.navigable && isDocumentAvailable()) {
        this.navigationService.focusIndex++;
        if (this.navigationService.focusIndex >= this.navigationService.focusableContent.length) {
          this.navigationService.focusIndex = 0;
        }
        this.navigationService.updateFocus();
      }
    }
    activeViewChange = new EventEmitter();
    showAddTask;
    showViewSelector;
    views;
    activeView;
    toolbarTemplate;
    navigable;
    set position(value) {
      this.context.position = this._position = value;
    }
    get position() {
      return this._position;
    }
    get toolbarTemplateRef() {
      return this.toolbarTemplate ? this.toolbarTemplate.templateRef : undefined;
    }
    get renderTemplate() {
      const ganttToolbarTemplate = this.toolbarTemplate;
      const templatePosition = ganttToolbarTemplate ? ganttToolbarTemplate.position : null;
      return ganttToolbarTemplate && (templatePosition === 'both' || templatePosition === this.position);
    }
    _position;
    constructor(hostEl, navigationService) {
      this.hostEl = hostEl;
      this.navigationService = navigationService;
    }
    handleViewChange(view) {
      this.activeViewChange.emit(view);
    }
    ngAfterViewInit() {
      if (isDocumentAvailable()) {
        const focusableElements = Array.from(this.hostEl.nativeElement.querySelectorAll(focusableSelector) || []).filter(el => isVisible(el));
        if (focusableElements.length) {
          this.navigationService.focusableContent = focusableElements;
        }
      }
    }
    static ɵfac = function ToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToolbarComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ToolbarNavigationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ToolbarComponent,
      selectors: [["kendo-gantt-toolbar"]],
      hostVars: 3,
      hostBindings: function ToolbarComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ToolbarComponent_click_HostBindingHandler($event) {
            return ctx.clickHandler($event);
          })("keydown.arrowleft", function ToolbarComponent_keydown_arrowleft_HostBindingHandler($event) {
            return ctx.arrowLeftListener($event);
          })("keydown.arrowright", function ToolbarComponent_keydown_arrowright_HostBindingHandler($event) {
            return ctx.arrowRightListener($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
          i0.ɵɵclassProp("k-toolbar-md", ctx.toolbarSizingClass);
        }
      },
      inputs: {
        showAddTask: "showAddTask",
        showViewSelector: "showViewSelector",
        views: "views",
        activeView: "activeView",
        toolbarTemplate: "toolbarTemplate",
        navigable: "navigable",
        position: "position"
      },
      outputs: {
        activeViewChange: "activeViewChange"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([ToolbarNavigationService]), i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], [1, "k-spacer", "k-toolbar-spacer"], [3, "views", "activeView", "activeViewChange", 4, "ngIf"], [3, "activeViewChange", "views", "activeView"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function ToolbarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ToolbarComponent_ng_container_0_Template, 4, 2, "ng-container", 0)(1, ToolbarComponent_1_Template, 1, 2, null, 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.renderTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.renderTemplate);
        }
      },
      dependencies: [NgIf, GanttAddTaskComponent, ViewSelectorComponent, NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return ToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let Messages = /*#__PURE__*/(() => {
  class Messages extends ComponentMessages {
    /**
     * The title of the "General" tab of the editing dialog TabStrip.
     */
    taskEditingGeneralTabTitle;
    /**
     * The title of the "Predecessors" dependencies tab of the editing dialog TabStrip.
     */
    taskEditingPredecessorsTabTitle;
    /**
     * The title of the "Successors" dependencies tab of the editing dialog TabStrip.
     */
    taskEditingSuccessorsTabTitle;
    /**
     * The text of the "Add" button in the dependencies tabs of the editing dialog TabStrip.
     */
    taskEditingDependenciesAddButtonText;
    /**
     * The text of the "Remove" button in the dependencies tabs of the editing dialog TabStrip.
     */
    taskEditingDependenciesRemoveButtonText;
    /**
     * The title of the "Task Title" Grid column in the dependencies tabs of the editing dialog TabStrip.
     */
    taskEditingDependenciesGridNameColumnTitle;
    /**
     * The title of the "Type" Grid column in the dependencies tabs of the editing dialog TabStrip.
     */
    taskEditingDependenciesGridTypeColumnTitle;
    /**
     * The text of the task editing dialog 'Delete' button.
     */
    deleteButtonText;
    /**
     * The label for the task delete button.
     */
    taskDeleteLabel;
    /**
     * The title of the task editing dialog.
     */
    taskEditingDialogTitle;
    /**
     * The title of the task editing dialog close button.
     */
    taskEditingDialogCloseTitle;
    /**
     * The title of the confirmation dialog close button.
     */
    confirmationDialogCloseTitle;
    /**
     * The title of the delete task confirmation dialog.
     */
    confirmationDialogTitle;
    /**
     * The text of the DropDownButton in the AddTask component.
     */
    addTaskText;
    /**
     * The text of the `Add Child` option in the AddTask component.
     */
    addChildText;
    /**
     * The text of the `Add Above` option in the AddTask component.
     */
    addAboveText;
    /**
     * The text of the `Add Below` option in the AddTask component.
     */
    addBelowText;
    /**
     * The text of the task editing dialog `Cancel` button.
     */
    cancelButtonText;
    /**
     * The text of the task editing dialog `Save` button.
     */
    saveButtonText;
    /**
     * The label of the 'title' field input in editing mode.
     */
    titleFieldInputLabel;
    /**
     * The label of the 'start' field input in editing mode.
     */
    startFieldInputLabel;
    /**
     * The label of the 'end' field input in editing mode.
     */
    endFieldInputLabel;
    /**
     * The label of the 'completionRatio' field input in editing mode.
     */
    completionRatioFieldInputLabel;
    /**
     * The content of the delete task confirmation dialog.
     */
    confirmationDialogContent;
    /**
     * The text of the day view in the ViewSelector component.
     */
    dayViewText;
    /**
     * The text of the week view in the ViewSelector component.
     */
    weekViewText;
    /**
     * The text of the month view in the ViewSelector component.
     */
    monthViewText;
    /**
     * @hidden
     * The text of the year view in the ViewSelector component.
     */
    yearViewText;
    /**
     * The no-records text.
     */
    noRecords;
    /**
     * The label of the filter cell or icon.
     */
    filter;
    /**
     * The text of the `Equal` (**Is equal to**) filter operator.
     */
    filterEqOperator;
    /**
     * The text of the `NotEqual` (**Is not equal to**) filter operator.
     */
    filterNotEqOperator;
    /**
     * The text of the `IsNull` (**Is null**) filter operator.
     */
    filterIsNullOperator;
    /**
     * The text of the `IsNotNull` (**Is not null**) filter operator.
     */
    filterIsNotNullOperator;
    /**
     * The text of the `IsEmpty` (**Is empty**) filter operator.
     */
    filterIsEmptyOperator;
    /**
     * The text of the `IsNotEmpty` (**Is not empty**) filter operator.
     */
    filterIsNotEmptyOperator;
    /**
     * The text of the `StartsWith` (**Starts with**) filter operator.
     */
    filterStartsWithOperator;
    /**
     * The text of the `Contains` (**Contains**) filter operator.
     */
    filterContainsOperator;
    /**
     * The text of the `DoesNotContain` (**Does not contain**) filter operator.
     */
    filterNotContainsOperator;
    /**
     * The text of the `EndsWith` (**Ends with**) string filter operator.
     */
    filterEndsWithOperator;
    /**
     * The text of the `GreaterOrEqualTo` (**Is greater than or equal to**) numeric filter operator.
     */
    filterGteOperator;
    /**
     * The text of the `Greater` (**Is greater than**) numeric filter operator.
     */
    filterGtOperator;
    /**
     * The text of the `LessOrEqualTo` (**Is less than or equal to**) numeric filter operator.
     */
    filterLteOperator;
    /**
     * The text of the `Less` (**Is less than**) numeric filter operator.
     */
    filterLtOperator;
    /**
     * The text of the `IsTrue` Boolean filter option.
     */
    filterIsTrue;
    /**
     * The text of the `IsFalse` Boolean filter option.
     */
    filterIsFalse;
    /**
     * The text of the `(All)` option for Boolean filter.
     */
    filterBooleanAll;
    /**
     * The text of the `AfterOrEqualTo` (**Is after or equal to**) date filter operator.
     */
    filterAfterOrEqualOperator;
    /**
     * The text of the `After` (**Is after**) date filter operator.
     */
    filterAfterOperator;
    /**
     * The text of the `Before` (**Is before**) date filter operator.
     */
    filterBeforeOperator;
    /**
     * The text of the `BeforeOrEqualTo` (**Is before or equal to**) date filter operator.
     */
    filterBeforeOrEqualOperator;
    /**
     * The text of the **Filter** button.
     */
    filterFilterButton;
    /**
     * The text of the **Clear filter** button.
     */
    filterClearButton;
    /**
     * The text of the `And` filter logic.
     */
    filterAndLogic;
    /**
     * The text of the `Or` filter logic.
     */
    filterOrLogic;
    /**
     * The loading text.
     *
     * > The `loading` property is part of the accessibility support of the Gantt.
     * Its value is detectable by screen readers and is not otherwise visible.
     */
    loading;
    /**
     * The title of the icon for the column menu.
     */
    columnMenu;
    /**
     * The text that is displayed in the column menu for the column items.
     */
    columns;
    /**
     * @hidden
     * The text that is displayed in the column menu for the lock item.
     */
    lock;
    /**
     * @hidden
     * The text that is displayed in the column menu for the unlock item.
     */
    unlock;
    /**
     * The label of the sort icon.
     */
    sortable;
    /**
     * The text that is displayed in the column menu for the ascending sort item.
     */
    sortAscending;
    /**
     * The text that is displayed in the column menu for the descending sort item.
     */
    sortDescending;
    /**
     * The status announcement when a column is sorted in an ascending order.
     * Deprecated - the announcement now relies entirely on the `aria-sort` attribute.
     * @hidden
     */
    sortedAscending;
    /**
     * The status announcement when a column is sorted in a descending order.
     * Deprecated - the announcement now relies entirely on the `aria-sort` attribute.
     * @hidden
     */
    sortedDescending;
    /**
     * The status announcement when a column is no longer sorted.
     */
    sortedDefault;
    /**
     * The text that is displayed in the column menu or in the column chooser item
     * for the **Apply** button of the columns.
     */
    columnsApply;
    /**
     * The text that is displayed in the column menu or in the column chooser item
     * for the **Reset** button of the columns.
     */
    columnsReset;
    /**
     * The text shown in the task tooltip before the task start date.
     */
    tooltipStartDateText;
    /**
     * The text shown in the task tooltip before the task end date.
     */
    tooltipEndDateText;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMessages_BaseFactory;
      return function Messages_Factory(__ngFactoryType__) {
        return (ɵMessages_BaseFactory || (ɵMessages_BaseFactory = i0.ɵɵgetInheritedFactory(Messages)))(__ngFactoryType__ || Messages);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: Messages,
      selectors: [["kendo-gantt-messages-base"]],
      inputs: {
        taskEditingGeneralTabTitle: "taskEditingGeneralTabTitle",
        taskEditingPredecessorsTabTitle: "taskEditingPredecessorsTabTitle",
        taskEditingSuccessorsTabTitle: "taskEditingSuccessorsTabTitle",
        taskEditingDependenciesAddButtonText: "taskEditingDependenciesAddButtonText",
        taskEditingDependenciesRemoveButtonText: "taskEditingDependenciesRemoveButtonText",
        taskEditingDependenciesGridNameColumnTitle: "taskEditingDependenciesGridNameColumnTitle",
        taskEditingDependenciesGridTypeColumnTitle: "taskEditingDependenciesGridTypeColumnTitle",
        deleteButtonText: "deleteButtonText",
        taskDeleteLabel: "taskDeleteLabel",
        taskEditingDialogTitle: "taskEditingDialogTitle",
        taskEditingDialogCloseTitle: "taskEditingDialogCloseTitle",
        confirmationDialogCloseTitle: "confirmationDialogCloseTitle",
        confirmationDialogTitle: "confirmationDialogTitle",
        addTaskText: "addTaskText",
        addChildText: "addChildText",
        addAboveText: "addAboveText",
        addBelowText: "addBelowText",
        cancelButtonText: "cancelButtonText",
        saveButtonText: "saveButtonText",
        titleFieldInputLabel: "titleFieldInputLabel",
        startFieldInputLabel: "startFieldInputLabel",
        endFieldInputLabel: "endFieldInputLabel",
        completionRatioFieldInputLabel: "completionRatioFieldInputLabel",
        confirmationDialogContent: "confirmationDialogContent",
        dayViewText: "dayViewText",
        weekViewText: "weekViewText",
        monthViewText: "monthViewText",
        yearViewText: "yearViewText",
        noRecords: "noRecords",
        filter: "filter",
        filterEqOperator: "filterEqOperator",
        filterNotEqOperator: "filterNotEqOperator",
        filterIsNullOperator: "filterIsNullOperator",
        filterIsNotNullOperator: "filterIsNotNullOperator",
        filterIsEmptyOperator: "filterIsEmptyOperator",
        filterIsNotEmptyOperator: "filterIsNotEmptyOperator",
        filterStartsWithOperator: "filterStartsWithOperator",
        filterContainsOperator: "filterContainsOperator",
        filterNotContainsOperator: "filterNotContainsOperator",
        filterEndsWithOperator: "filterEndsWithOperator",
        filterGteOperator: "filterGteOperator",
        filterGtOperator: "filterGtOperator",
        filterLteOperator: "filterLteOperator",
        filterLtOperator: "filterLtOperator",
        filterIsTrue: "filterIsTrue",
        filterIsFalse: "filterIsFalse",
        filterBooleanAll: "filterBooleanAll",
        filterAfterOrEqualOperator: "filterAfterOrEqualOperator",
        filterAfterOperator: "filterAfterOperator",
        filterBeforeOperator: "filterBeforeOperator",
        filterBeforeOrEqualOperator: "filterBeforeOrEqualOperator",
        filterFilterButton: "filterFilterButton",
        filterClearButton: "filterClearButton",
        filterAndLogic: "filterAndLogic",
        filterOrLogic: "filterOrLogic",
        loading: "loading",
        columnMenu: "columnMenu",
        columns: "columns",
        lock: "lock",
        unlock: "unlock",
        sortable: "sortable",
        sortAscending: "sortAscending",
        sortDescending: "sortDescending",
        sortedAscending: "sortedAscending",
        sortedDescending: "sortedDescending",
        sortedDefault: "sortedDefault",
        columnsApply: "columnsApply",
        columnsReset: "columnsReset",
        tooltipStartDateText: "tooltipStartDateText",
        tooltipEndDateText: "tooltipEndDateText"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return Messages;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let LocalizedMessagesDirective = /*#__PURE__*/(() => {
  class LocalizedMessagesDirective extends Messages {
    service;
    constructor(service) {
      super();
      this.service = service;
    }
    static ɵfac = function LocalizedMessagesDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocalizedMessagesDirective)(i0.ɵɵdirectiveInject(i1$1.LocalizationService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: LocalizedMessagesDirective,
      selectors: [["", "kendoGanttLocalizedMessages", ""]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: Messages,
        useExisting: forwardRef(() => LocalizedMessagesDirective)
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return LocalizedMessagesDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TREELIST_GROUP_COLUMNS_CLASS = 'k-gantt-treelist-nested-columns';
const DEFAULT_VIEW = 'week';
const DEFAULT_DRAG_SCROLL_SETTINGS = {
  enabled: true,
  step: 3,
  interval: 1,
  threshold: 10
};
/**
 * Represents the Kendo UI Gantt component for Angular.
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-gantt
 *            [style.height.px]="500"
 *            [kendoGanttHierarchyBinding]="data"
 *            childrenField="subtasks"
 *            [dependencies]="dependencies">
 *            <kendo-gantt-column
 *                field="title"
 *                title="Task"
 *                [width]="200"
 *                [expandable]="true"></kendo-gantt-column>
 *            <kendo-gantt-column
 *                field="start"
 *                title="Start"
 *                format="dd-MMM-yyyy"
 *                [width]="120"></kendo-gantt-column>
 *            <kendo-gantt-column
 *                field="end"
 *                title="End"
 *                format="dd-MMM-yyyy"
 *                [width]="120"></kendo-gantt-column>
 *            <kendo-gantt-timeline-day-view></kendo-gantt-timeline-day-view>
 *            <kendo-gantt-timeline-week-view></kendo-gantt-timeline-week-view>
 *            <kendo-gantt-timeline-month-view></kendo-gantt-timeline-month-view>
 *        </kendo-gantt>
 *    `
 * })
 * class AppComponent {
 *     public data: Task[] = [{
 *         id: 7, title: 'Validation and R&D', start: new Date('2014-06-02T00:00:00.000Z'),
 *         end: new Date('2014-06-19T00:00:00.000Z'), completionRatio: 0.45708333333333334,
 *         subtasks: [
 *             { id: 18, title: 'Project Kickoff', start: new Date('2014-06-02T00:00:00.000Z'),
 *                 end: new Date('2014-06-02T00:00:00.000Z'), completionRatio: 0.23 },
 *             { id: 11, title: 'Research', start: new Date('2014-06-02T00:00:00.000Z'),
 *                 end: new Date('2014-06-07T00:00:00.000Z'), completionRatio: 0.5766666666666667,
 *                 subtasks: [
 *                     { id: 19, title: 'Validation', start: new Date('2014-06-02T00:00:00.000Z'),
 *                         end: new Date('2014-06-04T00:00:00.000Z'), completionRatio: 0.25 },
 *                     { id: 39, title: 'Specification', start: new Date('2014-06-04T00:00:00.000Z'),
 *                         end: new Date('2014-06-07T00:00:00.000Z'), completionRatio: 0.66 }]
 *             }, { id: 13, title: 'Implementation', start: new Date('2014-06-08T00:00:00.000Z'),
 *                 end: new Date('2014-06-19T00:00:00.000Z'), completionRatio: 0.77,
 *                 subtasks: [
 *                     { id: 24, title: 'Prototype', start: new Date('2014-06-08T00:00:00.000Z'),
 *                         end: new Date('2014-06-14T00:00:00.000Z'), completionRatio: 0.77 },
 *                     { id: 29, title: 'UI and Interaction', start: new Date('2014-06-14T00:00:00.000Z'),
 *                         end: new Date('2014-06-19T00:00:00.000Z'), completionRatio: 0.6 }]
 *             }, { id: 17, title: 'Release', start: new Date('2014-06-19T00:00:00.000Z'),
 *                 end: new Date('2014-06-19T00:00:00.000Z'), completionRatio: 0 }]
 *     }];
 *
 *     public dependencies: GanttDependency[] = [
 *         { id: 528, fromId: 18, toId: 19, type: DependencyType.FS },
 *         { id: 529, fromId: 19, toId: 39, type: DependencyType.FS },
 *         { id: 535, fromId: 24, toId: 29, type: DependencyType.FS },
 *         { id: 551, fromId: 13, toId: 29, type: DependencyType.FF },
 *         { id: 777, fromId: 7, toId: 11, type: DependencyType.SF },
 *         { id: 556, fromId: 39, toId: 24, type: DependencyType.FS },
 *         { id: 546, fromId: 29, toId: 17, type: DependencyType.FS },
 *     ];
 * }
 * ```
 */
let GanttComponent = /*#__PURE__*/(() => {
  class GanttComponent {
    timelineViewService;
    scrollSyncService;
    renderer;
    mapper;
    optionChangesService;
    dependencyDomService;
    editService;
    localizationService;
    hostElement;
    zone;
    navigation;
    currentTimeMarkerService;
    intlService;
    localeId;
    treeList;
    timeline;
    /**
     * @hidden
     *
     * Queries the template for a task content template declaration.
     * In newer Angular versions the ngIf-ed value gets evaluated after the static query is resolved.
     * Therefore the `static` property needs to be set to `false`.
     */
    taskContentTemplate;
    /**
     * @hidden
     *
     * Queries the template for a task template declaration.
     * In newer Angular versions the ngIf-ed value gets evaluated after the static query is resolved.
     * Therefore the `static` property needs to be set to `false`.
     */
    taskTemplate;
    /**
     * @hidden
     *
     * Queries the template for a task tooltip template declaration.
     * In newer Angular versions the ngIf-ed value gets evaluated after the static query is resolved.
     * Therefore the `static` property needs to be set to `false`.
     */
    taskTooltipTemplate;
    /**
     * @hidden
     *
     * Queries the template for a task summary template declaration.
     * In newer Angular versions the ngIf-ed value gets evaluated after the static query is resolved.
     * Therefore the `static` property needs to be set to `false`.
     */
    summaryTaskTemplate;
    toolbarTemplateChildren;
    get toolbarTemplate() {
      if (this._customToolbarTemplate) {
        return this._customToolbarTemplate;
      }
      return this.toolbarTemplateChildren ? this.toolbarTemplateChildren.first : undefined;
    }
    set toolbarTemplate(customToolbarTemplate) {
      this._customToolbarTemplate = customToolbarTemplate;
    }
    /**
     * @hidden
     */
    roleDescription = 'Gantt Chart';
    get hostRoleDescriptionAttr() {
      return this.roleDescription;
    }
    /**
     * @hidden
     */
    role = 'application';
    get hostRoleAttr() {
      return this.role;
    }
    hostClasses = true;
    get dir() {
      return this.direction;
    }
    /**
     * A query list of all declared columns.
     */
    set columns(columns) {
      this._columns = columns;
      this.updateTreeListGroupClass(columns);
    }
    get columns() {
      return this._columns;
    }
    /**
     * Sets the fields which will be used to extract the task data from the provided `data` array items.
     * The `id` field is also used as a TreeList data item unique identifier (defaults to `'id'`).
     *
     * > If no object is provided, the Gantt task data items will have to conform to the [`GanttTask`]({% slug api_gantt_gantttask %}) interface.
     */
    set taskModelFields(fields) {
      this.mapper.taskFields = fields;
    }
    /**
     * Sets the fields which will be used to extract the dependency data from the provided `dependencies` array items.
     *
     * > If no object is provided, the Gantt dependency data items will have to conform to the [`GanttDependency`]({% slug api_gantt_ganttdependency %}) interface.
     */
    set dependencyModelFields(fields) {
      this.mapper.dependencyFields = fields;
    }
    /**
     * A query list of all declared views.
     */
    views;
    /**
     * The active timeline view.
     * @default 'week'
     */
    set activeView(view) {
      this._activeView = view;
    }
    get activeView() {
      /**
       * If the default/provided activeView is not among the provided views,
       * fallback to setting the first provided view as active
       */
      const view = this.views.find(view => view.type === this._activeView) ? this._activeView : this.views.first.type;
      this.currentTimeMarkerService.activeView = view;
      return view;
    }
    /**
     * @hidden
     *
     */
    get activeViewCurrentTimeMarker() {
      const activeViewCurrentTimeMarker = this.views.find(view => view.type === this._activeView)?.currentTimeMarker;
      if (activeViewCurrentTimeMarker === false) {
        return false;
      }
      return activeViewCurrentTimeMarker || this.currentTimeMarker;
    }
    /**
     * Gets or sets the data of the Gantt.
     *
     * > The task data items should either conform to the [`GanttTask`]({% slug api_gantt_gantttask %}) interface, or a [`taskModelFields`]({% slug api_gantt_ganttcomponent %}#toc-taskmodelfields) object has to be provided.
     */
    set data(data) {
      this._data = normalizeGanttData(data);
      this.loadTimelineData();
    }
    get data() {
      return this._data;
    }
    /**
     * Specifies a callback that determines if the given task is selected ([see example]({% slug selection_gantt %}#toc-custom-selection)).
     *
     * > The [`selectable`]({% slug api_gantt_ganttcomponent %}#toc-selectable) prop has to be set to `true` in order for this callback to be executed.
     */
    isSelected = isSelected;
    /**
     * Specifies a callback that determines if a new dependency is valid.
     * Used when evaluating if an attempt to create a new dependency will result in a valid link between the two tasks
     * [see example]({% slug editing_drag_create_dependencies_gantt %}#toc-validation).
     *
     * By defalut, dependencies are deemed invalid when:
     *  - The two tasks are in a parent-child relationship.
     *  - The two tasks are already dependent on one another. Only one dependency is allowed per pair.
     *  - The start or end times of the two tasks are incompatible with the attempted dependency type.
     */
    validateNewDependency = this.defaultValidateNewDependencyCallback.bind(this);
    /**
     * Fires when the Gantt selection is changed through user interaction.
     *
     * Holds data about the affected [`items`]({% slug api_gantt_selectionchangeevent %}#toc-items) and the attempted [`action`]({% slug api_gantt_selectionchangeevent %}#toc-action):
     * - `select` - Triggered on `click` or `ctrl + click` on deselected items.
     * - `remove` - Triggered on `ctrl + click` on selected items.
     */
    selectionChange = new EventEmitter();
    /**
     * Enables or disables the Gantt selection mechanism ([see example]({% slug selection_gantt %}#toc-custom-selection)).
     *
     * > When set to `true`, the [`isSelected`]({% slug api_gantt_ganttcomponent %}#toc-isselected) callback has to be provided.
     * > When applied, the [`SelectableDirective`]({% slug api_gantt_selectabledirective %}) sets `selectable` to `true` internally.
     */
    selectable = false;
    /**
     * The toolbar configuration. Defines the position and content of the toolbar(s).
     * The available properties are `position`, `addTaskTool`, and `viewSelectorTool`.
     * All are optional and default to `top`.
     *
     * The possible values for each option are:
     * - `top`&mdash;Positions the toolbar above the Gantt panes. Renders the respective tool in the top toolbar.
     * - `bottom`&mdash;Positions the toolbar below the Gantt panes. Renders the respective tool in the bottom toolbar.
     * - `both`&mdash;Displays two toolbar instances. Positions the first one above,
     * and the second one - below the Gantt panes. Renders the respective tool in the both toolbars.
     * - `none`&mdash;No toolbar is rendered when used for setting `position`.
     * No add task or view selector tool is rendered when used for setting `addTaskTool` or `viewSelectorTool`.
     */
    set toolbarSettings(value) {
      this._toolbarSettings = {
        position: value.position || 'top',
        addTaskTool: value.addTaskTool || 'none',
        viewSelectorTool: value.viewSelectorTool || 'top'
      };
    }
    get toolbarSettings() {
      return this._toolbarSettings;
    }
    /**
     * Allows setting the toolbar(s) `aria-label` attribute value as necessary to comply with accessibility requirements.
     * Typically, toolbars need an `aria-label` when there is more than one toolbar in the application.
     */
    toolbarAriaLabel = 'Toolbar';
    /**
     * Gets or sets the callback function that retrieves the child items for a particular item.
     */
    set fetchChildren(fn) {
      this._fetchChildren = fn;
      this.editService.fetchChildren = fn;
    }
    get fetchChildren() {
      return this._fetchChildren;
    }
    /**
     * Gets or sets the callback function that indicates if a particular item has child items.
     */
    set hasChildren(fn) {
      this._hasChildren = fn;
      this.editService.hasChildren = fn;
    }
    get hasChildren() {
      return this._hasChildren;
    }
    /**
     * Defines the dependencies that will be drawn between the rendered tasks.
     *
     * > The dependency data items should either conform to the [`GanttDependency`]({% slug api_gantt_ganttdependency %}) interface, or a [`dependencyModelFields`]({% slug api_gantt_ganttcomponent %}#toc-dependencymodelfields) object has to be provided.
     */
    dependencies = [];
    /**
     * Enables the sorting of the Gantt columns that have their `field` option set.
     */
    sortable = false;
    /**
     * The descriptors by which the data will be sorted.
     */
    sort = [];
    /**
     * Enables the filtering of the Gantt columns that have their `field` option set.
     *
     * @default false
     */
    filterable = false;
    /**
     * The descriptor by which the data will be filtered.
     */
    filter;
    /**
     * The start time of the work day.
     * Accepts string values in the `HH:mm` format.
     */
    workDayStart = '08:00';
    /**
     * The end time of the work day.
     * Accepts string values in the `HH:mm` format.
     */
    workDayEnd = '17:00';
    /**
     * The start of the work week (index based).
     */
    workWeekStart = 1;
    /**
     * The end of the work week (index based).
     */
    workWeekEnd = 5;
    /**
     * If set to `true`, the user can use dedicated shortcuts to interact with the Gantt.
     * By default, navigation is disabled for the TreeList and Timeline parts of the component,
     * ([see example]({% slug keyboard_navigation_gantt %})).
     */
    navigable = false;
    /**
     * The options of the timeline splitter pane. By default the pane is `collapsible`,
     * `resizable`, not `collapsed`, and its `size` is `'50%'`.
     */
    set timelinePaneOptions(value) {
      if (this._timelinePaneOptions.collapsed && !value.collapsed) {
        this.dependencyDomService.notifyChanges();
      }
      this._timelinePaneOptions = {
        ...DEFAULT_TIMELINE_PANE_SETTINGS,
        ...value
      };
    }
    get timelinePaneOptions() {
      return {
        ...this._timelinePaneOptions,
        size: this.treeListPaneOptions.collapsed ? '100%' : this._timelinePaneOptions.size
      };
    }
    /**
     * The options of the treelist splitter pane.
     * By default the pane is `collapsible` and not `collapsed`.
     */
    set treeListPaneOptions(value) {
      this._treeListPaneOptions = {
        ...DEFAULT_TREELIST_PANE_SETTINGS,
        ...value
      };
    }
    get treeListPaneOptions() {
      return this._treeListPaneOptions;
    }
    /**
     * Defines a function that is executed for every task in the component.
     * The classes returned from the function are applied to the task wrapper element.
     */
    set taskClass(fn) {
      if (isDevMode() && typeof fn !== 'function') {
        throw new Error(`taskClass must be a function, but received ${JSON.stringify(fn)}.`);
      }
      this._taskClass = fn;
    }
    get taskClass() {
      return this._taskClass;
    }
    /**
     * Defines a function that is executed for every data row in the component.
     */
    set rowClass(fn) {
      if (isDevMode() && typeof fn !== 'function') {
        throw new Error(`rowClass must be a function, but received ${JSON.stringify(fn)}.`);
      }
      this._rowClass = fn;
    }
    get rowClass() {
      return this._rowClass;
    }
    /**
     * The name of the field which contains the unique identifier of the task data item.
     * Defaults to 'id'.
     */
    get taskIdField() {
      return this.mapper.taskFields.id;
    }
    /**
     * Sets the callback function that indicates if a particular item is expanded.
     * If no callback is set, all items will be expanded and no expand icons will be rendered.
     */
    isExpanded;
    /**
     * Indicates whether the Gantt columns will be resized during initialization so that they fit their headers and row content.
     * Columns with autoSize set to false are excluded.
     *
     * @default false
     */
    columnsAutoSize = false;
    /**
     * Specifies the Gantt current time marker settings.
     * The settings will be applied for all views.
     * If the `currentTimeMarker` is set for a view then it takes precedence.
     *
     * @default true
     */
    currentTimeMarker = true;
    /**
     * Specifies if the column menu of the columns will be displayed.
     *
     * @default false
     */
    columnMenu = false;
    /**
     * If set to true, the user can reorder columns by dragging their header cells.
     *
     * @default false
     */
    columnsReorderable = false;
    /**
     * If set to true, the user can resize columns by dragging the edges (resize handles) of their header cells.
     *
     * @default false
     */
    columnsResizable = false;
    /**
     * Specifies the settings for auto-scrolling during dragging
     * when the pointer moves outside of the container bounderies
     * [see example]({% slug editing_drag_create_dependencies_gantt %}#toc-auto-scrolling).
     */
    set dragScrollSettings(settings) {
      this._dragScrollSettings = {
        ...DEFAULT_DRAG_SCROLL_SETTINGS,
        ...settings
      };
    }
    get dragScrollSettings() {
      return this._dragScrollSettings;
    }
    /**
     * Allows setting the task tooltip `position`, `callout`, and `showAfter` options.
     *
     * @default { position: 'top', callout: true, showAfter: 100 }
     */
    taskTooltipOptions = {
      position: 'top',
      callout: true,
      showAfter: 100
    };
    /**
     * Fires when an item is expanded.
     */
    rowExpand = new EventEmitter();
    /**
     * Fires when a Gantt task in the timeline pane is double-clicked. The data item, associated with the clicked task,
     * is available in the event data. Use the event handler to open a task editing dialog as necessary.
     */
    taskDblClick = new EventEmitter();
    /**
     * Fires when the user double clicks a cell.
     */
    cellDblClick = new EventEmitter();
    /**
     * Fires when the user leaves an edited cell.
     */
    cellClose = new EventEmitter();
    /**
     * Fires when the end user clicks the `Delete` button in the task editing dialog,
     * the task delete icon, or presses the `Delete` key on the keyboard when a task in the timeline is focused.
     * Use the event handler to open a confirmation dialog when necessary.
     */
    taskDelete = new EventEmitter();
    /**
     * Fires when an item is collapsed.
     */
    rowCollapse = new EventEmitter();
    /**
     * Fires when the user confirms deleting a task.
     */
    remove = new EventEmitter();
    /**
     * Fires when the user cancels editing a task.
     */
    cancel = new EventEmitter();
    /**
     * Fires when the user saves an edited task.
     */
    save = new EventEmitter();
    /**
     * Fires when the user adds a task.
     */
    taskAdd = new EventEmitter();
    /**
     * Fires when the user adds a dependency via dragging
     * [see example]({% slug editing_drag_create_dependencies_gantt %}#toc-basic-concepts).
     */
    dependencyAdd = new EventEmitter();
    /**
     * Fires when the sorting of the Gantt is changed.
     * You have to handle the event yourself and sort the data.
     */
    sortChange = new EventEmitter();
    /**
     * Fires when the Gantt filter is modified.
     * You have to handle the event yourself and filter the data.
     */
    filterChange = new EventEmitter();
    /**
     * Fires when the filter or sort state of the Gantt is changed.
     */
    dataStateChange = new EventEmitter();
    /**
     * Fires when the collapsed state of the treelist pane is changed.
     */
    treeListPaneCollapsedChange = new EventEmitter();
    /**
     * Fires when the collapsed state of the timeline pane is changed.
     */
    timelinePaneCollapsedChange = new EventEmitter();
    /**
     * Fires each time the user resizes the timeline pane.
     */
    timelinePaneSizeChange = new EventEmitter();
    /**
     * Fires each time the user selects a different view type. The event data contains the type of the newly selected view.
     */
    activeViewChange = new EventEmitter();
    /**
     * Fires when the user completes the resizing of the column.
     */
    columnResize = new EventEmitter();
    /**
     * Fires when the user completes the reordering of the column.
     */
    columnReorder = new EventEmitter();
    /**
     * Fires when the user changes the visibility of the columns from the column menu or column chooser.
     */
    columnVisibilityChange = new EventEmitter();
    /**
     * @hidden
     *
     * Fires when the user changes the locked state of the columns from the column menu or by reordering the columns.
     */
    columnLockedChange = new EventEmitter();
    /**
     * Fires when a cell is clicked.
     */
    cellClick = new EventEmitter();
    /**
     * Fires when a task is clicked.
     */
    taskClick = new EventEmitter();
    /**
     * @hidden
     */
    get renderedTreeListItems() {
      if (!isPresent(this.treeList)) {
        return [];
      }
      return this.treeList.view.data.map(item => item.data);
    }
    /**
     * @hidden
     */
    get viewItems() {
      if (!isPresent(this.treeList)) {
        return [];
      }
      return this.treeList.view.data;
    }
    /**
     * @hidden
     */
    get filterMenu() {
      return this.filterable ? 'menu' : false;
    }
    /**
     * @hidden
     *
     * Specifies whether the dependency drag clues will be rendered.
     * Set internally by the dependency-drag-create directive.
     *
     * @default false
     */
    renderDependencyDragClues = false;
    /**
     * @hidden
     */
    timelineSlots;
    /**
     * @hidden
     */
    timelineGroupSlots;
    /**
     * @hidden
     */
    tableWidth;
    /**
     * @hidden
     */
    get viewService() {
      if (!this.views || !this.views.length) {
        return null;
      }
      // TODO: review if this is a performance concern?
      return this.timelineViewService.service(this.activeView);
    }
    /**
     * @hidden
     *
     * Retrieves the `isSelected` callback if `selectable` is set to `true`
     * Otherwise returns the default callback, which always returns `false`.
     */
    get isTaskSelected() {
      return this.selectable ? this.isSelected : isSelected;
    }
    /**
     * @hidden
     *
     * Used by the GanttExpandableDirective.
     */
    get idGetter() {
      if (isPresent(this.treeList)) {
        return this.treeList.idGetter;
      }
    }
    /**
     * @hidden
     *
     * Used by the views selector.
     */
    get viewTypes() {
      return this.views.map(view => view.type);
    }
    /**
     * @hidden
     *
     * Used by the GanttExpandableDirective.
     */
    expandStateChange = new EventEmitter();
    /**
     * @hidden
     */
    showEditingDialog = false;
    /**
     * @hidden
     */
    showConfirmationDialog = false;
    /**
     * @hidden
     */
    get isInEditMode() {
      return this.showEditingDialog || this.showConfirmationDialog || this.treeList.isEditing();
    }
    /**
     * @hidden
     */
    showLicenseWatermark = false;
    _columns = new QueryList();
    _data = [];
    _dragScrollSettings = {
      ...DEFAULT_DRAG_SCROLL_SETTINGS
    };
    _timelinePaneOptions = {
      ...DEFAULT_TIMELINE_PANE_SETTINGS
    };
    _treeListPaneOptions = {
      ...DEFAULT_TREELIST_PANE_SETTINGS
    };
    _customToolbarTemplate;
    _rowClass = rowClassCallback;
    _taskClass = taskClassCallback;
    _activeView = DEFAULT_VIEW;
    _toolbarSettings = {
      position: 'top',
      addTaskTool: 'none',
      viewSelectorTool: 'top'
    };
    _fetchChildren = fetchChildren;
    _hasChildren = hasChildren;
    lastTreeListCellClick;
    direction;
    rtl = false;
    editItem;
    optionChangesSubscriptions = new Subscription();
    editServiceSubscription = new Subscription();
    localizationSubscription;
    intlSubscription;
    keydownListenerDisposers;
    constructor(timelineViewService, scrollSyncService, renderer, mapper, optionChangesService, dependencyDomService, editService, localizationService, hostElement, zone, navigation, currentTimeMarkerService, intlService, localeId) {
      this.timelineViewService = timelineViewService;
      this.scrollSyncService = scrollSyncService;
      this.renderer = renderer;
      this.mapper = mapper;
      this.optionChangesService = optionChangesService;
      this.dependencyDomService = dependencyDomService;
      this.editService = editService;
      this.localizationService = localizationService;
      this.hostElement = hostElement;
      this.zone = zone;
      this.navigation = navigation;
      this.currentTimeMarkerService = currentTimeMarkerService;
      this.intlService = intlService;
      this.localeId = localeId;
      const isValid = validatePackage(packageMetadata);
      this.showLicenseWatermark = shouldShowValidationUI(isValid);
      intlService.localeId = this.localeId;
      this.intlSubscription = this.intlService.changes.subscribe(() => {
        this.loadTimelineData();
        this.activeViewChange.emit(this.activeView);
      });
      this.optionChangesSubscriptions.add(this.optionChangesService.viewChanges.subscribe(() => {
        this.loadTimelineData();
      }));
      this.optionChangesSubscriptions.add(this.optionChangesService.dateFormatChanges.subscribe(() => {
        this.loadTimelineData();
      }));
      this.optionChangesSubscriptions.add(this.optionChangesService.columnChanges.subscribe(() => {
        this.treeList.columns.notifyOnChanges();
      }));
      this.editService.getSelectedItem = this.getFirstSelectedItem.bind(this);
      this.editServiceSubscription.add(this.editService.showEditingDialog.subscribe(show => this.showEditingDialog = show));
      this.editServiceSubscription.add(this.editService.taskDelete.subscribe(task => {
        if (hasObservers(this.taskDelete)) {
          this.zone.run(() => this.notifyTaskDelete(task));
        }
      }));
      this.editServiceSubscription.add(this.editService.editEvent.subscribe(args => {
        this[args.editResultType].emit({
          taskFormGroup: args.taskFormGroup,
          item: getEditItem(args.dataItem, this.treeList.view.data, this.mapper),
          dependencies: args.dependencies,
          sender: this
        });
        this.showConfirmationDialog = this.showEditingDialog = false;
        this.editService.dataItem = this.editService.taskFormGroup = null;
        this.updateView();
        if (this.navigable) {
          this.focus();
        }
      }));
      this.editServiceSubscription.add(this.editService.addEvent.subscribe(args => {
        const selectedItem = this.getFirstSelectedItem();
        this.taskAdd.emit({
          actionType: args.actionType,
          selectedItem: selectedItem ? getEditItem(selectedItem, this.treeList.view.data, this.mapper) : null
        });
        this.updateView();
      }));
      this.localizationSubscription = this.localizationService.changes.subscribe(({
        rtl
      }) => {
        this.rtl = rtl;
        this.direction = this.rtl ? 'rtl' : 'ltr';
        this.currentTimeMarkerService.rtl = rtl;
      });
    }
    ngOnChanges(changes) {
      if (anyChanged(['data', 'activeView', 'workWeekStart', 'workWeekEnd', 'workDayStart', 'workDayEnd'], changes)) {
        this.loadTimelineData();
      }
    }
    ngAfterViewInit() {
      this.updateTreeListMargin();
      this.zone.runOutsideAngular(() => {
        this.keydownListenerDisposers = this.renderer.listen(this.hostElement.nativeElement, 'keydown', this.handleKeydown.bind(this));
      });
      if (this.navigable) {
        this.navigation.initialize({
          treeList: this.treeList,
          host: this.hostElement.nativeElement,
          treeListElement: this.treeList.wrapper.nativeElement,
          timelineElement: this.timeline.timelineContent.nativeElement,
          columns: this.columns,
          data: this.data
        });
      }
      const leftContainer = this.treeList.wrapper.nativeElement.querySelector('kendo-treelist-list > div');
      this.scrollSyncService.registerElement(leftContainer, 'treelist');
    }
    ngAfterContentInit() {
      if (isDevMode() && this.views.length === 0) {
        throw new Error('No views declared for <kendo-gantt>. Please, declare at least one view.');
      }
      this.loadTimelineData();
      this.updateTreeListGroupClass();
    }
    ngOnDestroy() {
      this.optionChangesSubscriptions.unsubscribe();
      this.editServiceSubscription.unsubscribe();
      if (this.localizationSubscription) {
        this.localizationSubscription.unsubscribe();
      }
      if (this.intlSubscription) {
        this.intlSubscription.unsubscribe();
      }
      if (isPresent(this.keydownListenerDisposers)) {
        this.keydownListenerDisposers();
        this.keydownListenerDisposers = null;
      }
    }
    /**
     * Focuses the last active cell or task in the Gantt.
     * If no item has previously been focused, the first cell of the TreeList part will receive focus,
     * ([see example]({% slug keyboard_navigation_gantt %}#toc-controlling-the-focus)).
     */
    focus() {
      if (this.navigable) {
        this.navigation.focusLastActiveItem();
      }
    }
    /**
     * Focuses the targeted cell in the TreeList part of the component,
     * ([see example]({% slug keyboard_navigation_gantt %}#toc-controlling-the-focus)).
     */
    focusCell(rowIndex, colIndex) {
      if (this.navigable) {
        this.navigation.focusCell(rowIndex, colIndex);
      }
    }
    /**
     * Focuses the targeted task in the Timeline part of the component,
     * ([see example]({% slug keyboard_navigation_gantt %}#toc-controlling-the-focus)).
     */
    focusTask(taskIndex) {
      if (this.navigable) {
        this.navigation.focusTask(taskIndex);
      }
    }
    /**
     * Applies the minimum possible width for the specified column,
     * so that the whole text fits without wrapping. This method expects the Gantt
     * to be resizable (set `resizable` to `true`).
     * Makes sense to execute this method only after the Gantt is already populated with data.
     */
    autoFitColumn(column) {
      if (isPresent(this.treeList)) {
        this.treeList.autoFitColumn(column);
      }
    }
    /**
     * Adjusts the width of the specified columns to fit the entire content, including headers, without wrapping.
     * If no columns are specified, `autoFitColumns` is applied to all columns.
     *
     * This method requires the Gantt to be resizable (set `resizable` to `true`).
     */
    autoFitColumns(columns = this.columns) {
      if (isPresent(this.treeList)) {
        this.treeList.autoFitColumns(columns);
      }
    }
    /**
     * Clears the already loaded children for the dataItem so that the Gantt will fetch them again the next time it is rendered.
     */
    reload(dataItem, reloadChildren) {
      if (isPresent(this.treeList)) {
        this.treeList.reload(dataItem, reloadChildren);
      }
    }
    /**
     * Changes the position of the specified column.
     * The reordering of columns operates only on the level
     * which is inferred by the source column.
     * For the `reorderColumn` method to work properly,
     * the `source` column has to be visible.
     *
     * @param {ColumnBase} source - The column whose position will be changed.
     * @param {number} destIndex - The new position of the column.
     * @param {ColumnReorderConfig} options - Additional options.
     */
    reorderColumn(source, destIndex, options = {
      before: false
    }) {
      if (isPresent(this.treeList)) {
        this.treeList.reorderColumn(source, destIndex, options);
      }
    }
    /**
     * Forces the TreeList to evaluate if some data items have changed and re-renders the rows information, if needed.
     * Recalculates and re-renders the Timeline period, if needed.
     * Redraws changed dependencies, if needed.
     * Executes all row-related callbacks anew.
     */
    updateView() {
      if (isPresent(this.treeList)) {
        this.treeList.updateView();
      }
      this.loadTimelineData();
      this.dependencyDomService.notifyChanges();
    }
    /**
     * Opens the task editing dialog.
     */
    editTask(dataItem, formGroup) {
      if (!this.showEditingDialog) {
        const taskId = this.mapper.extractFromTask(dataItem, 'id');
        const dependencies = this.dependencies.filter(item => this.mapper.extractFromDependency(item, 'toId') === taskId || this.mapper.extractFromDependency(item, 'fromId') === taskId);
        this.editService.createEditDialog(dataItem, formGroup, dependencies);
      }
    }
    /**
     * Closes the task editing dialog.
     */
    closeTaskDialog() {
      if (this.showEditingDialog) {
        this.editService.closeEditDialog();
      }
    }
    /**
     * Opens the delete task confirmation dialog.
     */
    openConfirmationDialog() {
      this.showConfirmationDialog = true;
    }
    /**
     * @hidden
     */
    handleConfirmationDialogClose() {
      this.showConfirmationDialog = false;
      if (this.navigable) {
        this.focus();
      }
    }
    /**
     * Opens a cell for editing.
     */
    editCell(dataItem, column, formGroup) {
      this.treeList.editCell(dataItem, column, formGroup);
    }
    /**
     * Closes an edited cell.
     */
    closeCell() {
      this.treeList.closeCell();
    }
    /**
     * @hidden
     */
    handleCellClose(e) {
      this.cellClose.emit(new CellCloseEvent({
        ...e,
        item: this.editItem,
        sender: this
      }));
      this.dependencyDomService.notifyChanges();
    }
    /**
     * @hidden
     */
    onTreeListCollapsedChange(collapsed) {
      this.treeListPaneCollapsedChange.emit(collapsed);
      if (!collapsed) {
        this.scrollSyncService.syncScrollTop('timeline', 'treelist');
      }
    }
    /**
     * @hidden
     */
    onTimelineCollapsedChange(collapsed) {
      this.timelinePaneCollapsedChange.emit(collapsed);
      if (!collapsed) {
        this.scrollSyncService.syncScrollTop('treelist', 'timeline');
        this.dependencyDomService.notifyChanges();
      }
    }
    /**
     * @hidden
     */
    loadTimelineData() {
      if (!isPresent(this.viewService)) {
        return;
      }
      const activeViewOptions = this.getActiveViewOptions();
      this.viewService.options = {
        workWeekStart: this.workWeekStart,
        workWeekEnd: this.workWeekEnd,
        workDayStart: this.workDayStart,
        workDayEnd: this.workDayEnd,
        ...activeViewOptions
      };
      this.tableWidth = this.viewService.getTableWidth(this.data);
      const [groupedSlots, slots] = this.viewService.getSlots(this.data);
      this.timelineSlots = slots;
      this.timelineGroupSlots = groupedSlots;
    }
    /**
     * @hidden
     */
    showToolbar(position) {
      return this.toolbarSettings.position !== 'none' && [position, 'both'].indexOf(this.toolbarSettings.position) > -1;
    }
    /**
     * @hidden
     */
    handleColumnVisibilityChange(event) {
      this.columnVisibilityChange.emit(event);
      this.updateTreeListGroupClass();
    }
    /**
     * @hidden
     */
    onTimelinePaneSizeChange(e) {
      this._timelinePaneOptions.size = e;
      this.timelinePaneSizeChange.emit(e);
    }
    /**
     * @hidden
     */
    handleTimelineRightClick(event) {
      const target = event.target;
      const gantt = this.hostElement.nativeElement;
      if (!isTask(target, gantt) || isClearButton(target, gantt)) {
        return;
      }
      if (hasObservers(this.taskClick)) {
        const taskIndex = getClosestTaskIndex(target, gantt);
        const task = this.renderedTreeListItems[taskIndex];
        this.zone.run(() => this.notifyTaskClick(event, task, taskIndex));
      }
    }
    /**
     * @hidden
     */
    handleTimelineClick(event) {
      const target = event.target;
      const gantt = this.hostElement.nativeElement;
      if (!isTask(target, gantt) || isClearButton(target, gantt)) {
        return;
      }
      const taskIndex = getClosestTaskIndex(target, gantt);
      const task = this.renderedTreeListItems[taskIndex];
      const selectionAction = this.getSelectionAction(event, task);
      if (hasObservers(this.selectionChange) && !this.isSameSelection(selectionAction, task) || hasObservers(this.taskClick)) {
        this.zone.run(() => {
          this.notifySelectionChange(task, selectionAction);
          this.notifyTaskClick(event, task, taskIndex);
        });
      }
    }
    /**
     * @hidden
     */
    handleTreeListDoubleClick(event) {
      if (!isPresent(this.lastTreeListCellClick) || event.target !== this.lastTreeListCellClick.originalEvent.target) {
        return;
      }
      this.editItem = getEditItem(this.lastTreeListCellClick.dataItem, this.treeList.view.data, this.mapper);
      if (hasObservers(this.cellDblClick)) {
        this.zone.run(() => {
          this.cellDblClick.emit({
            column: this.lastTreeListCellClick.column,
            columnIndex: this.lastTreeListCellClick.columnIndex,
            dataItem: this.lastTreeListCellClick.dataItem,
            isEdited: this.lastTreeListCellClick.isEdited,
            originalEvent: this.lastTreeListCellClick.originalEvent,
            rowIndex: this.lastTreeListCellClick.rowIndex,
            type: 'dblclick',
            sender: this
          });
        });
      }
    }
    /**
     * @hidden
     */
    handleTreeListSelectionChange(event) {
      // prevent selection change from right-click
      if (isPresent(this.lastTreeListCellClick) && this.lastTreeListCellClick.type === 'contextmenu') {
        return;
      }
      const task = event.items.map(item => item.dataItem)[0]; // single selection only currently available
      const action = event.action;
      this.notifySelectionChange(task, action);
    }
    /**
     * @hidden
     */
    handleTreeListCellClick(event) {
      this.lastTreeListCellClick = event;
      this.cellClick.emit({
        column: event.column,
        columnIndex: event.columnIndex,
        dataItem: event.dataItem,
        isEdited: event.isEdited,
        originalEvent: event.originalEvent,
        rowIndex: event.rowIndex,
        type: event.type,
        sender: this
      });
    }
    /**
     * @hidden
     */
    handleDeleteConfirmation() {
      this.editService.triggerEditEvent('remove');
    }
    /**
     * @hidden
     */
    handleTimelineMouseDown(event) {
      const target = event.target;
      const gantt = this.hostElement.nativeElement;
      if (!isTask(target, gantt) || isClearButton(target, gantt)) {
        return;
      }
      event.preventDefault();
    }
    /**
     * @hidden
     */
    handleTimelineDblClick(event) {
      const target = event.target;
      const gantt = this.hostElement.nativeElement;
      if (!isTask(target, gantt) || isClearButton(target, gantt)) {
        return;
      }
      if (hasObservers(this.taskDblClick)) {
        const taskIndex = getClosestTaskIndex(target, gantt);
        const task = this.renderedTreeListItems[taskIndex];
        this.zone.run(() => this.taskDblClick.emit({
          dataItem: task,
          originalEvent: event,
          sender: this,
          index: taskIndex,
          type: 'dblclick'
        }));
      }
    }
    /**
     * @hidden
     */
    getText(token) {
      return this.localizationService.get(token);
    }
    /**
     * @hidden
     */
    changeActiveView(view) {
      if (view !== this.activeView) {
        this.activeView = view;
        this.loadTimelineData();
        this.scrollSyncService.resetTimelineScrollLeft();
        this.activeViewChange.emit(view);
        this.currentTimeMarkerService.slots = this.timelineSlots;
        this.currentTimeMarkerService.rows = this.viewItems;
        this.currentTimeMarkerService.activeView = view;
      }
    }
    /**
     * @hidden
     */
    notifyTaskClick(event, dataItem, itemIndex) {
      // simulates the TreeList `cellClick` event triggered by enter press (type: 'click')
      const type = event instanceof KeyboardEvent ? 'click' : event.type;
      this.taskClick.emit({
        originalEvent: event,
        dataItem: dataItem,
        index: itemIndex,
        type: type,
        sender: this
      });
    }
    /**
     * @hidden
     */
    notifySelectionChange(dataItem, action) {
      if (this.isSameSelection(action, dataItem)) {
        return;
      }
      this.selectionChange.emit({
        action: action,
        items: [dataItem],
        sender: this
      });
      this.treeList.updateView();
    }
    /**
     * @hidden
     */
    notifyTaskDelete(task) {
      this.editService.dataItem = task;
      this.taskDelete.emit({
        item: getEditItem(task, this.treeList.view.data, this.mapper),
        sender: this
      });
    }
    /**
     * @hidden
     */
    isSameSelection(action, dataItem) {
      return action === 'select' && this.isSelected(dataItem);
    }
    /**
     * @hidden
     */
    getSelectionAction({
      ctrlKey,
      metaKey
    }, dataItem) {
      const shouldToggleSelection = ctrlKey || metaKey;
      return shouldToggleSelection && this.isSelected(dataItem) ? 'remove' : 'select';
    }
    updateTreeListGroupClass(columns = this.columns) {
      if (!isPresent(this.treeList)) {
        return;
      }
      const hasColumns = isPresent(columns) && columns.length > 0;
      const hasVisibleGroupedColumns = hasColumns && columns.some(column => isColumnGroup(column) && column.childrenArray.some(childColumn => childColumn.isVisible));
      if (hasVisibleGroupedColumns) {
        this.renderer.addClass(this.treeList.wrapper.nativeElement, TREELIST_GROUP_COLUMNS_CLASS);
      } else {
        this.renderer.removeClass(this.treeList.wrapper.nativeElement, TREELIST_GROUP_COLUMNS_CLASS);
      }
    }
    /**
     * Used to hide the vertical scrollbar
     */
    updateTreeListMargin() {
      const treeListContentEl = this.treeList.wrapper.nativeElement.querySelector('.k-treelist .k-grid-content');
      this.renderer.setStyle(treeListContentEl, 'margin-right', `${-Math.abs(scrollbarWidth() - 1)}px`);
    }
    get activeTimelineIndex() {
      return this.navigation.activeTimelineIndex;
    }
    getActiveViewOptions() {
      if (!this.views) {
        return;
      }
      return this.views.find(view => view.type === this.activeView);
    }
    getFirstSelectedItem() {
      const isSelectedCallback = this.isSelected || isSelected;
      const loadedItems = this.renderedTreeListItems || [];
      return loadedItems.find(isSelectedCallback);
    }
    defaultValidateNewDependencyCallback(dependency) {
      const fromTaskId = this.mapper.extractFromDependency(dependency, 'fromId');
      const toTaskId = this.mapper.extractFromDependency(dependency, 'toId');
      const fromTask = this.treeList.view.data.find(task => this.mapper.extractFromTask(task.data, 'id') === fromTaskId);
      const toTask = this.treeList.view.data.find(task => this.mapper.extractFromTask(task.data, 'id') === toTaskId);
      // mark as invalid if the attempted dependency is lacking valid from- and to-tasks
      // or when the from- and to-tasks are actually the same task
      if (!isPresent(fromTask) || !isPresent(fromTask.data) || !isPresent(toTask) || !isPresent(toTask.data) || fromTask.data === toTask.data) {
        return false;
      }
      const tasksDependentOnOneAnother = this.dependencies.some(current => {
        const currentFromId = this.mapper.extractFromDependency(current, 'fromId');
        const currentToId = this.mapper.extractFromDependency(current, 'toId');
        return fromTaskId === currentFromId && toTaskId === currentToId || toTaskId === currentFromId && fromTaskId === currentToId;
      });
      // mark as invalid if the attempted dependency is trying to connect already dependent tasks
      // mark as invalid if the two tasks are in parent-child relationship
      if (tasksDependentOnOneAnother || areParentChild(fromTask, toTask)) {
        return false;
      }
      const fromTaskStart = this.mapper.extractFromTask(fromTask.data, 'start');
      const fromTaskEnd = this.mapper.extractFromTask(fromTask.data, 'end');
      const toTaskStart = this.mapper.extractFromTask(toTask.data, 'start');
      const toTaskEnd = this.mapper.extractFromTask(toTask.data, 'end');
      // if the two tasks are available to be connected via a dependency,
      // check if their start and end time allow for the attempted dependency type
      switch (this.mapper.extractFromDependency(dependency, 'type')) {
        // finish to finish (FF) — the from-task ends before the to-task can end
        case DependencyType.FF:
          return fromTaskEnd <= toTaskEnd;
        // finish to start (FS) — the from-task ends before the to-task can begin
        case DependencyType.FS:
          return fromTaskEnd <= toTaskStart;
        // start to finish (SF) — the from-task begins before the to-task can end
        case DependencyType.SF:
          return fromTaskStart <= toTaskEnd;
        // start to start (SS) — the from-task begins before the to-task can begin
        case DependencyType.SS:
          return fromTaskStart <= toTaskStart;
        default:
          return false;
      }
    }
    handleKeydown(event) {
      const {
        keyCode,
        target,
        altKey
      } = event;
      const isTimelineActive = this.timeline.timelineContent.nativeElement.contains(target);
      if (isTimelineActive) {
        if (isArrowUpDownKey(keyCode)) {
          const direction = keyCode === Keys.ArrowUp ? -1 : 1;
          this.navigation.activeTimelineIndex = this.activeTimelineIndex + direction;
          this.navigation.updateActiveTreeListCell();
        } else if (keyCode === Keys.Home) {
          this.navigation.activeTimelineIndex = 0;
          this.navigation.updateActiveTreeListCell();
        } else if (keyCode === Keys.End) {
          const lastAvailableIndex = this.treeList.view.data.length - 1;
          this.navigation.activeTimelineIndex = lastAvailableIndex;
          this.navigation.updateActiveTreeListCell();
        }
        if (isNavigationKey(keyCode)) {
          this.navigation.scrollHorizontallyToTask();
          this.scrollSyncService.syncScrollTop('timeline', 'treelist');
          this.navigation.notifyTaskStatusChange();
          event.preventDefault();
        }
        if (keyCode === Keys.Space && hasObservers(this.selectionChange)) {
          const task = this.renderedTreeListItems[this.activeTimelineIndex];
          const selectionAction = this.getSelectionAction(event, task);
          if (isPresent(task) && !this.isSameSelection(selectionAction, task)) {
            this.zone.run(() => this.notifySelectionChange(task, selectionAction));
          }
          event.preventDefault();
        }
        if (keyCode === Keys.Enter && hasObservers(this.taskClick)) {
          const task = this.renderedTreeListItems[this.activeTimelineIndex];
          if (isPresent(task)) {
            this.zone.run(() => this.notifyTaskClick(event, task, this.activeTimelineIndex));
          }
          event.preventDefault();
        }
        if (isExpandCollapseKey(keyCode, altKey)) {
          const task = this.renderedTreeListItems[this.activeTimelineIndex];
          if (isPresent(task) && this.hasChildren(task)) {
            const shouldExpand = keyCode === Keys.ArrowRight;
            const isExpanded = this.isExpanded(task);
            const sameState = shouldExpand === isExpanded;
            if (!sameState) {
              this.zone.run(() => {
                const expandEvent = {
                  dataItem: task
                };
                // order is not arbitrary
                // the TreeList emits the individual events first, then the combined `expandStateChange` event
                const individualEmitter = shouldExpand ? this.rowExpand : this.rowCollapse;
                individualEmitter.emit(expandEvent);
                this.expandStateChange.emit({
                  ...expandEvent,
                  expand: shouldExpand
                });
                this.updateView();
                this.navigation.scrollHorizontallyToTask();
              });
            }
          }
          event.preventDefault();
        }
      }
      const isTreeListActive = this.treeList.wrapper.nativeElement.contains(target);
      if (keyCode === Keys.Delete && (isTimelineActive || isTreeListActive) && hasObservers(this.taskDelete)) {
        const taskIndex = isTreeListActive ? this.treeList.activeCell.dataRowIndex : this.activeTimelineIndex;
        const task = this.renderedTreeListItems[taskIndex];
        if (isPresent(task)) {
          this.zone.run(() => this.notifyTaskDelete(task));
        }
      }
      if (isViewDigitKey(keyCode) && !isToolbar(target, this.hostElement.nativeElement) && !this.isInEditMode) {
        const targetViewIndex = getIndexFromViewDigitKeyCode(keyCode);
        const availableViews = this.views.toArray();
        const targetView = availableViews[targetViewIndex];
        if (isPresent(targetView) && targetView.type !== this.activeView) {
          this.zone.run(() => this.changeActiveView(targetView.type));
        }
      }
    }
    static ɵfac = function GanttComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttComponent)(i0.ɵɵdirectiveInject(TimelineViewService), i0.ɵɵdirectiveInject(ScrollSyncService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService), i0.ɵɵdirectiveInject(EditService), i0.ɵɵdirectiveInject(i1$1.LocalizationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(CurrentTimeMarkerService), i0.ɵɵdirectiveInject(i1.IntlService), i0.ɵɵdirectiveInject(LOCALE_ID));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GanttComponent,
      selectors: [["kendo-gantt"]],
      contentQueries: function GanttComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, GanttTaskContentTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, GanttTaskTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, GanttTaskTooltipTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, GanttSummaryTaskTemplateDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, ToolbarTemplateDirective, 4);
          i0.ɵɵcontentQuery(dirIndex, GanttColumnBase, 4);
          i0.ɵɵcontentQuery(dirIndex, ViewBase, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.taskContentTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.taskTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.taskTooltipTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.summaryTaskTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbarTemplateChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columns = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.views = _t);
        }
      },
      viewQuery: function GanttComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TreeListComponent, 7);
          i0.ɵɵviewQuery(GanttTimelineComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeline = _t.first);
        }
      },
      hostVars: 5,
      hostBindings: function GanttComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-roledescription", ctx.hostRoleDescriptionAttr)("role", ctx.hostRoleAttr)("dir", ctx.dir);
          i0.ɵɵclassProp("k-gantt", ctx.hostClasses);
        }
      },
      inputs: {
        roleDescription: [0, "aria-roledescription", "roleDescription"],
        role: "role",
        taskModelFields: "taskModelFields",
        dependencyModelFields: "dependencyModelFields",
        activeView: "activeView",
        data: "data",
        isSelected: "isSelected",
        validateNewDependency: "validateNewDependency",
        selectable: "selectable",
        toolbarSettings: "toolbarSettings",
        toolbarAriaLabel: "toolbarAriaLabel",
        fetchChildren: "fetchChildren",
        hasChildren: "hasChildren",
        dependencies: "dependencies",
        sortable: "sortable",
        sort: "sort",
        filterable: "filterable",
        filter: "filter",
        workDayStart: "workDayStart",
        workDayEnd: "workDayEnd",
        workWeekStart: "workWeekStart",
        workWeekEnd: "workWeekEnd",
        navigable: "navigable",
        timelinePaneOptions: "timelinePaneOptions",
        treeListPaneOptions: "treeListPaneOptions",
        taskClass: "taskClass",
        rowClass: "rowClass",
        isExpanded: "isExpanded",
        columnsAutoSize: "columnsAutoSize",
        currentTimeMarker: "currentTimeMarker",
        columnMenu: "columnMenu",
        columnsReorderable: "columnsReorderable",
        columnsResizable: "columnsResizable",
        dragScrollSettings: "dragScrollSettings",
        taskTooltipOptions: "taskTooltipOptions"
      },
      outputs: {
        selectionChange: "selectionChange",
        rowExpand: "rowExpand",
        taskDblClick: "taskDblClick",
        cellDblClick: "cellDblClick",
        cellClose: "cellClose",
        taskDelete: "taskDelete",
        rowCollapse: "rowCollapse",
        remove: "remove",
        cancel: "cancel",
        save: "save",
        taskAdd: "taskAdd",
        dependencyAdd: "dependencyAdd",
        sortChange: "sortChange",
        filterChange: "filterChange",
        dataStateChange: "dataStateChange",
        treeListPaneCollapsedChange: "treeListPaneCollapsedChange",
        timelinePaneCollapsedChange: "timelinePaneCollapsedChange",
        timelinePaneSizeChange: "timelinePaneSizeChange",
        activeViewChange: "activeViewChange",
        columnResize: "columnResize",
        columnReorder: "columnReorder",
        columnVisibilityChange: "columnVisibilityChange",
        columnLockedChange: "columnLockedChange",
        cellClick: "cellClick",
        taskClick: "taskClick"
      },
      exportAs: ["kendoGantt"],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([GanttLocalizationService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.gantt'
      }, {
        provide: DataBoundTreeComponent,
        useExisting: forwardRef(() => GanttComponent)
      }, {
        provide: ExpandableTreeComponent,
        useExisting: forwardRef(() => GanttComponent)
      }, TimelineViewService, TimelineDayViewService, TimelineWeekViewService, TimelineMonthViewService, TimeLineYearViewService, ScrollSyncService, DependencyDomService, MappingService, OptionChangesService, EditService, TimelineScrollService, NavigationService, CurrentTimeMarkerService]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 13,
      vars: 78,
      consts: () => {
        let i18n_0;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the 'General' tab of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingGeneralTabTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_0 = goog.getMsg("General");
          i18n_0 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_0;
        } else {
          i18n_0 = $localize`:kendo.gantt.taskEditingGeneralTabTitle|The title of the 'General' tab of the editing dialog TabStrip:General`;
        }
        let i18n_1;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the 'Predecessors' dependencies tab of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingPredecessorsTabTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_1 = goog.getMsg("Predecessors");
          i18n_1 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_1;
        } else {
          i18n_1 = $localize`:kendo.gantt.taskEditingPredecessorsTabTitle|The title of the 'Predecessors' dependencies tab of the editing dialog TabStrip:Predecessors`;
        }
        let i18n_2;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the 'Successors' dependencies tab of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingSuccessorsTabTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_2 = goog.getMsg("Successors");
          i18n_2 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_2;
        } else {
          i18n_2 = $localize`:kendo.gantt.taskEditingSuccessorsTabTitle|The title of the 'Successors' dependencies tab of the editing dialog TabStrip:Successors`;
        }
        let i18n_3;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the 'Add' button in the dependencies tabs of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingDependenciesAddButtonText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_3 = goog.getMsg("Add");
          i18n_3 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_3;
        } else {
          i18n_3 = $localize`:kendo.gantt.taskEditingDependenciesAddButtonText|The text of the 'Add' button in the dependencies tabs of the editing dialog TabStrip:Add`;
        }
        let i18n_4;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the 'Remove' button in the dependencies tabs of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingDependenciesRemoveButtonText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_4 = goog.getMsg("Remove");
          i18n_4 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_4;
        } else {
          i18n_4 = $localize`:kendo.gantt.taskEditingDependenciesRemoveButtonText|The text of the 'Remove' button in the dependencies tabs of the editing dialog TabStrip:Remove`;
        }
        let i18n_5;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the 'Task Title' Grid column in the dependencies tabs of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingDependenciesGridNameColumnTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_5 = goog.getMsg("Task Title");
          i18n_5 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_5;
        } else {
          i18n_5 = $localize`:kendo.gantt.taskEditingDependenciesGridNameColumnTitle|The title of the 'Task Title' Grid column in the dependencies tabs of the editing dialog TabStrip:Task Title`;
        }
        let i18n_6;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the 'Type' Grid column in the dependencies tabs of the editing dialog TabStrip
           * @meaning kendo.gantt.taskEditingDependenciesGridTypeColumnTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_6 = goog.getMsg("Type");
          i18n_6 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_6;
        } else {
          i18n_6 = $localize`:kendo.gantt.taskEditingDependenciesGridTypeColumnTitle|The title of the 'Type' Grid column in the dependencies tabs of the editing dialog TabStrip:Type`;
        }
        let i18n_7;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the task delete icon
           * @meaning kendo.gantt.taskDeleteLabel
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_7 = goog.getMsg("Delete");
          i18n_7 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_7;
        } else {
          i18n_7 = $localize`:kendo.gantt.taskDeleteLabel|The label of the task delete icon:Delete`;
        }
        let i18n_8;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the task editing dialog
           * @meaning kendo.gantt.taskEditingDialogTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_8 = goog.getMsg("Editing Task");
          i18n_8 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_8;
        } else {
          i18n_8 = $localize`:kendo.gantt.taskEditingDialogTitle|The title of the task editing dialog:Editing Task`;
        }
        let i18n_9;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the task editing dialog close button
           * @meaning kendo.gantt.taskEditingDialogCloseTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_9 = goog.getMsg("Close");
          i18n_9 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_9;
        } else {
          i18n_9 = $localize`:kendo.gantt.taskEditingDialogCloseTitle|The title of the task editing dialog close button:Close`;
        }
        let i18n_10;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the confirmation dialog close button
           * @meaning kendo.gantt.confirmationDialogCloseTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_10 = goog.getMsg("Close");
          i18n_10 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_10;
        } else {
          i18n_10 = $localize`:kendo.gantt.confirmationDialogCloseTitle|The title of the confirmation dialog close button:Close`;
        }
        let i18n_11;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the delete task confirmation dialog
           * @meaning kendo.gantt.confirmationDialogTitle
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_11 = goog.getMsg("Delete Task");
          i18n_11 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_11;
        } else {
          i18n_11 = $localize`:kendo.gantt.confirmationDialogTitle|The title of the delete task confirmation dialog:Delete Task`;
        }
        let i18n_12;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The content of the delete task confirmation dialog
           * @meaning kendo.gantt.confirmationDialogContent
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_12 = goog.getMsg("Are you sure you want to delete this task?");
          i18n_12 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_12;
        } else {
          i18n_12 = $localize`:kendo.gantt.confirmationDialogContent|The content of the delete task confirmation dialog:Are you sure you want to delete this task?`;
        }
        let i18n_13;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the task editing dialog 'Delete' button
           * @meaning kendo.gantt.deleteButtonText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_13 = goog.getMsg("Delete");
          i18n_13 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_13;
        } else {
          i18n_13 = $localize`:kendo.gantt.deleteButtonText|The text of the task editing dialog 'Delete' button:Delete`;
        }
        let i18n_14;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the task editing dialog 'Cancel' button
           * @meaning kendo.gantt.cancelButtonText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_14 = goog.getMsg("Cancel");
          i18n_14 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_14;
        } else {
          i18n_14 = $localize`:kendo.gantt.cancelButtonText|The text of the task editing dialog 'Cancel' button:Cancel`;
        }
        let i18n_15;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the task editing dialog 'Save' button
           * @meaning kendo.gantt.saveButtonText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_15 = goog.getMsg("Save");
          i18n_15 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_15;
        } else {
          i18n_15 = $localize`:kendo.gantt.saveButtonText|The text of the task editing dialog 'Save' button:Save`;
        }
        let i18n_16;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the 'title' field input in editing mode
           * @meaning kendo.gantt.titleFieldInputLabel
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_16 = goog.getMsg("Title");
          i18n_16 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_16;
        } else {
          i18n_16 = $localize`:kendo.gantt.titleFieldInputLabel|The label of the 'title' field input in editing mode:Title`;
        }
        let i18n_17;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the 'start' field input in editing mode
           * @meaning kendo.gantt.startFieldInputLabel
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_17 = goog.getMsg("Start");
          i18n_17 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_17;
        } else {
          i18n_17 = $localize`:kendo.gantt.startFieldInputLabel|The label of the 'start' field input in editing mode:Start`;
        }
        let i18n_18;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the 'end' field input in editing mode
           * @meaning kendo.gantt.endFieldInputLabel
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_18 = goog.getMsg("End");
          i18n_18 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_18;
        } else {
          i18n_18 = $localize`:kendo.gantt.endFieldInputLabel|The label of the 'end' field input in editing mode:End`;
        }
        let i18n_19;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the 'completionRatio' field input in editing mode
           * @meaning kendo.gantt.completionRatioFieldInputLabel
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_19 = goog.getMsg("Progress");
          i18n_19 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_19;
        } else {
          i18n_19 = $localize`:kendo.gantt.completionRatioFieldInputLabel|The label of the 'completionRatio' field input in editing mode:Progress`;
        }
        let i18n_20;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the day view in the ViewSelector component
           * @meaning kendo.gantt.dayViewText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_20 = goog.getMsg("Day");
          i18n_20 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_20;
        } else {
          i18n_20 = $localize`:kendo.gantt.dayViewText|The text of the day view in the ViewSelector component:Day`;
        }
        let i18n_21;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the week view in the ViewSelector component
           * @meaning kendo.gantt.weekViewText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_21 = goog.getMsg("Week");
          i18n_21 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_21;
        } else {
          i18n_21 = $localize`:kendo.gantt.weekViewText|The text of the week view in the ViewSelector component:Week`;
        }
        let i18n_22;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the month view in the ViewSelector component
           * @meaning kendo.gantt.monthViewText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_22 = goog.getMsg("Month");
          i18n_22 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_22;
        } else {
          i18n_22 = $localize`:kendo.gantt.monthViewText|The text of the month view in the ViewSelector component:Month`;
        }
        let i18n_23;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the DropDownButton in the AddTask component
           * @meaning kendo.gantt.addTaskText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_23 = goog.getMsg("Add Task");
          i18n_23 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_23;
        } else {
          i18n_23 = $localize`:kendo.gantt.addTaskText|The text of the DropDownButton in the AddTask component:Add Task`;
        }
        let i18n_24;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the 'Add Child' option in the AddTask component
           * @meaning kendo.gantt.addChildText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_24 = goog.getMsg("Add Child");
          i18n_24 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_24;
        } else {
          i18n_24 = $localize`:kendo.gantt.addChildText|The text of the 'Add Child' option in the AddTask component:Add Child`;
        }
        let i18n_25;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the 'Add Above' option in the AddTask component
           * @meaning kendo.gantt.addAboveText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_25 = goog.getMsg("Add Above");
          i18n_25 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_25;
        } else {
          i18n_25 = $localize`:kendo.gantt.addAboveText|The text of the 'Add Above' option in the AddTask component:Add Above`;
        }
        let i18n_26;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the 'Add Below' option in the AddTask component
           * @meaning kendo.gantt.addBelowText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_26 = goog.getMsg("Add Below");
          i18n_26 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_26;
        } else {
          i18n_26 = $localize`:kendo.gantt.addBelowText|The text of the 'Add Below' option in the AddTask component:Add Below`;
        }
        let i18n_27;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label visible in the TreeList when there are no records
           * @meaning kendo.gantt.noRecords
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_27 = goog.getMsg("No records available.");
          i18n_27 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_27;
        } else {
          i18n_27 = $localize`:kendo.gantt.noRecords|The label visible in the TreeList when there are no records:No records available.`;
        }
        let i18n_28;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the filter cell or icon
           * @meaning kendo.gantt.filter
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_28 = goog.getMsg("Filter");
          i18n_28 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_28;
        } else {
          i18n_28 = $localize`:kendo.gantt.filter|The label of the filter cell or icon:Filter`;
        }
        let i18n_29;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the equal filter operator
           * @meaning kendo.gantt.filterEqOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_29 = goog.getMsg("Is equal to");
          i18n_29 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_29;
        } else {
          i18n_29 = $localize`:kendo.gantt.filterEqOperator|The text of the equal filter operator:Is equal to`;
        }
        let i18n_30;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the not equal filter operator
           * @meaning kendo.gantt.filterNotEqOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_30 = goog.getMsg("Is not equal to");
          i18n_30 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_30;
        } else {
          i18n_30 = $localize`:kendo.gantt.filterNotEqOperator|The text of the not equal filter operator:Is not equal to`;
        }
        let i18n_31;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the is null filter operator
           * @meaning kendo.gantt.filterIsNullOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_31 = goog.getMsg("Is null");
          i18n_31 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_31;
        } else {
          i18n_31 = $localize`:kendo.gantt.filterIsNullOperator|The text of the is null filter operator:Is null`;
        }
        let i18n_32;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the is not null filter operator
           * @meaning kendo.gantt.filterIsNotNullOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_32 = goog.getMsg("Is not null");
          i18n_32 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_32;
        } else {
          i18n_32 = $localize`:kendo.gantt.filterIsNotNullOperator|The text of the is not null filter operator:Is not null`;
        }
        let i18n_33;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the is empty filter operator
           * @meaning kendo.gantt.filterIsEmptyOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_33 = goog.getMsg("Is empty");
          i18n_33 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_33;
        } else {
          i18n_33 = $localize`:kendo.gantt.filterIsEmptyOperator|The text of the is empty filter operator:Is empty`;
        }
        let i18n_34;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the is not empty filter operator
           * @meaning kendo.gantt.filterIsNotEmptyOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_34 = goog.getMsg("Is not empty");
          i18n_34 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_34;
        } else {
          i18n_34 = $localize`:kendo.gantt.filterIsNotEmptyOperator|The text of the is not empty filter operator:Is not empty`;
        }
        let i18n_35;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the starts with filter operator
           * @meaning kendo.gantt.filterStartsWithOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_35 = goog.getMsg("Starts with");
          i18n_35 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_35;
        } else {
          i18n_35 = $localize`:kendo.gantt.filterStartsWithOperator|The text of the starts with filter operator:Starts with`;
        }
        let i18n_36;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the contains filter operator
           * @meaning kendo.gantt.filterContainsOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_36 = goog.getMsg("Contains");
          i18n_36 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_36;
        } else {
          i18n_36 = $localize`:kendo.gantt.filterContainsOperator|The text of the contains filter operator:Contains`;
        }
        let i18n_37;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the does not contain filter operator
           * @meaning kendo.gantt.filterNotContainsOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_37 = goog.getMsg("Does not contain");
          i18n_37 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_37;
        } else {
          i18n_37 = $localize`:kendo.gantt.filterNotContainsOperator|The text of the does not contain filter operator:Does not contain`;
        }
        let i18n_38;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the ends with filter operator
           * @meaning kendo.gantt.filterEndsWithOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_38 = goog.getMsg("Ends with");
          i18n_38 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_38;
        } else {
          i18n_38 = $localize`:kendo.gantt.filterEndsWithOperator|The text of the ends with filter operator:Ends with`;
        }
        let i18n_39;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the greater than or equal filter operator
           * @meaning kendo.gantt.filterGteOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_39 = goog.getMsg("Is greater than or equal to");
          i18n_39 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_39;
        } else {
          i18n_39 = $localize`:kendo.gantt.filterGteOperator|The text of the greater than or equal filter operator:Is greater than or equal to`;
        }
        let i18n_40;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the greater than filter operator
           * @meaning kendo.gantt.filterGtOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_40 = goog.getMsg("Is greater than");
          i18n_40 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_40;
        } else {
          i18n_40 = $localize`:kendo.gantt.filterGtOperator|The text of the greater than filter operator:Is greater than`;
        }
        let i18n_41;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the less than or equal filter operator
           * @meaning kendo.gantt.filterLteOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_41 = goog.getMsg("Is less than or equal to");
          i18n_41 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_41;
        } else {
          i18n_41 = $localize`:kendo.gantt.filterLteOperator|The text of the less than or equal filter operator:Is less than or equal to`;
        }
        let i18n_42;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the less than filter operator
           * @meaning kendo.gantt.filterLtOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_42 = goog.getMsg("Is less than");
          i18n_42 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_42;
        } else {
          i18n_42 = $localize`:kendo.gantt.filterLtOperator|The text of the less than filter operator:Is less than`;
        }
        let i18n_43;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the IsTrue boolean filter option
           * @meaning kendo.gantt.filterIsTrue
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_43 = goog.getMsg("Is True");
          i18n_43 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_43;
        } else {
          i18n_43 = $localize`:kendo.gantt.filterIsTrue|The text of the IsTrue boolean filter option:Is True`;
        }
        let i18n_44;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the IsFalse boolean filter option
           * @meaning kendo.gantt.filterIsFalse
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_44 = goog.getMsg("Is False");
          i18n_44 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_44;
        } else {
          i18n_44 = $localize`:kendo.gantt.filterIsFalse|The text of the IsFalse boolean filter option:Is False`;
        }
        let i18n_45;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the (All) boolean filter option
           * @meaning kendo.gantt.filterBooleanAll
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_45 = goog.getMsg("(All)");
          i18n_45 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_45;
        } else {
          i18n_45 = $localize`:kendo.gantt.filterBooleanAll|The text of the (All) boolean filter option:(All)`;
        }
        let i18n_46;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the after or equal date filter operator
           * @meaning kendo.gantt.filterAfterOrEqualOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_46 = goog.getMsg("Is after or equal to");
          i18n_46 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_46;
        } else {
          i18n_46 = $localize`:kendo.gantt.filterAfterOrEqualOperator|The text of the after or equal date filter operator:Is after or equal to`;
        }
        let i18n_47;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the after date filter operator
           * @meaning kendo.gantt.filterAfterOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_47 = goog.getMsg("Is after");
          i18n_47 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_47;
        } else {
          i18n_47 = $localize`:kendo.gantt.filterAfterOperator|The text of the after date filter operator:Is after`;
        }
        let i18n_48;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the before date filter operator
           * @meaning kendo.gantt.filterBeforeOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_48 = goog.getMsg("Is before");
          i18n_48 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_48;
        } else {
          i18n_48 = $localize`:kendo.gantt.filterBeforeOperator|The text of the before date filter operator:Is before`;
        }
        let i18n_49;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the before or equal date filter operator
           * @meaning kendo.gantt.filterBeforeOrEqualOperator
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_49 = goog.getMsg("Is before or equal to");
          i18n_49 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_49;
        } else {
          i18n_49 = $localize`:kendo.gantt.filterBeforeOrEqualOperator|The text of the before or equal date filter operator:Is before or equal to`;
        }
        let i18n_50;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the filter button
           * @meaning kendo.gantt.filterFilterButton
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_50 = goog.getMsg("Filter");
          i18n_50 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_50;
        } else {
          i18n_50 = $localize`:kendo.gantt.filterFilterButton|The text of the filter button:Filter`;
        }
        let i18n_51;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the clear filter button
           * @meaning kendo.gantt.filterClearButton
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_51 = goog.getMsg("Clear");
          i18n_51 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_51;
        } else {
          i18n_51 = $localize`:kendo.gantt.filterClearButton|The text of the clear filter button:Clear`;
        }
        let i18n_52;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the And filter logic
           * @meaning kendo.gantt.filterAndLogic
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_52 = goog.getMsg("And");
          i18n_52 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_52;
        } else {
          i18n_52 = $localize`:kendo.gantt.filterAndLogic|The text of the And filter logic:And`;
        }
        let i18n_53;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text of the Or filter logic
           * @meaning kendo.gantt.filterOrLogic
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_53 = goog.getMsg("Or");
          i18n_53 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_53;
        } else {
          i18n_53 = $localize`:kendo.gantt.filterOrLogic|The text of the Or filter logic:Or`;
        }
        let i18n_54;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The loading text
           * @meaning kendo.gantt.loading
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_54 = goog.getMsg("Loading");
          i18n_54 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_54;
        } else {
          i18n_54 = $localize`:kendo.gantt.loading|The loading text:Loading`;
        }
        let i18n_55;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The title of the column menu icon
           * @meaning kendo.gantt.columnMenu
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_55 = goog.getMsg("Column Menu");
          i18n_55 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_55;
        } else {
          i18n_55 = $localize`:kendo.gantt.columnMenu|The title of the column menu icon:Column Menu`;
        }
        let i18n_56;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu for the columns item
           * @meaning kendo.gantt.columns
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_56 = goog.getMsg("Columns");
          i18n_56 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_56;
        } else {
          i18n_56 = $localize`:kendo.gantt.columns|The text shown in the column menu for the columns item:Columns`;
        }
        let i18n_57;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu for the lock item
           * @meaning kendo.gantt.lock
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_57 = goog.getMsg("Lock");
          i18n_57 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_57;
        } else {
          i18n_57 = $localize`:kendo.gantt.lock|The text shown in the column menu for the lock item:Lock`;
        }
        let i18n_58;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu for the unlock item
           * @meaning kendo.gantt.unlock
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_58 = goog.getMsg("Unlock");
          i18n_58 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_58;
        } else {
          i18n_58 = $localize`:kendo.gantt.unlock|The text shown in the column menu for the unlock item:Unlock`;
        }
        let i18n_59;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The label of the sort icon
           * @meaning kendo.gantt.sortable
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_59 = goog.getMsg("Sortable");
          i18n_59 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_59;
        } else {
          i18n_59 = $localize`:kendo.gantt.sortable|The label of the sort icon:Sortable`;
        }
        let i18n_60;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu for the sort ascending item
           * @meaning kendo.gantt.sortAscending
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_60 = goog.getMsg("Sort Ascending");
          i18n_60 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_60;
        } else {
          i18n_60 = $localize`:kendo.gantt.sortAscending|The text shown in the column menu for the sort ascending item:Sort Ascending`;
        }
        let i18n_61;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu for the sort descending item
           * @meaning kendo.gantt.sortDescending
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_61 = goog.getMsg("Sort Descending");
          i18n_61 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_61;
        } else {
          i18n_61 = $localize`:kendo.gantt.sortDescending|The text shown in the column menu for the sort descending item:Sort Descending`;
        }
        let i18n_62;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The status announcement when a column is no longer sorted
           * @meaning kendo.gantt.sortedDefault
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_62 = goog.getMsg("Not Sorted");
          i18n_62 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_62;
        } else {
          i18n_62 = $localize`:kendo.gantt.sortedDefault|The status announcement when a column is no longer sorted:Not Sorted`;
        }
        let i18n_63;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu or column chooser for the columns apply button
           * @meaning kendo.gantt.columnsApply
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_63 = goog.getMsg("Apply");
          i18n_63 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_63;
        } else {
          i18n_63 = $localize`:kendo.gantt.columnsApply|The text shown in the column menu or column chooser for the columns apply button:Apply`;
        }
        let i18n_64;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the column menu or column chooser for the columns reset button
           * @meaning kendo.gantt.columnsReset
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_64 = goog.getMsg("Reset");
          i18n_64 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_64;
        } else {
          i18n_64 = $localize`:kendo.gantt.columnsReset|The text shown in the column menu or column chooser for the columns reset button:Reset`;
        }
        let i18n_65;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the task tooltip before the task start date
           * @meaning kendo.gantt.tooltipStartDateText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_65 = goog.getMsg("Start");
          i18n_65 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_65;
        } else {
          i18n_65 = $localize`:kendo.gantt.tooltipStartDateText|The text shown in the task tooltip before the task start date:Start`;
        }
        let i18n_66;
        if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
          /**
           * @desc The text shown in the task tooltip before the task end date
           * @meaning kendo.gantt.tooltipEndDateText
           */
          const MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_66 = goog.getMsg("End");
          i18n_66 = MSG_G__AGENT__WORK_77_S_FRONTEND_NODE_MODULES__PROGRESS_KENDO_ANGULAR_GANTT_FESM2022_PROGRESS_KENDO_ANGULAR_GANTT_MJS_66;
        } else {
          i18n_66 = $localize`:kendo.gantt.tooltipEndDateText|The text shown in the task tooltip before the task end date:End`;
        }
        return [["kendoGanttLocalizedMessages", "", "taskEditingGeneralTabTitle", i18n_0, "taskEditingPredecessorsTabTitle", i18n_1, "taskEditingSuccessorsTabTitle", i18n_2, "taskEditingDependenciesAddButtonText", i18n_3, "taskEditingDependenciesRemoveButtonText", i18n_4, "taskEditingDependenciesGridNameColumnTitle", i18n_5, "taskEditingDependenciesGridTypeColumnTitle", i18n_6, "taskDeleteLabel", i18n_7, "taskEditingDialogTitle", i18n_8, "taskEditingDialogCloseTitle", i18n_9, "confirmationDialogCloseTitle", i18n_10, "confirmationDialogTitle", i18n_11, "confirmationDialogContent", i18n_12, "deleteButtonText", i18n_13, "cancelButtonText", i18n_14, "saveButtonText", i18n_15, "titleFieldInputLabel", i18n_16, "startFieldInputLabel", i18n_17, "endFieldInputLabel", i18n_18, "completionRatioFieldInputLabel", i18n_19, "dayViewText", i18n_20, "weekViewText", i18n_21, "monthViewText", i18n_22, "yearViewText", "Year", "addTaskText", i18n_23, "addChildText", i18n_24, "addAboveText", i18n_25, "addBelowText", i18n_26, "noRecords", i18n_27, "filter", i18n_28, "filterEqOperator", i18n_29, "filterNotEqOperator", i18n_30, "filterIsNullOperator", i18n_31, "filterIsNotNullOperator", i18n_32, "filterIsEmptyOperator", i18n_33, "filterIsNotEmptyOperator", i18n_34, "filterStartsWithOperator", i18n_35, "filterContainsOperator", i18n_36, "filterNotContainsOperator", i18n_37, "filterEndsWithOperator", i18n_38, "filterGteOperator", i18n_39, "filterGtOperator", i18n_40, "filterLteOperator", i18n_41, "filterLtOperator", i18n_42, "filterIsTrue", i18n_43, "filterIsFalse", i18n_44, "filterBooleanAll", i18n_45, "filterAfterOrEqualOperator", i18n_46, "filterAfterOperator", i18n_47, "filterBeforeOperator", i18n_48, "filterBeforeOrEqualOperator", i18n_49, "filterFilterButton", i18n_50, "filterClearButton", i18n_51, "filterAndLogic", i18n_52, "filterOrLogic", i18n_53, "loading", i18n_54, "columnMenu", i18n_55, "columns", i18n_56, "lock-disabled", i18n_57, "unlock-disabled", i18n_58, "sortable", i18n_59, "sortAscending", i18n_60, "sortDescending", i18n_61, "sortedDefault", i18n_62, "columnsApply", i18n_63, "columnsReset", i18n_64, "tooltipStartDateText", i18n_65, "tooltipEndDateText", i18n_66], ["class", "k-gantt-header k-toolbar k-gantt-toolbar", "position", "top", 3, "showAddTask", "showViewSelector", "toolbarTemplate", "views", "activeView", "navigable", "activeViewChange", 4, "ngIf"], [1, "k-gantt-content"], [1, "k-gantt-treelist", "k-gantt-treelist-scrollable", 3, "collapsedChange", "collapsible", "collapsed", "scrollable"], [3, "filterChange", "sortChange", "dataStateChange", "expandStateChange", "expand", "collapse", "columnReorder", "columnResize", "columnVisibilityChange", "columnLockedChange", "selectionChange", "cellClick", "cellClose", "idField", "columns", "data", "hasChildren", "fetchChildren", "navigable", "isExpanded", "autoSize", "columnMenu", "reorderable", "resizable", "rowClass", "isSelected", "selectable", "sortable", "sort", "filterable", "filter", "kendoEventsOutsideAngular", "scope"], [3, "noRecords", "filter", "filterEqOperator", "filterNotEqOperator", "filterIsNullOperator", "filterIsNotNullOperator", "filterIsEmptyOperator", "filterIsNotEmptyOperator", "filterStartsWithOperator", "filterContainsOperator", "filterNotContainsOperator", "filterEndsWithOperator", "filterGteOperator", "filterGtOperator", "filterLteOperator", "filterLtOperator", "filterIsTrue", "filterIsFalse", "filterBooleanAll", "filterAfterOrEqualOperator", "filterAfterOperator", "filterBeforeOperator", "filterBeforeOrEqualOperator", "filterFilterButton", "filterClearButton", "filterAndLogic", "filterOrLogic", "loading", "columnMenu", "columns", "sortable", "sortAscending", "sortDescending", "sortedAscending", "sortedDescending", "sortedDefault", "columnsApply", "columnsReset"], [1, "k-gantt-timeline-pane", 3, "collapsedChange", "sizeChange", "collapsible", "resizable", "collapsed", "min", "max", "size", "scrollable"], [3, "renderDependencyDragClues", "dragScrollSettings", "rows", "slots", "currentTimeMarker", "groupSlots", "tableWidth", "activeView", "taskContentTemplate", "taskTemplate", "summaryTaskTemplate", "taskClass", "dependencies", "isExpanded", "selectable", "isTaskSelected", "kendoEventsOutsideAngular", "customTooltipTemplate", "tooltipOptions", "scope", 4, "ngIf"], ["class", "k-gantt-footer k-toolbar k-gantt-toolbar", "position", "bottom", 3, "showAddTask", "showViewSelector", "toolbarTemplate", "views", "activeView", "navigable", 4, "ngIf"], [3, "data", 4, "ngIf"], [3, "width", "height", "title", "close", 4, "ngIf"], ["kendoWatermarkOverlay", "", 4, "ngIf"], ["position", "top", 1, "k-gantt-header", "k-toolbar", "k-gantt-toolbar", 3, "activeViewChange", "showAddTask", "showViewSelector", "toolbarTemplate", "views", "activeView", "navigable"], [3, "renderDependencyDragClues", "dragScrollSettings", "rows", "slots", "currentTimeMarker", "groupSlots", "tableWidth", "activeView", "taskContentTemplate", "taskTemplate", "summaryTaskTemplate", "taskClass", "dependencies", "isExpanded", "selectable", "isTaskSelected", "kendoEventsOutsideAngular", "customTooltipTemplate", "tooltipOptions", "scope"], ["position", "bottom", 1, "k-gantt-footer", "k-toolbar", "k-gantt-toolbar", 3, "showAddTask", "showViewSelector", "toolbarTemplate", "views", "activeView", "navigable"], [3, "data"], [3, "close", "width", "height", "title"], ["layout", "start"], ["kendoButton", "", 3, "click", "primary"], ["kendoButton", "", 3, "click"], ["kendoWatermarkOverlay", ""]];
      },
      template: function GanttComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainer(0, 0);
          i0.ɵɵtemplate(1, GanttComponent_kendo_gantt_toolbar_1_Template, 1, 7, "kendo-gantt-toolbar", 1);
          i0.ɵɵelementStart(2, "div", 2)(3, "kendo-splitter")(4, "kendo-splitter-pane", 3);
          i0.ɵɵlistener("collapsedChange", function GanttComponent_Template_kendo_splitter_pane_collapsedChange_4_listener($event) {
            return ctx.onTreeListCollapsedChange($event);
          });
          i0.ɵɵelementStart(5, "kendo-treelist", 4);
          i0.ɵɵlistener("filterChange", function GanttComponent_Template_kendo_treelist_filterChange_5_listener($event) {
            return ctx.filterChange.emit($event);
          })("sortChange", function GanttComponent_Template_kendo_treelist_sortChange_5_listener($event) {
            return ctx.sortChange.emit($event);
          })("dataStateChange", function GanttComponent_Template_kendo_treelist_dataStateChange_5_listener($event) {
            return ctx.dataStateChange.emit({
              filter: $event.filter,
              sort: $event.sort
            });
          })("expandStateChange", function GanttComponent_Template_kendo_treelist_expandStateChange_5_listener($event) {
            return ctx.expandStateChange.emit($event);
          })("expand", function GanttComponent_Template_kendo_treelist_expand_5_listener($event) {
            return ctx.rowExpand.emit({
              dataItem: $event.dataItem
            });
          })("collapse", function GanttComponent_Template_kendo_treelist_collapse_5_listener($event) {
            return ctx.rowCollapse.emit({
              dataItem: $event.dataItem
            });
          })("columnReorder", function GanttComponent_Template_kendo_treelist_columnReorder_5_listener($event) {
            return ctx.columnReorder.emit($event);
          })("columnResize", function GanttComponent_Template_kendo_treelist_columnResize_5_listener($event) {
            return ctx.columnResize.emit($event);
          })("columnVisibilityChange", function GanttComponent_Template_kendo_treelist_columnVisibilityChange_5_listener($event) {
            return ctx.handleColumnVisibilityChange($event);
          })("columnLockedChange", function GanttComponent_Template_kendo_treelist_columnLockedChange_5_listener($event) {
            return ctx.columnLockedChange.emit($event);
          })("selectionChange", function GanttComponent_Template_kendo_treelist_selectionChange_5_listener($event) {
            return ctx.handleTreeListSelectionChange($event);
          })("cellClick", function GanttComponent_Template_kendo_treelist_cellClick_5_listener($event) {
            return ctx.handleTreeListCellClick($event);
          })("cellClose", function GanttComponent_Template_kendo_treelist_cellClose_5_listener($event) {
            return ctx.handleCellClose($event);
          });
          i0.ɵɵelement(6, "kendo-treelist-messages", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "kendo-splitter-pane", 6);
          i0.ɵɵlistener("collapsedChange", function GanttComponent_Template_kendo_splitter_pane_collapsedChange_7_listener($event) {
            return ctx.onTimelineCollapsedChange($event);
          })("sizeChange", function GanttComponent_Template_kendo_splitter_pane_sizeChange_7_listener($event) {
            return ctx.onTimelinePaneSizeChange($event);
          });
          i0.ɵɵtemplate(8, GanttComponent_kendo_gantt_timeline_8_Template, 1, 25, "kendo-gantt-timeline", 7);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(9, GanttComponent_kendo_gantt_toolbar_9_Template, 1, 7, "kendo-gantt-toolbar", 8)(10, GanttComponent_kendo_gantt_edit_dialog_10_Template, 1, 1, "kendo-gantt-edit-dialog", 9)(11, GanttComponent_kendo_dialog_11_Template, 9, 7, "kendo-dialog", 10)(12, GanttComponent_div_12_Template, 1, 0, "div", 11);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showToolbar("top"));
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("border", 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("collapsible", ctx.treeListPaneOptions == null ? null : ctx.treeListPaneOptions.collapsible)("collapsed", ctx.treeListPaneOptions == null ? null : ctx.treeListPaneOptions.collapsed)("scrollable", false);
          i0.ɵɵadvance();
          i0.ɵɵproperty("idField", ctx.taskIdField)("columns", ctx.columns)("data", ctx.data)("hasChildren", ctx.hasChildren)("fetchChildren", ctx.fetchChildren)("navigable", ctx.navigable)("isExpanded", ctx.isExpanded)("autoSize", ctx.columnsAutoSize)("columnMenu", ctx.columnMenu)("reorderable", ctx.columnsReorderable)("resizable", ctx.columnsResizable)("rowClass", ctx.rowClass)("isSelected", ctx.isSelected)("selectable", ctx.selectable)("sortable", ctx.sortable)("sort", ctx.sort)("filterable", ctx.filterMenu)("filter", ctx.filter)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(76, _c15, ctx.handleTreeListDoubleClick))("scope", ctx);
          i0.ɵɵadvance();
          i0.ɵɵproperty("noRecords", ctx.getText("noRecords"))("filter", ctx.getText("filter"))("filterEqOperator", ctx.getText("filterEqOperator"))("filterNotEqOperator", ctx.getText("filterNotEqOperator"))("filterIsNullOperator", ctx.getText("filterIsNullOperator"))("filterIsNotNullOperator", ctx.getText("filterIsNotNullOperator"))("filterIsEmptyOperator", ctx.getText("filterIsEmptyOperator"))("filterIsNotEmptyOperator", ctx.getText("filterIsNotEmptyOperator"))("filterStartsWithOperator", ctx.getText("filterStartsWithOperator"))("filterContainsOperator", ctx.getText("filterContainsOperator"))("filterNotContainsOperator", ctx.getText("filterNotContainsOperator"))("filterEndsWithOperator", ctx.getText("filterEndsWithOperator"))("filterGteOperator", ctx.getText("filterGteOperator"))("filterGtOperator", ctx.getText("filterGtOperator"))("filterLteOperator", ctx.getText("filterLteOperator"))("filterLtOperator", ctx.getText("filterLtOperator"))("filterIsTrue", ctx.getText("filterIsTrue"))("filterIsFalse", ctx.getText("filterIsFalse"))("filterBooleanAll", ctx.getText("filterBooleanAll"))("filterAfterOrEqualOperator", ctx.getText("filterAfterOrEqualOperator"))("filterAfterOperator", ctx.getText("filterAfterOperator"))("filterBeforeOperator", ctx.getText("filterBeforeOperator"))("filterBeforeOrEqualOperator", ctx.getText("filterBeforeOrEqualOperator"))("filterFilterButton", ctx.getText("filterFilterButton"))("filterClearButton", ctx.getText("filterClearButton"))("filterAndLogic", ctx.getText("filterAndLogic"))("filterOrLogic", ctx.getText("filterOrLogic"))("loading", ctx.getText("loading"))("columnMenu", ctx.getText("columnMenu"))("columns", ctx.getText("columns"))("sortable", ctx.getText("sortable"))("sortAscending", ctx.getText("sortAscending"))("sortDescending", ctx.getText("sortDescending"))("sortedAscending", ctx.getText("sortedAscending"))("sortedDescending", ctx.getText("sortedDescending"))("sortedDefault", ctx.getText("sortedDefault"))("columnsApply", ctx.getText("columnsApply"))("columnsReset", ctx.getText("columnsReset"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("collapsible", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.collapsible)("resizable", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.resizable)("collapsed", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.collapsed)("min", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.min)("max", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.max)("size", ctx.timelinePaneOptions == null ? null : ctx.timelinePaneOptions.size)("scrollable", false);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.views && ctx.views.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showToolbar("bottom"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showEditingDialog);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showConfirmationDialog);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showLicenseWatermark);
        }
      },
      dependencies: [LocalizedMessagesDirective, NgIf, ToolbarComponent, SplitterComponent, SplitterPaneComponent, TreeListComponent, EventsOutsideAngularDirective, CustomMessagesComponent$2, GanttTimelineComponent, EditDialogComponent, DialogComponent, DialogActionsComponent, TreeListSpacerComponent, ButtonComponent, WatermarkOverlayComponent],
      encapsulation: 2
    });
  }
  return GanttComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A directive which binds the Gantt to an array of objects by using
 * an ID and parent ID field to define the hierarchy.
 *
 * The directive encapsulates the in-memory handling of data operations such as sorting and filtering.
 */
let GanttFlatBindingDirective = /*#__PURE__*/(() => {
  class GanttFlatBindingDirective extends FlatBindingDirective {
    /**
     * The array of data which will be used to populate the Gantt.
     */
    data;
    /**
     * @hidden
     */
    set aggregate(value) {
      super.aggregate = value;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵGanttFlatBindingDirective_BaseFactory;
      return function GanttFlatBindingDirective_Factory(__ngFactoryType__) {
        return (ɵGanttFlatBindingDirective_BaseFactory || (ɵGanttFlatBindingDirective_BaseFactory = i0.ɵɵgetInheritedFactory(GanttFlatBindingDirective)))(__ngFactoryType__ || GanttFlatBindingDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttFlatBindingDirective,
      selectors: [["", "kendoGanttFlatBinding", ""]],
      inputs: {
        data: [0, "kendoGanttFlatBinding", "data"]
      },
      exportAs: ["kendoGanttFlatBinding"],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return GanttFlatBindingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A directive which binds the Gantt to a tree of objects,
 * which encapsulates the in-memory handling of data operations such as sorting and filtering.
 */
let GanttHierarchyBindingDirective = /*#__PURE__*/(() => {
  class GanttHierarchyBindingDirective extends HierarchyBindingDirective {
    /**
     * The array of data which will be used to populate the Gantt.
     */
    data;
    /**
     * @hidden
     */
    set aggregate(value) {
      super.aggregate = value;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵGanttHierarchyBindingDirective_BaseFactory;
      return function GanttHierarchyBindingDirective_Factory(__ngFactoryType__) {
        return (ɵGanttHierarchyBindingDirective_BaseFactory || (ɵGanttHierarchyBindingDirective_BaseFactory = i0.ɵɵgetInheritedFactory(GanttHierarchyBindingDirective)))(__ngFactoryType__ || GanttHierarchyBindingDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttHierarchyBindingDirective,
      selectors: [["", "kendoGanttHierarchyBinding", ""]],
      inputs: {
        data: [0, "kendoGanttHierarchyBinding", "data"]
      },
      exportAs: ["kendoGanttHierarchyBinding"],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return GanttHierarchyBindingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A directive which controls the expanded state of the items.
 */
let GanttExpandableDirective = /*#__PURE__*/(() => {
  class GanttExpandableDirective extends ExpandableDirective {
    /**
     * Defines the item key that will be stored in the expandedKeys collection.
     * Defaults to the task data item ID field,
     * which is specified in the [`taskModelFields`]({% slug api_gantt_ganttcomponent %}#toc-taskmodelfields) object.
     *
     */
    set expandBy(value) {
      super.expandBy = value;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵGanttExpandableDirective_BaseFactory;
      return function GanttExpandableDirective_Factory(__ngFactoryType__) {
        return (ɵGanttExpandableDirective_BaseFactory || (ɵGanttExpandableDirective_BaseFactory = i0.ɵɵgetInheritedFactory(GanttExpandableDirective)))(__ngFactoryType__ || GanttExpandableDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: GanttExpandableDirective,
      selectors: [["", "kendoGanttExpandable", ""]],
      inputs: {
        expandBy: "expandBy"
      },
      exportAs: ["kendoGanttExpandable"],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return GanttExpandableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @hidden
 */
let DragValidationTooltipComponent = /*#__PURE__*/(() => {
  class DragValidationTooltipComponent {
    /**
     * Sets the status class of the attempted operation.
     * Note that the status will be ignored and the `neutral` status class will be rendered,
     * if the any of the fromTaskName or toTaskName are not populated.
     */
    isValid = false;
    /**
     * The name of the task where the dragging has started.
     */
    fromTaskName;
    /**
     * The name of the task which is being currently hovered.
     */
    toTaskName;
    /**
     * Specifies whether the valid/invalid validity classes should be rendered or not.
     * Prevents the validity classes being rendered when e.g. the same task is hovered during drag,
     * or when a task body is hovered and not an actual drag clue.
     */
    showValidityStatus;
    static ɵfac = function DragValidationTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DragValidationTooltipComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DragValidationTooltipComponent,
      selectors: [["ng-component"]],
      standalone: true,
      features: [i0.ɵɵStandaloneFeature],
      decls: 11,
      vars: 6,
      consts: [[1, "k-tooltip", "k-gantt-tooltip-validation"], [1, "k-gantt-tooltip-validation-row"], [1, "k-gantt-tooltip-validation-label"], [1, "k-gantt-tooltip-validation-value"]],
      template: function DragValidationTooltipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
          i0.ɵɵtext(3, "From:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "span", 3);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 1)(7, "span", 2);
          i0.ɵɵtext(8, "To:");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "span", 3);
          i0.ɵɵtext(10);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("k-gantt-tooltip-valid", ctx.showValidityStatus && ctx.isValid)("k-gantt-tooltip-invalid", ctx.showValidityStatus && !ctx.isValid);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(ctx.fromTaskName);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(ctx.toTaskName);
        }
      },
      encapsulation: 2
    });
  }
  return DragValidationTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * When added to the .k-task-dot, the element will be kept with hover styles.
 * Used for the drag clue from which the dragging has started.
 */
const DRAG_CLUE_HOVER_CLASS = 'k-hover';
/**
 * Add the selection disabling class to the enitre container.
 * Otherwise existing selection on a given task text prevents dragging the clue even if the clue has `user-select: none` styles.
 */
const USER_SELECT_NONE_CLASS = 'k-user-select-none';
/**
 * When added to the .k-task-wrap, the containing .k-task-dot elements will be kept visible even when not hovered.
 * Used for the drag clue from which the dragging has started.
 */
const TASK_WRAPPER_DRAG_CLASS = 'k-origin';
/**
 * Use 20px margin between the pointer and the popup.
 * Could be made user-configurable if there's demand.
 */
const DEFAULT_POPUP_VERTICAL_MARGIN = 20;
/**
 * A directive which enables the creation of new dependencies via dragging.
 */
let DependencyDragCreateDirective = /*#__PURE__*/(() => {
  class DependencyDragCreateDirective {
    gantt;
    zone;
    renderer;
    mapper;
    popupService;
    timelineScrollService;
    /**
     * Specifies whether the validation tooltip will be displayed during drag operations.
     *
     * @default true
     */
    displayValidationTooltip = true;
    get container() {
      if (!isPresent(this.gantt.timeline) || !isPresent(this.gantt.timeline.timelineContent)) {
        return null;
      }
      return this.gantt.timeline.timelineContent.nativeElement;
    }
    get polyline() {
      if (!isPresent(this.gantt.timeline) || !isPresent(this.gantt.timeline.dependencyDragCreatePolyline)) {
        return null;
      }
      return this.gantt.timeline.dependencyDragCreatePolyline.nativeElement;
    }
    get popupContainer() {
      if (!isPresent(this.gantt.timeline) || !isPresent(this.gantt.timeline.dragPopupContainer)) {
        return null;
      }
      return this.gantt.timeline.dragPopupContainer;
    }
    /**
     * Points to the drag clue where the dragging started (the FROM task).
     * Used to attach/detach classes to the target element and its task wrapper parent element.
     */
    fromTaskClue;
    /**
     * The drag start element coords will be the same through the enitre dragging session, so compute them on press and cache them.
     */
    polylineStartCoords;
    /**
     * Stored during dragging to be consumed by the container scroll subscription.
     * The scroll event doesn't expose the current pointer position, so it has to be stored separately.
     */
    currentPointerClientCoords;
    scrollListenerDisposer;
    dragPopup;
    dragSubscriptions;
    constructor(gantt, zone, renderer, mapper, popupService, timelineScrollService) {
      this.gantt = gantt;
      this.zone = zone;
      this.renderer = renderer;
      this.mapper = mapper;
      this.popupService = popupService;
      this.timelineScrollService = timelineScrollService;
      this.gantt.renderDependencyDragClues = true;
    }
    ngAfterViewInit() {
      this.subscribeDraggable();
      this.addScrollListener();
    }
    ngOnDestroy() {
      this.unsubscribeDraggable();
      this.removeScrollListener();
      this.fromTaskClue = null;
      this.cancelScroll();
      this.closeDragPopup();
    }
    subscribeDraggable() {
      this.dragSubscriptions = this.gantt.timeline.timelineContainerPress.subscribe(this.handlePress.bind(this));
      this.dragSubscriptions.add(this.gantt.timeline.timelineContainerDrag.subscribe(this.handleDrag.bind(this)));
      this.dragSubscriptions.add(this.gantt.timeline.timelineContainerRelease.subscribe(this.handleRelease.bind(this)));
    }
    unsubscribeDraggable() {
      if (isPresent(this.dragSubscriptions)) {
        this.dragSubscriptions.unsubscribe();
        this.dragSubscriptions = null;
      }
    }
    handlePress({
      clientX,
      clientY
    }) {
      // using `originalEvent.target` is not reliable under mobile devices with the current implementation of the draggable, so use this instead
      const target = elementFromPoint(clientX, clientY);
      if (isDependencyDragClue(target)) {
        this.fromTaskClue = target;
        this.assignDragStartClasses(this.fromTaskClue);
        // use the center of the target clue as polyline starting point
        const dragClueCenterCoords = getElementClientCenterCoords(this.fromTaskClue);
        // the polyline uses `position: aboslute`, so translate the client coordinates to offset coordinates (`left` and `top` relative to the timeline container)
        this.polylineStartCoords = clientToOffsetCoords(dragClueCenterCoords.left, dragClueCenterCoords.top, this.container);
      }
    }
    handleDrag({
      clientX,
      clientY
    }) {
      if (isPresent(this.fromTaskClue)) {
        // the polyline uses `position: aboslute`, so translate the client coordinates to offset coordinates (`left` and `top` relative to the timeline container)
        const pointerOffsetCoords = clientToOffsetCoords(clientX, clientY, this.container);
        // the start coords are calculated just once per drag session in handlePress
        // use the current drag coords as polyline end coords
        this.updatePolyline(this.polylineStartCoords, pointerOffsetCoords);
        this.currentPointerClientCoords = {
          left: clientX,
          top: clientY
        };
        if (this.gantt.dragScrollSettings.enabled) {
          // use client coordinates for scroll trigger
          this.scrollPointIntoView(this.currentPointerClientCoords);
        }
        if (this.displayValidationTooltip) {
          this.updateDragPopup(pointerOffsetCoords);
        }
      }
    }
    handleRelease({
      clientX,
      clientY
    }) {
      if (!isPresent(this.fromTaskClue)) {
        return;
      }
      // using `originalEvent.target` is not reliable under mobile devices with the current implementation of the draggable, so use this instead
      const target = elementFromPoint(clientX, clientY);
      if (isDependencyDragClue(target) && !sameTaskClues(this.fromTaskClue, target, this.container)) {
        this.zone.run(() => {
          const fromTaskClue = this.fromTaskClue;
          const toTaskClue = target;
          const fromTask = this.gantt.renderedTreeListItems[getClosestTaskIndex(fromTaskClue, this.container)];
          const toTask = this.gantt.renderedTreeListItems[getClosestTaskIndex(toTaskClue, this.container)];
          const dependencyType = getDependencyTypeFromTargetTasks(fromTaskClue, toTaskClue);
          const {
            fromId,
            toId,
            type
          } = this.mapper.dependencyFields;
          this.gantt.dependencyAdd.emit({
            fromTask: fromTask,
            toTask: toTask,
            type: dependencyType,
            isValid: this.gantt.validateNewDependency({
              [fromId]: this.mapper.extractFromTask(fromTask, 'id'),
              [toId]: this.mapper.extractFromTask(toTask, 'id'),
              [type]: dependencyType
            })
          });
        });
      }
      this.clearPolyline();
      this.removeDragStartClasses(this.fromTaskClue);
      this.fromTaskClue = null;
      this.cancelScroll();
      this.closeDragPopup();
    }
    updatePolyline(start, end) {
      const points = `${start.left},${start.top} ${end.left},${end.top}`;
      this.renderer.setAttribute(this.polyline, 'points', points);
    }
    clearPolyline() {
      this.renderer.removeAttribute(this.polyline, 'points');
    }
    assignDragStartClasses(dragClue) {
      if (!isPresent(dragClue)) {
        return;
      }
      this.renderer.addClass(this.container, USER_SELECT_NONE_CLASS);
      this.renderer.addClass(dragClue, DRAG_CLUE_HOVER_CLASS);
      const taskWrapper = getClosestTaskWrapper(dragClue, this.container);
      if (isPresent(taskWrapper)) {
        this.renderer.addClass(taskWrapper, TASK_WRAPPER_DRAG_CLASS);
      }
    }
    removeDragStartClasses(dragClue) {
      if (!isPresent(dragClue)) {
        return;
      }
      this.renderer.removeClass(this.container, USER_SELECT_NONE_CLASS);
      this.renderer.removeClass(dragClue, DRAG_CLUE_HOVER_CLASS);
      const taskWrapper = getClosestTaskWrapper(dragClue, this.container);
      if (isPresent(taskWrapper)) {
        this.renderer.removeClass(taskWrapper, TASK_WRAPPER_DRAG_CLASS);
      }
    }
    scrollPointIntoView({
      left,
      top
    }) {
      this.timelineScrollService.requestScrollCancel();
      this.timelineScrollService.requestHorizontalScroll(left);
      this.timelineScrollService.requestVerticalScroll(top);
    }
    cancelScroll() {
      this.timelineScrollService.requestScrollCancel();
    }
    addScrollListener() {
      if (!isDocumentAvailable()) {
        return;
      }
      this.zone.runOutsideAngular(() => this.scrollListenerDisposer = this.renderer.listen(this.container, 'scroll', () => {
        // update the polyline only if we're currently dragging
        if (isPresent(this.fromTaskClue) && isPresent(this.currentPointerClientCoords)) {
          const {
            left,
            top
          } = this.currentPointerClientCoords;
          const pointerOffsetCoords = clientToOffsetCoords(left, top, this.container);
          this.updatePolyline(this.polylineStartCoords, pointerOffsetCoords);
          if (this.displayValidationTooltip) {
            this.updateDragPopup(pointerOffsetCoords);
          }
        }
      }));
    }
    removeScrollListener() {
      if (isPresent(this.scrollListenerDisposer)) {
        this.scrollListenerDisposer();
        this.scrollListenerDisposer = null;
      }
    }
    openDragPopup() {
      if (isPresent(this.dragPopup)) {
        this.closeDragPopup();
      }
      this.dragPopup = this.popupService.open({
        animate: false,
        content: DragValidationTooltipComponent,
        appendTo: this.popupContainer,
        positionMode: 'absolute',
        popupClass: 'k-popup-transparent'
      });
    }
    updateDragPopup(pointerOffsetPosition) {
      if (!isPresent(this.dragPopup)) {
        this.openDragPopup();
      }
      const tooltip = this.dragPopup.content.instance;
      const {
        fromTaskName,
        toTaskName,
        isValid,
        showValidityStatus
      } = this.getTooltipContext();
      if (tooltip.fromTaskName !== fromTaskName || tooltip.toTaskName !== toTaskName || tooltip.isValid !== isValid || tooltip.showValidityStatus !== showValidityStatus) {
        tooltip.fromTaskName = fromTaskName;
        tooltip.toTaskName = toTaskName;
        tooltip.isValid = isValid;
        tooltip.showValidityStatus = showValidityStatus;
        this.dragPopup.content.changeDetectorRef.detectChanges();
      }
      this.dragPopup.popup.instance.offset = this.normalizePopupPosition(pointerOffsetPosition);
      this.dragPopup.popup.changeDetectorRef.detectChanges();
    }
    closeDragPopup() {
      if (isPresent(this.dragPopup)) {
        this.dragPopup.close();
        this.dragPopup = null;
      }
    }
    extractTaskName(target) {
      if (!isTaskWrapper(target, this.container)) {
        return null;
      }
      const taskIndex = getClosestTaskIndex(target, this.container);
      const task = this.gantt.renderedTreeListItems[taskIndex];
      const taskName = this.mapper.extractFromTask(task, 'title');
      return taskName;
    }
    getTooltipContext() {
      const fromTaskName = this.extractTaskName(this.fromTaskClue);
      const currentPointerTarget = elementFromPoint(this.currentPointerClientCoords.left, this.currentPointerClientCoords.top);
      const toTaskName = isTaskWrapper(currentPointerTarget, this.container) && !sameTaskClues(this.fromTaskClue, currentPointerTarget, this.container) ? this.extractTaskName(currentPointerTarget) : '';
      const showValidityStatus = isDependencyDragClue(currentPointerTarget) && !sameTaskClues(this.fromTaskClue, currentPointerTarget, this.container);
      const {
        fromId,
        toId,
        type
      } = this.mapper.dependencyFields;
      return {
        fromTaskName,
        toTaskName,
        showValidityStatus,
        isValid: showValidityStatus && this.gantt.validateNewDependency({
          [fromId]: this.mapper.extractFromTask(this.gantt.renderedTreeListItems[getClosestTaskIndex(this.fromTaskClue, this.container)], 'id'),
          [toId]: this.mapper.extractFromTask(this.gantt.renderedTreeListItems[getClosestTaskIndex(currentPointerTarget, this.container)], 'id'),
          [type]: getDependencyTypeFromTargetTasks(this.fromTaskClue, currentPointerTarget)
        })
      };
    }
    /**
     * Restricts the popup position to not go below the scroll height or width of the container.
     * Flips the position of the popup when there's not enough vertical space in the visible part of the container to render the popup.
     */
    normalizePopupPosition(pointerOffsetPosition) {
      let top = pointerOffsetPosition.top + DEFAULT_POPUP_VERTICAL_MARGIN;
      const containerClientBottom = this.container.clientHeight + this.container.scrollTop;
      const popupHeight = this.dragPopup.popupElement.querySelector('.k-tooltip').clientHeight;
      const enoughSpaceToRender = top < containerClientBottom - popupHeight;
      // flip the popup above the pointer if there's not enough space in the bottom of the container
      if (!enoughSpaceToRender) {
        // margin * 2 to account for the already applied margin
        top -= popupHeight + DEFAULT_POPUP_VERTICAL_MARGIN * 2;
      }
      // center the popup horizontally according to the pointer position
      const popupWidth = this.dragPopup.popupElement.querySelector('.k-tooltip').clientWidth;
      const left = pointerOffsetPosition.left - popupWidth / 2;
      // don't allow the popup to be cut out of the viewport
      const minLeftTop = 0;
      // restrict the popup from being positioned beyond or before the available scrollable space
      return {
        left: fitToRange(left, minLeftTop, this.container.scrollWidth - popupWidth),
        top: fitToRange(top, minLeftTop, this.container.scrollHeight - popupHeight)
      };
    }
    static ɵfac = function DependencyDragCreateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DependencyDragCreateDirective)(i0.ɵɵdirectiveInject(GanttComponent), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(i3.PopupService), i0.ɵɵdirectiveInject(TimelineScrollService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DependencyDragCreateDirective,
      selectors: [["", "kendoGanttDependencyDragCreate", ""]],
      inputs: {
        displayValidationTooltip: "displayValidationTooltip"
      },
      standalone: true
    });
  }
  return DependencyDragCreateDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Gantt timeline day view component.
 */
let TimelineDayViewComponent = /*#__PURE__*/(() => {
  class TimelineDayViewComponent extends ViewBase {
    /**
     * The type for this view (`day`).
     */
    type = 'day';
    constructor(optionChangesService, dependencyDomService) {
      super(optionChangesService, dependencyDomService);
    }
    static ɵfac = function TimelineDayViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineDayViewComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimelineDayViewComponent,
      selectors: [["kendo-gantt-timeline-day-view"]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: ViewBase,
        useExisting: forwardRef(() => TimelineDayViewComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function TimelineDayViewComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return TimelineDayViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Gantt timeline week view component.
 */
let TimelineWeekViewComponent = /*#__PURE__*/(() => {
  class TimelineWeekViewComponent extends ViewBase {
    /**
     * The type for this view (`week`).
     */
    type = 'week';
    constructor(optionChangesService, dependencyDomService) {
      super(optionChangesService, dependencyDomService);
    }
    static ɵfac = function TimelineWeekViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineWeekViewComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimelineWeekViewComponent,
      selectors: [["kendo-gantt-timeline-week-view"]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: ViewBase,
        useExisting: forwardRef(() => TimelineWeekViewComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function TimelineWeekViewComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return TimelineWeekViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Gantt timeline month view component.
 */
let TimelineMonthViewComponent = /*#__PURE__*/(() => {
  class TimelineMonthViewComponent extends ViewBase {
    /**
     * The type for this view (`month`).
     */
    type = 'month';
    constructor(optionChangesService, dependencyDomService) {
      super(optionChangesService, dependencyDomService);
    }
    static ɵfac = function TimelineMonthViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineMonthViewComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimelineMonthViewComponent,
      selectors: [["kendo-gantt-timeline-month-view"]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: ViewBase,
        useExisting: forwardRef(() => TimelineMonthViewComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function TimelineMonthViewComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return TimelineMonthViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The Gantt timeline year view component.
 */
let TimelineYearViewComponent = /*#__PURE__*/(() => {
  class TimelineYearViewComponent extends ViewBase {
    /**
     * The type for this view (`year`).
     */
    type = 'year';
    constructor(optionChangesService, dependencyDomService) {
      super(optionChangesService, dependencyDomService);
    }
    static ɵfac = function TimelineYearViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TimelineYearViewComponent)(i0.ɵɵdirectiveInject(OptionChangesService), i0.ɵɵdirectiveInject(DependencyDomService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimelineYearViewComponent,
      selectors: [["kendo-gantt-timeline-year-view"]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: ViewBase,
        useExisting: forwardRef(() => TimelineYearViewComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function TimelineYearViewComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return TimelineYearViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A directive which handles the [`selectionChange`]({% slug api_gantt_ganttcomponent %}#toc-selectionchange) event of the Gantt
 * ([see example]({% slug selection_gantt %}#toc-built-in-directive))
 */
let SelectableDirective = /*#__PURE__*/(() => {
  class SelectableDirective {
    gantt;
    /**
     * @hidden
     */
    set selectable(value) {
      if (value) {
        this.gantt.isSelected = this.isSelected;
        this.subscribeSelection();
      } else {
        this.gantt.isSelected = () => false;
        this.unsubscribeSelection();
      }
      this.gantt.selectable = value;
      this.gantt.updateView();
    }
    /**
     * Sets the selected keys.
     */
    set selectedKeys(value) {
      if (isPresent(value) && value === this.lastChange) {
        return;
      }
      // prevent multiple items displayed as selected as multiple selection still not supported fully
      const keys = (value || []).slice(0, 1);
      this.state = new Set(keys);
      this.gantt.updateView();
    }
    /**
     * Fires when the selected keys are changed.
     */
    selectedKeysChange = new EventEmitter();
    /**
     * The field name or a function that specifies the data item unique key identifier.
     * By default, the string field `id` is used.
     */
    set itemKey(value) {
      if (isString(value)) {
        this._keyGetter = getter(value);
      } else {
        this._keyGetter = value;
      }
    }
    get keyGetter() {
      return this._keyGetter || this.gantt.idGetter;
    }
    selectionSubscription;
    state = new Set();
    lastChange;
    _keyGetter;
    constructor(gantt) {
      this.gantt = gantt;
      this.isSelected = this.isSelected.bind(this);
      this.selectionChange = this.selectionChange.bind(this);
      this.selectable = true;
    }
    ngOnDestroy() {
      this.unsubscribeSelection();
    }
    isSelected(dataItem) {
      return this.state.has(this.keyGetter(dataItem));
    }
    selectionChange({
      action,
      items
    }) {
      this.state.clear();
      if (action === 'select') {
        items.forEach(item => this.state.add(this.keyGetter(item)));
      }
      this.emitSelectedItemsChange();
    }
    emitSelectedItemsChange() {
      this.lastChange = Array.from(this.state);
      this.selectedKeysChange.emit(this.lastChange);
    }
    subscribeSelection() {
      this.unsubscribeSelection();
      this.selectionSubscription = this.gantt.selectionChange.subscribe(this.selectionChange);
    }
    unsubscribeSelection() {
      if (this.selectionSubscription) {
        this.selectionSubscription.unsubscribe();
        this.selectionSubscription = null;
      }
    }
    static ɵfac = function SelectableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectableDirective)(i0.ɵɵdirectiveInject(GanttComponent));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SelectableDirective,
      selectors: [["", "kendoGanttSelectable", ""]],
      inputs: {
        selectable: "selectable",
        selectedKeys: "selectedKeys",
        itemKey: "itemKey"
      },
      outputs: {
        selectedKeysChange: "selectedKeysChange"
      },
      exportAs: ["kendoGanttSelectable"],
      standalone: true
    });
  }
  return SelectableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Custom component messages override default component messages
 * ([see example](slug:globalization_treelist#toc-custom-messages)).
 */
let CustomMessagesComponent = /*#__PURE__*/(() => {
  class CustomMessagesComponent extends Messages {
    service;
    constructor(service) {
      super();
      this.service = service;
    }
    get override() {
      return true;
    }
    static ɵfac = function CustomMessagesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomMessagesComponent)(i0.ɵɵdirectiveInject(i1$1.LocalizationService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CustomMessagesComponent,
      selectors: [["kendo-gantt-messages"]],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: Messages,
        useExisting: forwardRef(() => CustomMessagesComponent)
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function CustomMessagesComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return CustomMessagesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TaskDragDirective = /*#__PURE__*/(() => {
  class TaskDragDirective {
    /**
     * Emitted while the end user is resizing or moving a task through dragging.
     */
    taskDrag = new EventEmitter();
    /**
     * Triggered when the dragging action associated with resizing or moving an event is finished.
     * The event data contains all necessary information to update the task and all related tasks
     * accordingly.
     */
    taskDragEnd = new EventEmitter();
    subs = new Subscription();
    constructor(gantt, mapper, dragTargetContainer, taskDragService) {
      dragTargetContainer.mode = 'manual';
      dragTargetContainer.dragTargetFilter = '.k-resize-handle, .k-task, .k-task-draghandle';
      dragTargetContainer.cursorStyle = null;
      dragTargetContainer.threshold = 5;
      this.subs.add(dragTargetContainer.onDragStart.subscribe(args => {
        taskDragService.onDragStart(args);
      }));
      this.subs.add(dragTargetContainer.onDrag.subscribe(args => {
        taskDragService.onDrag(args);
      }));
      this.subs.add(dragTargetContainer.onDragEnd.subscribe(args => {
        taskDragService.onDragEnd(args);
      }));
      this.subs.add(taskDragService.drag.subscribe(args => {
        hasObservers(this.taskDrag) && this.taskDrag.emit({
          start: args.start,
          end: args.end,
          completionRatio: args.completionRatio,
          item: getEditItem(args.item, gantt.treeList.view.data, mapper),
          dragEvent: args.dragEvent
        });
      }));
      this.subs.add(taskDragService.dragEnd.subscribe(args => {
        hasObservers(this.taskDragEnd) && this.taskDragEnd.emit({
          start: args.start,
          end: args.end,
          completionRatio: args.completionRatio,
          item: getEditItem(args.item, gantt.treeList.view.data, mapper),
          dragEvent: args.dragEvent
        });
      }));
    }
    ngOnDestroy() {
      this.subs.unsubscribe();
    }
    static ɵfac = function TaskDragDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TaskDragDirective)(i0.ɵɵdirectiveInject(GanttComponent), i0.ɵɵdirectiveInject(MappingService), i0.ɵɵdirectiveInject(i3$1.DragTargetContainerDirective), i0.ɵɵdirectiveInject(TaskDragService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TaskDragDirective,
      selectors: [["", "kendoGanttTaskDrag", ""]],
      outputs: {
        taskDrag: "taskDrag",
        taskDragEnd: "taskDragEnd"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([TaskDragService]), i0.ɵɵHostDirectivesFeature([i3$1.DragTargetContainerDirective])]
    });
  }
  return TaskDragDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
* Utility array that contains all `@progress/kendo-angular-gantt` related components and directives
*/
const KENDO_GANTT = [GanttComponent, GanttFlatBindingDirective, GanttHierarchyBindingDirective, GanttTaskContentTemplateDirective, GanttTaskTemplateDirective, GanttSummaryTaskTemplateDirective, ToolbarTemplateDirective, ViewSelectorComponent, GanttColumnComponent, GanttColumnGroupComponent, GanttSpanColumnComponent, FilterCellTemplateDirective, FilterMenuTemplateDirective, CellTemplateDirective, EditTemplateDirective, ColumnMenuTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, GanttExpandableDirective, DependencyDragCreateDirective, TimelineDayViewComponent, TimelineWeekViewComponent, TimelineMonthViewComponent, TimelineYearViewComponent, SelectableDirective, CustomMessagesComponent, GanttAddTaskComponent, TaskDragDirective, GanttTaskTooltipTemplateDirective];

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Represents the [NgModule](link:site.data.urls.angular['ngmoduleapi'])
 * definition for the Gantt component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Gantt module
 * import { GanttModule } from '@progress/kendo-angular-gantt';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, GanttModule], // import Gantt module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
let GanttModule = /*#__PURE__*/(() => {
  class GanttModule {
    static ɵfac = function GanttModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GanttModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GanttModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: L10N_PREFIX,
        useValue: 'kendo.gantt'
      },
      // InputsModule providers
      IconsService, PopupService, ResizeBatchService, DialogContainerService, DialogService, WindowService, WindowContainerService,
      // DateInputsModule providers
      CalendarDOMService, CenturyViewService, DecadeViewService, MonthViewService, YearViewService, NavigationService$1, TimePickerDOMService, HoursService, MinutesService, SecondsService, MillisecondsService, DayPeriodService,
      // TreeListModule providers
      ColumnResizingService],
      imports: [GanttComponent, ViewSelectorComponent, GanttAddTaskComponent]
    });
  }
  return GanttModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CellCloseEvent, CellTemplateDirective, ColumnMenuTemplateDirective, CustomMessagesComponent, DependenciesTableComponent, DependencyDragCreateDirective, DependencyType, DragValidationTooltipComponent, EditDialogComponent, EditTemplateDirective, FilterCellTemplateDirective, FilterMenuTemplateDirective, FooterTemplateDirective, GanttAddTaskComponent, GanttColumnBase, GanttColumnComponent, GanttColumnGroupComponent, GanttComponent, GanttDependencyDirective, GanttExpandableDirective, GanttFlatBindingDirective, GanttHeaderTableBodyComponent, GanttHierarchyBindingDirective, GanttMilestoneTaskComponent, GanttModule, GanttSpanColumnComponent, GanttSummaryTaskComponent, GanttSummaryTaskTemplateDirective, GanttTaskComponent, GanttTaskContentTemplateDirective, GanttTaskTemplateDirective, GanttTaskTooltipTemplateDirective, GanttTasksTableBodyComponent, GanttTimelineComponent, HeaderTemplateDirective, KENDO_GANTT, LocalizedMessagesDirective, SelectableDirective, TaskDragDirective, TaskFieldsComponent, TimelineDayViewComponent, TimelineMonthViewComponent, TimelineScrollableDirective, TimelineWeekViewComponent, TimelineYearViewComponent, ToolbarComponent, ToolbarTemplateDirective, ViewSelectorComponent };